$(() => {
  (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
  // require dependencies
  const SVGtoPDF = require('svg-to-pdfkit');

  PDFDocument.prototype.addSVG = function(svg, x, y, options) {
    return SVGtoPDF(this, svg, x, y, options), this;
  };

  var pdfjsLib = window['pdfjs-dist/build/pdf'];

  var carbon_pattern = '<pattern patternTransform="scale(1, -1)" y="34.289" width="70" height="70" patternUnits="userSpaceOnUse" id="p1" viewBox="3.508 -77.004 70 70" overflow="visible"><g><polygon fill="none" points="3.508,-77.004 73.508,-77.004 73.508,-7.004 3.508,-7.004 		"/><g><defs><rect id="SVGID_1_" x="3.508" y="-77.004" width="70" height="70"/></defs><clipPath id="SVGID_2_"><use xlink:href="#SVGID_1_"  overflow="visible"/></clipPath><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74041.0625 77632)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_3_)" points="59.5,-73.5 59.5,-84 56,-84 56,-73.5 			"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48990.5078 -63057.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_4_)" points="63,-77 70,-77 70,-80.5 63,-80.5 			"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74037.5625 77635.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_5_)" points="63,-70 63,-80.5 59.5,-80.5 59.5,-70 			"/><linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48987.0078 -63054.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_6_)" points="66.5,-73.5 73.5,-73.5 73.5,-77 66.5,-77 			"/><linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74034.0625 77639)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_7_)" points="66.5,-66.5 66.5,-77 63,-77 63,-66.5 			"/><linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48983.5078 -63050.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_8_)" points="70,-70 77,-70 77,-73.5 70,-73.5 			"/><linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74030.5625 77642.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_9_)" points="70,-63 70,-73.5 66.5,-73.5 66.5,-63 			"/><linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48980.0078 -63047.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_10_)" points="73.5,-66.5 80.5,-66.5 80.5,-70 73.5,-70 			"/><linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74027.0625 77646)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_11_)" points="73.5,-59.5 73.5,-70 70,-70 70,-59.5 			"/><linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74058.5625 77632)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_12_)" points="42,-73.5 42,-84 38.5,-84 38.5,-73.5 			"/><linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49008.0078 -63057.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_13_)" points="45.5,-77 52.5,-77 52.5,-80.5 45.5,-80.5 			"/><linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74055.0625 77635.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_14_)" points="45.5,-70 45.5,-80.5 42,-80.5 42,-70 			"/><linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49004.5078 -63054.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_15_)" points="49,-73.5 56,-73.5 56,-77 49,-77 			"/><linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74051.5625 77639)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_16_)" points="49,-66.5 49,-77 45.5,-77 45.5,-66.5 			"/><linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49001.0078 -63050.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_17_)" points="52.5,-70 59.5,-70 59.5,-73.5 52.5,-73.5 			"/><linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74048.0625 77642.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_18_)" points="52.5,-63 52.5,-73.5 49,-73.5 49,-63 			"/><linearGradient id="SVGID_19_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48997.5078 -63047.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_19_)" points="56,-66.5 63,-66.5 63,-70 56,-70 			"/><linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74044.5625 77646)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_20_)" points="56,-59.5 56,-70 52.5,-70 52.5,-59.5 			"/><linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48994.0078 -63043.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_21_)" points="59.5,-63 66.5,-63 66.5,-66.5 59.5,-66.5 			"/><linearGradient id="SVGID_22_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74041.0625 77649.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_22_)" points="59.5,-56 59.5,-66.5 56,-66.5 56,-56 			"/><linearGradient id="SVGID_23_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48990.5078 -63040.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_23_)" points="63,-59.5 70,-59.5 70,-63 63,-63 			"/><linearGradient id="SVGID_24_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74037.5625 77653)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_24_)" points="63,-52.5 63,-63 59.5,-63 59.5,-52.5 			"/><linearGradient id="SVGID_25_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48987.0078 -63036.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_25_)" points="66.5,-56 73.5,-56 73.5,-59.5 66.5,-59.5 			"/><linearGradient id="SVGID_26_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74034.0625 77656.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_26_)" points="66.5,-49 66.5,-59.5 63,-59.5 63,-49 			"/><linearGradient id="SVGID_27_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48983.5078 -63033.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_27_)" points="70,-52.5 77,-52.5 77,-56 70,-56 			"/><linearGradient id="SVGID_28_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74030.5625 77660)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_28_)" points="70,-45.5 70,-56 66.5,-56 66.5,-45.5 			"/><linearGradient id="SVGID_29_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48980.0078 -63029.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_29_)" points="73.5,-49 80.5,-49 80.5,-52.5 73.5,-52.5 			"/><linearGradient id="SVGID_30_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74027.0625 77663.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_30_)" points="73.5,-42 73.5,-52.5 70,-52.5 70,-42 			"/><linearGradient id="SVGID_31_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74076.0625 77632)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_31_)" points="24.5,-73.5 24.5,-84 21,-84 21,-73.5 			"/><linearGradient id="SVGID_32_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49025.5078 -63057.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_32_)" points="28,-77 35,-77 35,-80.5 28,-80.5 			"/><linearGradient id="SVGID_33_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74072.5625 77635.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_33_)" points="28,-70 28,-80.5 24.5,-80.5 24.5,-70 			"/><linearGradient id="SVGID_34_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49022.0078 -63054.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_34_)" points="31.5,-73.5 38.5,-73.5 38.5,-77 31.5,-77 			"/><linearGradient id="SVGID_35_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74069.0625 77639)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_35_)" points="31.5,-66.5 31.5,-77 28,-77 28,-66.5 			"/><linearGradient id="SVGID_36_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49018.5078 -63050.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_36_)" points="35,-70 42,-70 42,-73.5 35,-73.5 			"/><linearGradient id="SVGID_37_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74065.5625 77642.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_37_)" points="35,-63 35,-73.5 31.5,-73.5 31.5,-63 			"/><linearGradient id="SVGID_38_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49015.0078 -63047.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_38_)" points="38.5,-66.5 45.5,-66.5 45.5,-70 38.5,-70 			"/><linearGradient id="SVGID_39_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74062.0625 77646)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_39_)" points="38.5,-59.5 38.5,-70 35,-70 35,-59.5 			"/><linearGradient id="SVGID_40_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49011.5078 -63043.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_40_)" points="42,-63 49,-63 49,-66.5 42,-66.5 			"/><linearGradient id="SVGID_41_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74058.5625 77649.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_41_)" points="42,-56 42,-66.5 38.5,-66.5 38.5,-56 			"/><linearGradient id="SVGID_42_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49008.0078 -63040.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_42_)" points="45.5,-59.5 52.5,-59.5 52.5,-63 45.5,-63 			"/><linearGradient id="SVGID_43_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74055.0625 77653)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_43_)" points="45.5,-52.5 45.5,-63 42,-63 42,-52.5 			"/><linearGradient id="SVGID_44_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49004.5078 -63036.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_44_)" points="49,-56 56,-56 56,-59.5 49,-59.5 			"/><linearGradient id="SVGID_45_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74051.5625 77656.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_45_)" points="49,-49 49,-59.5 45.5,-59.5 45.5,-49 			"/><linearGradient id="SVGID_46_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49001.0078 -63033.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_46_)" points="52.5,-52.5 59.5,-52.5 59.5,-56 52.5,-56 			"/><linearGradient id="SVGID_47_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74048.0625 77660)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_47_)" points="52.5,-45.5 52.5,-56 49,-56 49,-45.5 			"/><linearGradient id="SVGID_48_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48997.5078 -63029.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_48_)" points="56,-49 63,-49 63,-52.5 56,-52.5 			"/><linearGradient id="SVGID_49_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74044.5625 77663.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_49_)" points="56,-42 56,-52.5 52.5,-52.5 52.5,-42 			"/><linearGradient id="SVGID_50_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48994.0078 -63026.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_50_)" points="59.5,-45.5 66.5,-45.5 66.5,-49 59.5,-49 			"/><linearGradient id="SVGID_51_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74041.0625 77667)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_51_)" points="59.5,-38.5 59.5,-49 56,-49 56,-38.5 			"/><linearGradient id="SVGID_52_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48990.5078 -63022.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_52_)" points="63,-42 70,-42 70,-45.5 63,-45.5 			"/><linearGradient id="SVGID_53_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74037.5625 77670.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_53_)" points="63,-35 63,-45.5 59.5,-45.5 59.5,-35 			"/><linearGradient id="SVGID_54_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48987.0078 -63019.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_54_)" points="66.5,-38.5 73.5,-38.5 73.5,-42 66.5,-42 			"/><linearGradient id="SVGID_55_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74034.0625 77674)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_55_)" points="66.5,-31.5 66.5,-42 63,-42 63,-31.5 			"/><linearGradient id="SVGID_56_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48983.5078 -63015.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_56_)" points="70,-35 77,-35 77,-38.5 70,-38.5 			"/><linearGradient id="SVGID_57_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74030.5625 77677.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_57_)" points="70,-28 70,-38.5 66.5,-38.5 66.5,-28 			"/><linearGradient id="SVGID_58_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48980.0078 -63012.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_58_)" points="73.5,-31.5 80.5,-31.5 80.5,-35 73.5,-35 			"/><linearGradient id="SVGID_59_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74027.0625 77681)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_59_)" points="73.5,-24.5 73.5,-35 70,-35 70,-24.5 			"/><linearGradient id="SVGID_60_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74093.5625 77632)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_60_)" points="7,-73.5 7,-84 3.5,-84 3.5,-73.5 			"/><linearGradient id="SVGID_61_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49043.0078 -63057.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_61_)" points="10.5,-77 17.5,-77 17.5,-80.5 10.5,-80.5 			"/><linearGradient id="SVGID_62_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74090.0625 77635.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_62_)" points="10.5,-70 10.5,-80.5 7,-80.5 7,-70 			"/><linearGradient id="SVGID_63_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49039.5078 -63054.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_63_)" points="14,-73.5 21,-73.5 21,-77 14,-77 			"/><linearGradient id="SVGID_64_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74086.5625 77639)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_64_)" points="14,-66.5 14,-77 10.5,-77 10.5,-66.5 			"/><linearGradient id="SVGID_65_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49036.0078 -63050.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_65_)" points="17.5,-70 24.5,-70 24.5,-73.5 17.5,-73.5 			"/><linearGradient id="SVGID_66_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74083.0625 77642.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_66_)" points="17.5,-63 17.5,-73.5 14,-73.5 14,-63 			"/><linearGradient id="SVGID_67_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49032.5078 -63047.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_67_)" points="21,-66.5 28,-66.5 28,-70 21,-70 			"/><linearGradient id="SVGID_68_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74079.5625 77646)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_68_)" points="21,-59.5 21,-70 17.5,-70 17.5,-59.5 			"/><linearGradient id="SVGID_69_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49029.0078 -63043.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_69_)" points="24.5,-63 31.5,-63 31.5,-66.5 24.5,-66.5 			"/><linearGradient id="SVGID_70_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74076.0625 77649.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_70_)" points="24.5,-56 24.5,-66.5 21,-66.5 21,-56 			"/><linearGradient id="SVGID_71_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49025.5078 -63040.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_71_)" points="28,-59.5 35,-59.5 35,-63 28,-63 			"/><linearGradient id="SVGID_72_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74072.5625 77653)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_72_)" points="28,-52.5 28,-63 24.5,-63 24.5,-52.5 			"/><linearGradient id="SVGID_73_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49022.0078 -63036.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_73_)" points="31.5,-56 38.5,-56 38.5,-59.5 31.5,-59.5 			"/><linearGradient id="SVGID_74_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74069.0625 77656.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_74_)" points="31.5,-49 31.5,-59.5 28,-59.5 28,-49 			"/><linearGradient id="SVGID_75_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49018.5078 -63033.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_75_)" points="35,-52.5 42,-52.5 42,-56 35,-56 			"/><linearGradient id="SVGID_76_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74065.5625 77660)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_76_)" points="35,-45.5 35,-56 31.5,-56 31.5,-45.5 			"/><linearGradient id="SVGID_77_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49015.0078 -63029.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_77_)" points="38.5,-49 45.5,-49 45.5,-52.5 38.5,-52.5 			"/><linearGradient id="SVGID_78_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74062.0625 77663.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_78_)" points="38.5,-42 38.5,-52.5 35,-52.5 35,-42 			"/><linearGradient id="SVGID_79_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49011.5078 -63026.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_79_)" points="42,-45.5 49,-45.5 49,-49 42,-49 			"/><linearGradient id="SVGID_80_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74058.5625 77667)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_80_)" points="42,-38.5 42,-49 38.5,-49 38.5,-38.5 			"/><linearGradient id="SVGID_81_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49008.0078 -63022.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_81_)" points="45.5,-42 52.5,-42 52.5,-45.5 45.5,-45.5 			"/><linearGradient id="SVGID_82_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74055.0625 77670.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_82_)" points="45.5,-35 45.5,-45.5 42,-45.5 42,-35 			"/><linearGradient id="SVGID_83_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49004.5078 -63019.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_83_)" points="49,-38.5 56,-38.5 56,-42 49,-42 			"/><linearGradient id="SVGID_84_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74051.5625 77674)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_84_)" points="49,-31.5 49,-42 45.5,-42 45.5,-31.5 			"/><linearGradient id="SVGID_85_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49001.0078 -63015.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_85_)" points="52.5,-35 59.5,-35 59.5,-38.5 52.5,-38.5 			"/><linearGradient id="SVGID_86_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74048.0625 77677.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_86_)" points="52.5,-28 52.5,-38.5 49,-38.5 49,-28 			"/><linearGradient id="SVGID_87_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48997.5078 -63012.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_87_)" points="56,-31.5 63,-31.5 63,-35 56,-35 			"/><linearGradient id="SVGID_88_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74044.5625 77681)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_88_)" points="56,-24.5 56,-35 52.5,-35 52.5,-24.5 			"/><linearGradient id="SVGID_89_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48994.0078 -63008.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_89_)" points="59.5,-28 66.5,-28 66.5,-31.5 59.5,-31.5 			"/><linearGradient id="SVGID_90_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74041.0625 77684.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_90_)" points="59.5,-21 59.5,-31.5 56,-31.5 56,-21 			"/><linearGradient id="SVGID_91_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48990.5078 -63005.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_91_)" points="63,-24.5 70,-24.5 70,-28 63,-28 			"/><linearGradient id="SVGID_92_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74037.5625 77688)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_92_)" points="63,-17.5 63,-28 59.5,-28 59.5,-17.5 			"/><linearGradient id="SVGID_93_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48987.0078 -63001.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_93_)" points="66.5,-21 73.5,-21 73.5,-24.5 66.5,-24.5 			"/><linearGradient id="SVGID_94_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74034.0625 77691.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_94_)" points="66.5,-14 66.5,-24.5 63,-24.5 63,-14 			"/><linearGradient id="SVGID_95_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48983.5078 -62998.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_95_)" points="70,-17.5 77,-17.5 77,-21 70,-21 			"/><linearGradient id="SVGID_96_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74030.5625 77695)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_96_)" points="70,-10.5 70,-21 66.5,-21 66.5,-10.5 			"/><linearGradient id="SVGID_97_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48980.0078 -62994.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_97_)" points="73.5,-14 80.5,-14 80.5,-17.5 73.5,-17.5 			"/><linearGradient id="SVGID_98_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74027.0625 77698.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_98_)" points="73.5,-7 73.5,-17.5 70,-17.5 70,-7 			"/><linearGradient id="SVGID_99_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49053.5078 -63050.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_99_)" points="0,-70 7,-70 7,-73.5 0,-73.5 			"/><linearGradient id="SVGID_100_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49050.0078 -63047.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_100_)" points="3.5,-66.5 10.5,-66.5 10.5,-70 3.5,-70 			"/><linearGradient id="SVGID_101_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49046.5078 -63043.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_101_)" points="7,-63 14,-63 14,-66.5 7,-66.5 			"/><linearGradient id="SVGID_102_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74093.5625 77649.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_102_)" points="7,-56 7,-66.5 3.5,-66.5 3.5,-56 			"/><linearGradient id="SVGID_103_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49043.0078 -63040.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_103_)" points="10.5,-59.5 17.5,-59.5 17.5,-63 10.5,-63 			"/><linearGradient id="SVGID_104_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74090.0625 77653)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_104_)" points="10.5,-52.5 10.5,-63 7,-63 7,-52.5 			"/><linearGradient id="SVGID_105_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49039.5078 -63036.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_105_)" points="14,-56 21,-56 21,-59.5 14,-59.5 			"/><linearGradient id="SVGID_106_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74086.5625 77656.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_106_)" points="14,-49 14,-59.5 10.5,-59.5 10.5,-49 			"/><linearGradient id="SVGID_107_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49036.0078 -63033.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_107_)" points="17.5,-52.5 24.5,-52.5 24.5,-56 17.5,-56 			"/><linearGradient id="SVGID_108_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74083.0625 77660)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_108_)" points="17.5,-45.5 17.5,-56 14,-56 14,-45.5 			"/><linearGradient id="SVGID_109_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49032.5078 -63029.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_109_)" points="21,-49 28,-49 28,-52.5 21,-52.5 			"/><linearGradient id="SVGID_110_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74079.5625 77663.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_110_)" points="21,-42 21,-52.5 17.5,-52.5 17.5,-42 			"/><linearGradient id="SVGID_111_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49029.0078 -63026.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_111_)" points="24.5,-45.5 31.5,-45.5 31.5,-49 24.5,-49 			"/><linearGradient id="SVGID_112_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74076.0625 77667)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_112_)" points="24.5,-38.5 24.5,-49 21,-49 21,-38.5 			"/><linearGradient id="SVGID_113_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49025.5078 -63022.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_113_)" points="28,-42 35,-42 35,-45.5 28,-45.5 			"/><linearGradient id="SVGID_114_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74072.5625 77670.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_114_)" points="28,-35 28,-45.5 24.5,-45.5 24.5,-35 			"/><linearGradient id="SVGID_115_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49022.0078 -63019.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_115_)" points="31.5,-38.5 38.5,-38.5 38.5,-42 31.5,-42 			"/><linearGradient id="SVGID_116_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74069.0625 77674)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_116_)" points="31.5,-31.5 31.5,-42 28,-42 28,-31.5 			"/><linearGradient id="SVGID_117_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49018.5078 -63015.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_117_)" points="35,-35 42,-35 42,-38.5 35,-38.5 			"/><linearGradient id="SVGID_118_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74065.5625 77677.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_118_)" points="35,-28 35,-38.5 31.5,-38.5 31.5,-28 			"/><linearGradient id="SVGID_119_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49015.0078 -63012.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_119_)" points="38.5,-31.5 45.5,-31.5 45.5,-35 38.5,-35 			"/><linearGradient id="SVGID_120_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74062.0625 77681)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_120_)" points="38.5,-24.5 38.5,-35 35,-35 35,-24.5 			"/><linearGradient id="SVGID_121_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49011.5078 -63008.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_121_)" points="42,-28 49,-28 49,-31.5 42,-31.5 			"/><linearGradient id="SVGID_122_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74058.5625 77684.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_122_)" points="42,-21 42,-31.5 38.5,-31.5 38.5,-21 			"/><linearGradient id="SVGID_123_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49008.0078 -63005.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_123_)" points="45.5,-24.5 52.5,-24.5 52.5,-28 45.5,-28 			"/><linearGradient id="SVGID_124_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74055.0625 77688)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_124_)" points="45.5,-17.5 45.5,-28 42,-28 42,-17.5 			"/><linearGradient id="SVGID_125_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49004.5078 -63001.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_125_)" points="49,-21 56,-21 56,-24.5 49,-24.5 			"/><linearGradient id="SVGID_126_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74051.5625 77691.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_126_)" points="49,-14 49,-24.5 45.5,-24.5 45.5,-14 			"/><linearGradient id="SVGID_127_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49001.0078 -62998.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_127_)" points="52.5,-17.5 59.5,-17.5 59.5,-21 52.5,-21 			"/><linearGradient id="SVGID_128_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74048.0625 77695)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_128_)" points="52.5,-10.5 52.5,-21 49,-21 49,-10.5 			"/><linearGradient id="SVGID_129_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48997.5078 -62994.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_129_)" points="56,-14 63,-14 63,-17.5 56,-17.5 			"/><linearGradient id="SVGID_130_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74044.5625 77698.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_130_)" points="56,-7 56,-17.5 52.5,-17.5 52.5,-7 			"/><linearGradient id="SVGID_131_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -48994.0078 -62991.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_131_)" points="59.5,-10.5 66.5,-10.5 66.5,-14 59.5,-14 			"/><linearGradient id="SVGID_132_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74041.0625 77702)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_132_)" points="59.5,-3.5 59.5,-14 56,-14 56,-3.5 			"/><linearGradient id="SVGID_133_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -48990.5078 -62987.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_133_)" points="63,-7 70,-7 70,-10.5 63,-10.5 			"/><linearGradient id="SVGID_134_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74037.5625 77705.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_134_)" points="63,0 63,-10.5 59.5,-10.5 59.5,0 			"/><linearGradient id="SVGID_135_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49053.5078 -63033.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_135_)" points="0,-52.5 7,-52.5 7,-56 0,-56 			"/><linearGradient id="SVGID_136_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49050.0078 -63029.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_136_)" points="3.5,-49 10.5,-49 10.5,-52.5 3.5,-52.5 			"/><linearGradient id="SVGID_137_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49046.5078 -63026.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_137_)" points="7,-45.5 14,-45.5 14,-49 7,-49 			"/><linearGradient id="SVGID_138_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74093.5625 77667)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_138_)" points="7,-38.5 7,-49 3.5,-49 3.5,-38.5 			"/><linearGradient id="SVGID_139_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49043.0078 -63022.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_139_)" points="10.5,-42 17.5,-42 17.5,-45.5 10.5,-45.5 			"/><linearGradient id="SVGID_140_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74090.0625 77670.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_140_)" points="10.5,-35 10.5,-45.5 7,-45.5 7,-35 			"/><linearGradient id="SVGID_141_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49039.5078 -63019.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_141_)" points="14,-38.5 21,-38.5 21,-42 14,-42 			"/><linearGradient id="SVGID_142_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74086.5625 77674)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_142_)" points="14,-31.5 14,-42 10.5,-42 10.5,-31.5 			"/><linearGradient id="SVGID_143_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49036.0078 -63015.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_143_)" points="17.5,-35 24.5,-35 24.5,-38.5 17.5,-38.5 			"/><linearGradient id="SVGID_144_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74083.0625 77677.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_144_)" points="17.5,-28 17.5,-38.5 14,-38.5 14,-28 			"/><linearGradient id="SVGID_145_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49032.5078 -63012.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_145_)" points="21,-31.5 28,-31.5 28,-35 21,-35 			"/><linearGradient id="SVGID_146_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74079.5625 77681)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_146_)" points="21,-24.5 21,-35 17.5,-35 17.5,-24.5 			"/><linearGradient id="SVGID_147_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49029.0078 -63008.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_147_)" points="24.5,-28 31.5,-28 31.5,-31.5 24.5,-31.5 			"/><linearGradient id="SVGID_148_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74076.0625 77684.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_148_)" points="24.5,-21 24.5,-31.5 21,-31.5 21,-21 			"/><linearGradient id="SVGID_149_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49025.5078 -63005.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_149_)" points="28,-24.5 35,-24.5 35,-28 28,-28 			"/><linearGradient id="SVGID_150_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74072.5625 77688)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_150_)" points="28,-17.5 28,-28 24.5,-28 24.5,-17.5 			"/><linearGradient id="SVGID_151_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49022.0078 -63001.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_151_)" points="31.5,-21 38.5,-21 38.5,-24.5 31.5,-24.5 			"/><linearGradient id="SVGID_152_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74069.0625 77691.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_152_)" points="31.5,-14 31.5,-24.5 28,-24.5 28,-14 			"/><linearGradient id="SVGID_153_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49018.5078 -62998.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_153_)" points="35,-17.5 42,-17.5 42,-21 35,-21 			"/><linearGradient id="SVGID_154_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74065.5625 77695)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_154_)" points="35,-10.5 35,-21 31.5,-21 31.5,-10.5 			"/><linearGradient id="SVGID_155_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49015.0078 -62994.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_155_)" points="38.5,-14 45.5,-14 45.5,-17.5 38.5,-17.5 			"/><linearGradient id="SVGID_156_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74062.0625 77698.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_156_)" points="38.5,-7 38.5,-17.5 35,-17.5 35,-7 			"/><linearGradient id="SVGID_157_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49011.5078 -62991.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_157_)" points="42,-10.5 49,-10.5 49,-14 42,-14 			"/><linearGradient id="SVGID_158_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6426" x2="7401.5239" y2="-7393.6426" gradientTransform="matrix(0 -10.5 -10.022 0 -74058.5625 77702)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_158_)" points="42,-3.5 42,-14 38.5,-14 38.5,-3.5 			"/><linearGradient id="SVGID_159_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49008.0078 -62987.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_159_)" points="45.5,-7 52.5,-7 52.5,-10.5 45.5,-10.5 			"/><linearGradient id="SVGID_160_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74055.0625 77705.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_160_)" points="45.5,0 45.5,-10.5 42,-10.5 42,0 			"/><linearGradient id="SVGID_161_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49053.5078 -63015.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_161_)" points="0,-35 7,-35 7,-38.5 0,-38.5 			"/><linearGradient id="SVGID_162_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49050.0078 -63012.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_162_)" points="3.5,-31.5 10.5,-31.5 10.5,-35 3.5,-35 			"/><linearGradient id="SVGID_163_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49046.5078 -63008.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_163_)" points="7,-28 14,-28 14,-31.5 7,-31.5 			"/><linearGradient id="SVGID_164_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74093.5625 77684.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_164_)" points="7,-21 7,-31.5 3.5,-31.5 3.5,-21 			"/><linearGradient id="SVGID_165_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49043.0078 -63005.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_165_)" points="10.5,-24.5 17.5,-24.5 17.5,-28 10.5,-28 			"/><linearGradient id="SVGID_166_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74090.0625 77688)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_166_)" points="10.5,-17.5 10.5,-28 7,-28 7,-17.5 			"/><linearGradient id="SVGID_167_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49039.5078 -63001.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_167_)" points="14,-21 21,-21 21,-24.5 14,-24.5 			"/><linearGradient id="SVGID_168_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74086.5625 77691.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_168_)" points="14,-14 14,-24.5 10.5,-24.5 10.5,-14 			"/><linearGradient id="SVGID_169_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49036.0078 -62998.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_169_)" points="17.5,-17.5 24.5,-17.5 24.5,-21 17.5,-21 			"/><linearGradient id="SVGID_170_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74083.0625 77695)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_170_)" points="17.5,-10.5 17.5,-21 14,-21 14,-10.5 			"/><linearGradient id="SVGID_171_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49032.5078 -62994.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_171_)" points="21,-14 28,-14 28,-17.5 21,-17.5 			"/><linearGradient id="SVGID_172_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74079.5625 77698.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_172_)" points="21,-7 21,-17.5 17.5,-17.5 17.5,-7 			"/><linearGradient id="SVGID_173_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49029.0078 -62991.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_173_)" points="24.5,-10.5 31.5,-10.5 31.5,-14 24.5,-14 			"/><linearGradient id="SVGID_174_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74076.0625 77702)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_174_)" points="24.5,-3.5 24.5,-14 21,-14 21,-3.5 			"/><linearGradient id="SVGID_175_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49025.5078 -62987.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_175_)" points="28,-7 35,-7 35,-10.5 28,-10.5 			"/><linearGradient id="SVGID_176_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74072.5625 77705.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_176_)" points="28,0 28,-10.5 24.5,-10.5 24.5,0 			"/><linearGradient id="SVGID_177_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49053.5078 -62998.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_177_)" points="0,-17.5 7,-17.5 7,-21 0,-21 			"/><linearGradient id="SVGID_178_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49050.0078 -62994.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_178_)" points="3.5,-14 10.5,-14 10.5,-17.5 3.5,-17.5 			"/><linearGradient id="SVGID_179_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.127" x2="7008.6436" y2="-9426.127" gradientTransform="matrix(7 0 0 -6.6813 -49046.5078 -62991.1172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_179_)" points="7,-10.5 14,-10.5 14,-14 7,-14 			"/><linearGradient id="SVGID_180_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6416" x2="7401.5239" y2="-7393.6416" gradientTransform="matrix(0 -10.5 -10.022 0 -74093.5625 77702)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_180_)" points="7,-3.5 7,-14 3.5,-14 3.5,-3.5 			"/><linearGradient id="SVGID_181_" gradientUnits="userSpaceOnUse" x1="7007.6436" y1="-9426.126" x2="7008.6436" y2="-9426.126" gradientTransform="matrix(7 0 0 -6.6813 -49043.0078 -62987.6172)"><stop  offset="0" style="stop-color:#555655"/><stop  offset="0.2426" style="stop-color:#4E4F4E"/><stop  offset="0.6936" style="stop-color:#3D3E3D"/><stop  offset="1" style="stop-color:#31312F"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_181_)" points="10.5,-7 17.5,-7 17.5,-10.5 10.5,-10.5 			"/><linearGradient id="SVGID_182_" gradientUnits="userSpaceOnUse" x1="7400.5239" y1="-7393.6421" x2="7401.5239" y2="-7393.6421" gradientTransform="matrix(0 -10.5 -10.022 0 -74090.0625 77705.5)"><stop  offset="0" style="stop-color:#A7A5A5"/><stop  offset="1" style="stop-color:#1C1C1C"/></linearGradient><polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_182_)" points="10.5,0 10.5,-10.5 7,-10.5 7,0 			"/></g></g></pattern>';

  var plate_builder = {
    pb: {},
    displays: {},
    variant_id: "12994878013504",
    render_tasks: {},
    loading: {
      "front": false, 
      "back": false
    },
    settings: {
      dpi: 72,
      bleed: 0.2,
      border_radius: 10,
      default_colour: "#040005",
      default_offset_colour: "#6d6e71",
      images_to_load: 0,
      default_text: "ENTER REG",
      default_line_break: 4,
      faces: ["front","back"],
      tint: false,
      bg_chosen: false,
      badge_filters: ["legal","bike","car","flags","misc","sport"],
      generator_url: "https://srt9s3r4lc.execute-api.us-east-2.amazonaws.com/generator/generate",
      default_display: {
        generic: {
          font: {
            url: 'https://cdn.shopify.com/s/files/1/0015/3976/8384/files/LaserCharlesWright.otf?v=1633468762',
            name: 'Standard'           
          }   
        },
        bsau_font: {
          url: 'https://cdn.shopify.com/s/files/1/0015/3976/8384/files/helv-test.otf?v=1633463482',
          name: 'Helvetica'
        },        
        front: {
          bg_colour: '#d7d7d7'
        },
        back: {
          bg_colour: '#ffc72c'
        }
      }
    },
    stored_options: {
      badges: {
        left: {},
        right: {}
      }
    },
    pdf_data: {
      front: "",
      back: ""
    },
    display_params: {
      front: {},
      back: {},
      generic: {
        loaded_images: {}
      }
    }, 
    selectors: {
      plate_options: {
        faces: "#plateSelect",
        reg: "#reg",
        type: "input:radio[name ='plateType']"
      },
      line_break: {
        front: {
          active: "#frontMultiLine",
          break_on: "#frontMultiLineSplit"
        },
        back: {
          active: "#backMultiLine",
          break_on: "#backMultiLineSplit"
        }      
      },
      sizes: {
        back: "#backSize",
        front: "#frontSize"
      },
      colours: {
        main: "#font-colour",
        main_outline: "#font-outline-colour",
        badge_left: "#badge-left-colour",
        badge_right: "#badge-right-colour",
        border: "#border-colour",
        slogan: "#slogan-colour",
        background: "#background-colour"
      },
      fonts: {
        registration: "#plate-fonts",
        slogan: "#slogan-fonts"
      },
      badges: {
        left: "#badges-left",
        right: "#badges-right"
      },
      slogans: {
        text: "#slogan",
        left_image: "#slogan-images-left",
        right_image: "#slogan-images-right"
      },
      border: {
        border_type: "#borderSettings"
      },
      background: {
        images: "#plate-background"
      },
      display: {
        front: "#front_display",
        back: "#back_display"
      }
    },
    init: function(){
      var _this = this;

      var reg = "";


      if(typeof pb !== "undefined"){
        _this.pb = pb;

        if(location.href.indexOf("licence") > -1){
          reg = location.href.split("?")[1].split("=")[1];      
          reg = decodeURIComponent(reg).replace("+"," ");
          $("#reg").val(reg);
        }          

        _this.generateInputs();
        _this.startSliders();
        _this.setListeners();    

        _this.displays.front = {};
        _this.displays.back = {};
        _this.updatePrice();
        _this.refreshParams(); 

        _this.applyBadgeFilter("legal", "#badges-left");    
        _this.applyBadgeFilter("legal", "#badges-right");    

      }else{
        console.log('no template settings');
      }
    },
    rgb2hex: function(rgb) {
        if (/^#[0-9A-F]{6}$/i.test(rgb)) return rgb;

        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    },  
    setListeners: function(){
      var _this = this;

      $(".plate-builder__preview, img").contextmenu(function(e){
        e.preventDefault();
      });

      $('.pb-tab').on('click',function(){
        $('.pb-tab').parent().removeClass('plate-builder__tabs__tab--active');
        $(this).parent().addClass('plate-builder__tabs__tab--active');
        var tab_name = $(this).attr('data-tab');
        _this.changeTab(tab_name);
      });

      $(".picker:not(.picker--custom)").on('click',function(){
        $(this).parent().parent().find('.picker').removeClass('picker--active');
        $(this).addClass('picker--active');
        _this.refreshParams();
      });

      $("#border-colour .picker").on('click',function(){
        $('#no-border').prop('checked', false);
      });

      $(".badge-item").on('click',function(){
        $(this).closest('.block__categories').find('.badge-item').removeClass('active');
        $(this).closest(".block").find("input[type='checkbox']").prop("checked", false);
        $(this).addClass('active');
        _this.refreshParams();
      });  

      $('#leftBadgeRemove').on('click',function(){
        $("#badges-left").find('.badge-item').removeClass('active');
        _this.stored_options.badges.left = {}; 
        _this.refreshParams();
      });  

      $('#rightBadgeRemove').on('click',function(){
        $("#badges-right").find('.badge-item').removeClass('active');
        _this.stored_options.badges.right = {}; 
        _this.refreshParams();
      });    

      $('#leftSloganRemove').on('click',function(){
        $("#slogan-images-left").find('.slogan-item').removeClass('active');
        _this.refreshParams();
      });  

      $('#rightSloganRemove').on('click',function(){
        $("#slogan-images-right").find('.slogan-item').removeClass('active');
        _this.refreshParams();
      });    

      $(".badge-filter").on('click',function(){
        var filter = $(this).attr('data-filter');
        var filter_for = "#" + $(this).closest(".block__categories-nav").attr("data-filter");
        $(this).parent().find('.badge-filter').removeClass('active');
        $(this).addClass('active');

        _this.applyBadgeFilter(filter, filter_for);
      });   

      $('.background-item').on('click', function(){
        $(this).closest(_this.selectors.background.images).find('img').removeClass('active');
        $(this).find('img').addClass('active');  
        _this.refreshParams();
      });

      $('.font-item').on('click', function(){
        $(this).parent().parent().find('.font-item').removeClass('active');
        $(this).addClass('active');   
        _this.refreshParams();
      });

      $('.slogan-item').on('click', function(){
        $(this).parent().parent().find('.slogan-item').removeClass('active');
        $(this).addClass('active');   
        _this.refreshParams();
      });  

      $('.form-control, #reg, #slogan').on('click, change',function(){
        _this.refreshParams();
      });

      $(_this.selectors.border.border_type).on('change',function(){
        _this.refreshParams();
      });  

      $("#frontMultiLine, #frontMultiLineSplit, #backMultiLine, #backMultiLineSplit").on('change',function(){
        _this.refreshParams();
      }); 

      $('#no-left-background').on('click',function(){
        $("#badge-left-colour").find('.picker--active').removeClass('picker--active');           
        _this.refreshParams();
      });

      $('#no-right-background').on('click',function(){
        $("#badge-right-colour").find('.picker--active').removeClass('picker--active');
        _this.refreshParams();
      });  

      $('#no-outline').on('click',function(){
        $(_this.selectors.colours.main_outline).find('.picker--active').removeClass('picker--active');
        _this.refreshParams();
      });

      $('#no-border').on('click',function(){
        $(_this.selectors.colours.border).find('.picker--active').removeClass('picker--active');
        _this.refreshParams();
      });  

      $("#carbon").on('change',function(){
        if($(this).prop('checked') === true){
          $("#font-colour").find('.picker').removeClass('picker--active');
          _this.refreshParams();
        }else{
          $("#font-colour").find('.picker').first().click();
        }
      });

      $("#font-colour .picker").on("click", function(){
        $("#carbon").prop('checked', false);
      });  

      $('.picker-col .picker:not(.picker--custom)').on('click', function(){
        $(this).closest('.picker-col').find('.picker--custom').removeClass('picker--active').css('background-color', 'transparent');
      });

      $('input[type="color"]').on('change', function(){
        var col = $(this).val();
        $(this).closest('.picker-col').find('.picker').removeClass('picker--active');
        $(this).closest('.picker-col').find('.picker--custom').addClass('picker--active').css('background-color', col);
        setTimeout(function(){
          _this.refreshParams();
        },500);
      });

      $(".plate-builder__legend__actions__button.atc").on("click", function(){      
        _this.addPlates();
      });

      $("#britishStandard").on("click", function(){
        _this.refreshParams();
      });  

      $('input[name="plateType"]').on("change", function(){
        _this.selectVariant();
      });      

      $("#background-colour .picker").on("click", function(){
        _this.settings.bg_chosen = true;
      });    

      $("#no-background-image").on("click", function(){
        $("#plate-background").find(".active").removeClass("active");
        _this.refreshParams();
      });

      $("#no-background-colour").on("click", function(){
        $("#background-colour").find('.picker').removeClass('picker--active');
        _this.settings.bg_chosen = false;
        _this.refreshParams();
      }); 

      $(_this.selectors.plate_options.faces).on("change", function(){
        _this.selectVariant();
        _this.refreshParams();
      });
    },
    selectVariant: function(){
      var _this = this;
      var opt_1 = $('input[name="plateType"]:checked').val();
      var sides = $('#plateSelect').val();
      var variant = opt_1 + sides;

      switch(variant) {
        case 'normalfront-back':
            _this.variant_id = "12994878013504";
            _this.settings.tint = false;
            break;
        case 'normalfront':
            _this.variant_id = "13017994264640";
            _this.settings.tint = false;
            break;
        case 'normalback':
            _this.variant_id = "13017994362944";
            _this.settings.tint = false;
            break;
        case 'tintedfront-back':
            _this.variant_id = "13017994461248";
            _this.settings.tint = true;
            break;
        case 'tintedfront':
            _this.variant_id = "13017994559552";
            _this.settings.tint = true;
            break;
        case 'tintedback':
            _this.variant_id = "13017994690624";
            _this.settings.tint = true;
            break;
        case 'stickOnfront-back':
            _this.variant_id = "18058407018560";
            _this.settings.tint = false;
            break;
        case 'stickOnfront':
            _this.variant_id = "18058446274624";
            _this.settings.tint = false;
            break;
        case 'stickOnback':
            _this.variant_id = "18058457186368";
            _this.settings.tint = false;
            break;
        case 'stickOnTintedfront-back':
            _this.variant_id = "18061851525184";
            _this.settings.tint = true;
            break;
        case 'stickOnTintedfront':
            _this.variant_id = "18061800669248";
            _this.settings.tint = true;
            break;
        case 'stickOnTintedback':
            _this.variant_id = "18061768032320";
            _this.settings.tint = true;
            break;
        case 'gelfront-back':
            _this.variant_id = "18654526799936";
            _this.settings.tint = false;
            break;
        case 'gelfront':
            _this.variant_id = "18654445076544";
            _this.settings.tint = false;
            break;
        case 'gelback':
            _this.variant_id = "18654579359808";
            _this.settings.tint = false;
            break;
        case 'gelTintedfront-back':
            _this.variant_id = "18654457200704";
            _this.settings.tint = true;
            break;
        case 'gelTintedfront':
            _this.variant_id = "18654417846336";
            _this.settings.tint = true;
            break;
        case 'gelTintedback':
            _this.variant_id = "18654314102848";
            _this.settings.tint = true;
            break;       
      } 

      _this.updatePrice();
      _this.refreshParams();

    },
    updatePrice: function(){
      var _this = this;
      if(product_json){
        var v_id = parseInt(_this.variant_id);
        for(var v in product_json.variants){
          var variant = product_json.variants[v];
          if(v_id === variant.id){
            var price = "TOTAL: £" + parseFloat(variant.price) / 100;
            $(".plate-builder__legend__actions__totals").text(price);
          }
        }
      }
    },
    applyBadgeFilter: function(filter_name, filter_target){
      var _this = this;
      var filter_selector = "."+filter_name;

      $(filter_target).slick('slickUnfilter');
      $(filter_target).slick('slickFilter',filter_selector);
      $(filter_target).slick("refresh");
    },
    setDisplaySize: function(){
      var _this = this;
      for(var f in _this.settings.faces){
        var n = _this.settings.faces[f];
        var r = $(_this.selectors.display[n]).width() / _this.display_params[n].size.width;
        var h = (_this.display_params[n].size.height * r) + "px";
        $(_this.selectors.display[n]).attr('height', h);
      }        
    },
    startSliders: function(){
      var _this = this;

      var slider_properties = {
        infinite: true,
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 3,
        adaptiveHeight: true
      }    

      $(_this.selectors.badges.left).slick(slider_properties);
      $(_this.selectors.badges.right).slick(slider_properties);

      $(_this.selectors.fonts.registration).slick(slider_properties);  
      $(_this.selectors.fonts.slogan).slick(slider_properties);

      $(_this.selectors.slogans.left_image).slick(slider_properties);    
      $(_this.selectors.slogans.right_image).slick(slider_properties);

      if(_this.pb.backgrounds.length > 3){
        $(_this.selectors.background.images).slick(slider_properties);  
      }

    },
    changeTab: function(tab_name){
      var _this = this;
      $('.pb-section').hide();
      switch(tab_name) {
        case 'pb-reg':
          $('#pb-reg').show();
          break;        
        case 'pb-size':
          $('#pb-size').show();
          break;
        case 'pb-text':
          $('#pb-text').show();
          $(_this.selectors.fonts.registration).slick("refresh"); 
          break;
        case 'pb-badges':
          $('#pb-badges').show();
          $(_this.selectors.badges.left).slick("refresh");
          $(_this.selectors.badges.right).slick("refresh");        
          break;
        case 'pb-border':
          $('#pb-border').show();
          break;
        case 'pb-slogan':
          $('#pb-slogan').show();
          $(_this.selectors.fonts.slogan).slick("refresh");
          $(_this.selectors.slogans.left_image).slick("refresh");    
          $(_this.selectors.slogans.right_image).slick("refresh");        
          break;
        case 'pb-background':
          $('#pb-background').show();
          $(_this.selectors.background.images).slick("refresh");
          break;        
      } 
    },
    loadImage: function(url){
      var _this = this;       

      return new Promise(resolve => {
        var img = {};
        img.xhr = new XMLHttpRequest();
        img.xhr.onreadystatechange = function() {    
          if (this.readyState == 4 && this.status == 200) {
            return resolve(this.response);
          }    
        };
        img.xhr.responseType = 'arraybuffer';
        img.xhr.open('GET', url);
        img.xhr.send(null);     
      });  

    },
    loadFont: function(url){
      var _this = this; 

      return new Promise(resolve => {
        var img = {};
        img.xhr = new XMLHttpRequest();
        img.xhr.onreadystatechange = function() {    
          if (this.readyState == 4 && this.status == 200) {
            return resolve(this.response);
          }    
        };
        img.xhr.responseType = 'arraybuffer';
        img.xhr.open('GET', url);
        img.xhr.send(null);     
      });   
    },
    loadSVGTextFromURL: function(url){
      return new Promise(resolve => {
        $.ajax({
            type: "GET",
            url: url,
            dataType: "xml",
            success: function(svg) {
              var svgText = $(svg).find('svg')[0].outerHTML;
              return resolve(svgText);
            }
        });    
      });
    },
    showLoading: function(){
      $('.loading-cover').css({"pointer-events": "all", "opacity": 1}); 
    },
    hideLoading: function(){
      var _this = this;
      if(_this.loading.front === false && _this.loading.back === false){
        $('.loading-cover').css({"pointer-events": "none", "opacity": 0});
      }    
    },
    generateInputs: function(){
      var _this = this;
      console.log(this,'this')
      /* Sizes */
      var front_size_html = "";
      var back_size_html = "";
      var class_string = "";
      for(var s in _this.pb.sizes){
        var size = _this.pb.sizes[s];
        if(size.face === "both" || size.face === "front"){
          front_size_html += "<option value='"+s+"'>"+size.display+"</option>";
        }
        if(size.face === "both" || size.face === "back"){
          back_size_html += "<option value='"+s+"'>"+size.display+"</option>";
        }      
      }
      $(_this.selectors.sizes.front).html(front_size_html);
      $(_this.selectors.sizes.back).html(back_size_html);

      /* Fonts */
      var font_html = "";
      var hel_is_special = "";
      for(var f in _this.pb.fonts){
        var font = _this.pb.fonts[f];
        if(font.name === "Helvetica"){
          hel_is_special = "<div class='font-item font-"+font.name.replace(/\s/g,"-")+"' data-font='"+f+"'><img src='"+font.font_img+"' alt='"+font.display+"'></div>";
        }else{
          font_html += "<div class='font-item font-"+font.name.replace(/\s/g,"-")+"' data-font='"+f+"'><img src='"+font.font_img+"' alt='"+font.display+"'></div>";
        }      
      }

      $(_this.selectors.fonts.registration).html(font_html+hel_is_special); 
      $(_this.selectors.fonts.slogan).html(hel_is_special+font_html); 

      $('.font-item').first().addClass("active");
      $("#slogan-fonts .font-item.font-Standard-3D").remove();
      $("#slogan-fonts .font-item.font-Standard-Inline").remove();
      $("#slogan-fonts .font-item").first().addClass("active");


      /* Badges */
      var badge_html = "";
      for(var b_type in _this.pb.badges){
        for(var b in _this.pb.badges[b_type]){
          badge_html += "<div class='badge-item "+b_type+"' ><img data-lazy='"+_this.pb.badges[b_type][b]+"'></div>";         
        }   
      }
      $(_this.selectors.badges.left).html(badge_html);
      $(_this.selectors.badges.right).html(badge_html);

      /* Slogans */
      var slogan_html = "";
      for(var s in _this.pb.slogans){
        var slogan = _this.pb.slogans[s];
        slogan_html += "<div class='slogan-item'><img data-lazy='"+slogan+"'></div>";      
      }
      $(_this.selectors.slogans.left_image).html(slogan_html);
      $(_this.selectors.slogans.right_image).html(slogan_html);

      /* Backgrounds */  
      var background_html = "";
      for(var b in _this.pb.backgrounds){
        var background = _this.pb.backgrounds[b];
        background_html += "<div class='background-item'><img data-image='"+b+"' data-url='"+background.url+"' src='"+background.display_img+"'></div>";      
      }
      $(_this.selectors.background.images).html(background_html); 

      /* BSAU */    
      $("#bs_display").text(_this.pb.bsau.display);
      $("#britishStandard").prop("checked", true);
    },
    refreshParams: async function(){
      var _this = this;

      var selectors = _this.selectors;
      var images_to_load = {};

      _this.showLoading();

      $(".loading-stage").text("Gathering Plate Data");

      /* generic */
      var generic = {};

      /* Registration */
      if($(_this.selectors.plate_options.reg).val() !== ''){
        generic.registration = $(_this.selectors.plate_options.reg).val();
      }else{
        generic.registration = _this.settings.default_text;
      }

      /* background */
      generic.bg = {};
      if($(_this.selectors.background.images+' .active').length > 0){      
        generic.bg.bg_index = parseInt($(_this.selectors.background.images+' .active').attr('data-image'));
        generic.bg.image = _this.pb.backgrounds[generic.bg.bg_index];      

        try{
          generic.bg.image.img_data = await _this.loadSVGTextFromURL(generic.bg.image.url);
        }catch(e){
          console.log(e);
          generic.bg.image.img_data = "nodata";
        }       
      }    

      /* colours */
      generic.colours = {};
      for(var s in _this.selectors.colours){
        var selector = _this.selectors.colours[s];
        var c = $(selector).find('.picker--active');
        var col = c.css('background-color');
        if(c.length > 0){
          generic.colours[s] = _this.rgb2hex(col);
        }else{
          generic.colours[s] = 'default';
        }
      }

      if($("#carbon").prop('checked') === true){
        generic.colours.carbon = true;
      }else{
        generic.colours.carbon = false;
      }    

      /* fonts */
      generic.fonts = {};
      var f_url = '';

      generic.fonts.registration = {};
      if($(_this.selectors.fonts.registration+' .active').length > 0){
        var f_index = parseInt($(_this.selectors.fonts.registration+' .active').attr('data-font'));
        var f = _this.pb.fonts[f_index]
        generic.fonts.registration = f;
        try{
          generic.fonts.registration.data = await _this.loadFont(f.url);
        }catch(e){
          console.log(e);
          generic.fonts.registration.data = "nodata";
        }  
      }else{
        var f = _this.pb.fonts[0]
        generic.fonts.registration = f;
        try{
          generic.fonts.registration.data = await _this.loadFont(f.url);
        }catch(e){
          console.log(e);
          generic.fonts.registration.data = "nodata";
        }    
      } 

      generic.fonts.slogan = {};
      if($(_this.selectors.fonts.slogan+' .active').length > 0){
        var f_index = parseInt($(_this.selectors.fonts.slogan+' .active').attr('data-font'));
        var f = _this.pb.fonts[f_index]
        generic.fonts.slogan = f;
        try{
          generic.fonts.slogan.data = await _this.loadFont(f.url);
        }catch(e){
          console.log(e);
          generic.fonts.slogan.data = "nodata";
        }  
      }else{
        var f = _this.pb.fonts[0]
        generic.fonts.slogan = f;
        try{
          generic.fonts.slogan.data = await _this.loadFont(f.url);
        }catch(e){
          console.log(e);
          generic.fonts.slogan.data = "nodata";
        }    
      }     

      generic.fonts.base = {};
      generic.fonts.base.name = _this.settings.default_display.generic.font.name;
      try{
        generic.fonts.base.data = await _this.loadFont(_this.settings.default_display.generic.font.url);
      }catch(e){
        console.log(e);
        generic.fonts.base.data = "nodata";
      }   

      generic.fonts.bsau = {};
      generic.fonts.bsau.name = _this.settings.default_display.bsau_font.name;
      try{
        generic.fonts.bsau.data = await _this.loadFont(_this.settings.default_display.bsau_font.url);
      }catch(e){
        console.log(e);
        generic.fonts.bsau.data = "nodata";
      }     

      /* text options */
      generic.text_options = {};

      generic.text_options.front = {}
      generic.text_options.front.multiline = $(_this.selectors.line_break.front.active).prop('checked');
      if($(_this.selectors.line_break.front.break_on).val() !== ""){
        generic.text_options.front.linebreak = $(_this.selectors.line_break.front.break_on).val();
      }else{
        generic.text_options.front.linebreak = _this.settings.default_line_break;
      }

      generic.text_options.back = {};
      generic.text_options.back.multiline = $(_this.selectors.line_break.back.active).prop('checked');
      if($(_this.selectors.line_break.back.break_on).val() !== ""){
        generic.text_options.back.linebreak = $(_this.selectors.line_break.back.break_on).val();
      }else{
        generic.text_options.back.linebreak = _this.settings.default_line_break;
      }

      /* badges */ 
      generic.badges = {};
      generic.badges.left = {};
      generic.badges.right = {};


      if($(_this.selectors.badges.left+' .active').length > 0){
        var badge_ele = $(_this.selectors.badges.left+' .active').find('img');
        try{

          generic.badges.left.img = await _this.loadSVGTextFromURL(badge_ele.attr('src'));
          generic.badges.left.img_url = badge_ele.attr('src');

          if($(_this.selectors.colours.badge_left+' .picker--active').length > 0){
            generic.badges.left.colour = $(_this.selectors.colours.badge_left+' .picker--active').text();
          }else{
            generic.badges.left.colour = "none";
          }           
        }catch(e){
          console.log(e);
        }
      }

      if($(_this.selectors.badges.right+' .active').length > 0){
        var badge_ele = $(_this.selectors.badges.right+' .active').find('img');
        try{
          generic.badges.right.img = await _this.loadSVGTextFromURL(badge_ele.attr('src'));
          generic.badges.right.img_url = badge_ele.attr('src');

          if($(_this.selectors.colours.badge_right+' .picker--active').length > 0){
            generic.badges.right.colour = $(_this.selectors.colours.badge_right+' .picker--active').text();
          }else{
            generic.badges.right.colour = "none";
          }          
        }catch(e){
          console.log(e);
        }
      }  

      /* slogans */ 
      generic.slogans = {};
      generic.slogans.left = {};
      generic.slogans.right = {};

      //left img
      if($(_this.selectors.slogans.left_image+' .active').length > 0){
        var slogan_ele = $(_this.selectors.slogans.left_image+' .active').find('img');
        try{                   
          generic.slogans.left.img = await _this.loadSVGTextFromURL(slogan_ele.attr('src'));
          generic.slogans.left.img_url = slogan_ele.attr('src');
        }catch(e){
          console.log(e);
        }
      }

      //right img    
      if($(_this.selectors.slogans.right_image+' .active').length > 0){
        var slogan_ele = $(_this.selectors.slogans.right_image+' .active').find('img');
        try{
          generic.slogans.right.img = await _this.loadSVGTextFromURL(slogan_ele.attr('src'));  
          generic.slogans.right.img_url = slogan_ele.attr('src');
        }catch(e){
          console.log(e);
        }
      }

      //colour    
            generic.slogans.colour = generic.colours.slogan === "default" ? "" : generic.colours.slogan;

      //text    
      if($(_this.selectors.slogans.text).val().length > 0){
        generic.slogans.text = $(_this.selectors.slogans.text).val();
      }else{
        generic.slogans.text = "";
      }            

      /* border */
      generic.border = {};
      if($(_this.selectors.colours.border+' .picker--active').length > 0){
        generic.border.colour = _this.rgb2hex($(_this.selectors.colours.border+' .picker--active').css('background-color'));
        generic.border.type = $(_this.selectors.border.border_type).val();
      }

      /* bsau */
      generic.bsau = {};
      if($("#britishStandard").prop("checked") === true){
        generic.bsau.text = _this.pb.bsau.print;
      }    


      /* front */
      var front = {};
      front.size = {};
      if($(selectors.plate_options.faces).val() === "front-back" || $(selectors.plate_options.faces).val() === "front"){      
        var s_f_i = parseInt($(selectors.sizes.front).val());
        front.size = _this.pb.sizes[s_f_i];

        front.size.height = parseFloat(front.size.height); 
        front.size.width = parseFloat(front.size.width);
      }

      /* back */
      var back = {};
      back.size = {};
      if($(selectors.plate_options.faces).val() === "front-back" || $(selectors.plate_options.faces).val() === "back"){      
        var s_f_i = parseInt($(selectors.sizes.back).val());
        back.size = _this.pb.sizes[s_f_i];

        back.size.height = back.size.height; 
        back.size.width = back.size.width;
      }   

      if($(selectors.plate_options.faces).val() === "front-back"){
        generic.faces = "front-back";
      }

      if($(selectors.plate_options.faces).val() === "front"){
        generic.faces = "front";
      }

      if($(selectors.plate_options.faces).val() === "back"){
        generic.faces = "back";
      }    

      generic.plate_type = $('input[name="plateType"]:checked').val();


      _this.display_params.front = front;
      _this.display_params.back = back;
      _this.display_params.generic = generic;

      _this.pb = pb;

      if($(selectors.plate_options.faces).val() === "front-back" || $(selectors.plate_options.faces).val() === "front"){  
        _this.createFace("front");    
        _this.updateSidebar();
      }

      if($(selectors.plate_options.faces).val() === "front-back" || $(selectors.plate_options.faces).val() === "back"){ 
        _this.createFace("back");
        _this.updateSidebar();
      }   

      return;

    },
    toPoints: function(input){
      //convert mm to inch
      //var result = input * 28.346472;
      //var result = input * 25.4;
      //convert to point
      //result = result / 72;

      //var result = input;

      var result = input * 2.83465;

      return result;
    },
    generateProductProperties: function(front_img, back_img){
      var _this = this;
      var front = _this.display_params.front;
      var back = _this.display_params.back;
      var generic = _this.display_params.generic; 

      var properties = {};

      properties.front = {};
      properties.front["Front Plate URL"] = front_img;

      properties.back = {};
      properties.back["Back Plate URL"] = back_img;         

      properties.registration = {};

      properties.registration = generic.registration;
      properties.plates = $("#plateSelect option:selected").text();
      properties.plate_type = generic.plate_type;

      if(generic.text_options.front.multiline){
        properties.front_multiline = generic.text_options.front.linebreak;
      }

      if(generic.text_options.back.multiline){
        properties.back_multiline += generic.text_options.back.linebreak;
      } 

      properties.front_size = front.size.display;
      properties.back_size = back.size.display;

      properties.registration_font = generic.fonts.registration.name;
      properties.registration_color = generic.colours.main;

      if(generic.colours.main_outline !== "default"){
        properties.registration_outline_color = generic.colours.main_outline;
      }      

      //badge
      if(!$.isEmptyObject(generic.badges.left) || !$.isEmptyObject(generic.badges.right)){

        if(!$.isEmptyObject(generic.badges.left)){
          properties.left_badge_img_url = generic.badges.left.img_url;

          if(generic.badges.left.colour !== "none"){
            properties.left_badge_bg = generic.colours.badge_left;
          }            
        } 

        if(!$.isEmptyObject(generic.badges.right)){
          properties.right_badge_img_url = generic.badges.right.img_url;

          if(generic.badges.right.colour !== "none"){
            properties.right_badge_bg = generic.colours.badge_right;
          }    
        }

      } 

      //border
      if(!$.isEmptyObject(generic.border)){
        properties.border_color = generic.border.colour;
        properties.border_type = generic.border.type;
      }       

      //slogan
      if(generic.slogans.text !== "" || !$.isEmptyObject(generic.slogans.left) || !$.isEmptyObject(generic.slogans.right)){

        if(generic.slogans.text !== ""){

          properties.slogan_text = generic.slogans.text;

          if(generic.slogans.colour === ""){
            properties.slogan_color = _this.settings.default_colour;
          }else{
            properties.slogan_color = generic.slogans.colour;
          }
          properties.slogan_font = generic.fonts.slogan.name;
        }

        if(!$.isEmptyObject(generic.slogans.left)){
          properties.slogan_left_img = generic.slogans.left.img_url;
        }

        if(!$.isEmptyObject(generic.slogans.right)){
          properties.slogan_right_img = generic.slogans.right.img_url;
        } 

      }

      //background
      if(!$.isEmptyObject(generic.bg) || generic.colours.background !== "default"){


        if(!$.isEmptyObject(generic.bg)){
          properties.bg_img = generic.bg.display_img;        
        }

        if(generic.colours.background !== "default"){
          properties.bg_color = generic.colours.background;
        }
      }  

      return properties;
    },
    updateSidebar: function(){
      var _this = this;
      var front = _this.display_params.front;
      var back = _this.display_params.back;
      var generic = _this.display_params.generic; 

      var legend_html = "<ul>";
      //reg
      legend_html += "<li><h5>Your Reg</h5><ul>"+
                      "<li>Reg: "+generic.registration+"</li>"+
                      "<li>Plates: "+$("#plateSelect option:selected").text()+"</li>"+
                      "<li>Plate Type "+generic.plate_type+"</li>";

      if(generic.text_options.front.multiline){
        legend_html += "<li>Front Multi-line "+generic.text_options.front.linebreak+"</li>";
      }

      if(generic.text_options.back.multiline){
        legend_html += "<li>Front Multi-line "+generic.text_options.back.linebreak+"</li>";
      }    


      legend_html += "</ul></li>";

      //size    
      legend_html += "<li><h5>Size</h5><ul>"+
                    "<li>Front: "+front.size.display+"</li>"+
                    "<li>Back: "+back.size.display+"</li>"+
                    "</ul></li>";   

      //reg style
      legend_html += "<li><h5>Text Size</h5><ul>"+
              "<li>Font: "+generic.fonts.registration.name+"</li>"+
              "<li class='plate-builder__legend__items__item--picker'>Font Colour<div class='picker' style='background-color: "+generic.colours.main+";'></div></li>";

      if(generic.colours.main_outline !== "default"){
        legend_html += "<li class='plate-builder__legend__items__item--picker'>Font Outline Colour:<div class='picker' style='background-color: "+generic.colours.main_outline+";'></div></li>";
      }      

      legend_html += "</ul></li>";

      //badge
      if(!$.isEmptyObject(generic.badges.left) || !$.isEmptyObject(generic.badges.right)){
        legend_html += "<li><h5>Badge</h5><ul>";

        if(!$.isEmptyObject(generic.badges.left)){
          legend_html += '<li class="plate-builder__legend__items__item--picker">Left Badge <img src="'+generic.badges.left.img_url+'"></li>';

          if(generic.badges.left.colour !== "none"){
            legend_html += '<li class="plate-builder__legend__items__item--picker">Left Badge Background:<div class="picker" style="background-color: '+generic.colours.badge_left+';"></div></li>';
          }            
        } 

        if(!$.isEmptyObject(generic.badges.right)){
          legend_html += '<li class="plate-builder__legend__items__item--picker">Left Badge <img src="'+generic.badges.right.img_url+'"></li>';

          if(generic.badges.right.colour !== "default"){
            legend_html += '<li class="plate-builder__legend__items__item--picker">Left Badge Background:<div class="picker" style="background-color: '+generic.colours.badge_right+';"></div></li>';
          } 
        }

        legend_html += "</ul></li>";

      } 

      //border
      if(!$.isEmptyObject(generic.border)){
        legend_html += "<li><h5>Border</h5><ul>"+
                        '<li class="plate-builder__legend__items__item--picker">Border Colour:<div class="picker" style="background-color: '+generic.border.colour+';"></div></li>'+
                        '<li>Border Settings: '+generic.border.type+'</li>'+
                        "</ul></li>"; 
      }    


      //slogan
      if(generic.slogans.text !== "" || !$.isEmptyObject(generic.slogans.left) || !$.isEmptyObject(generic.slogans.right)){
        legend_html += "<li><h5>Slogan</h5><ul>";

        if(generic.slogans.text !== ""){
          legend_html += "<li>Slogan: "+generic.slogans.text+"</li>";
          if(generic.slogans.colour === ""){
            legend_html += '<li class="plate-builder__legend__items__item--picker">Slogan Colour:<div class="picker" style="background-color: '+_this.settings.default_colour+';"></div></li>';
          }else{
            legend_html += '<li class="plate-builder__legend__items__item--picker">Slogan Colour:<div class="picker" style="background-color: '+generic.slogans.colour+';"></div></li>';
          }
          legend_html += "<li>Font: "+generic.fonts.slogan.name+"</li>";
        }

        if(!$.isEmptyObject(generic.slogans.left)){
          legend_html += '<li class="plate-builder__legend__items__item--picker">Left Slogan Logo <img src="'+generic.slogans.left.img_url+'"></li>';
        }

        if(!$.isEmptyObject(generic.slogans.right)){
          legend_html += '<li class="plate-builder__legend__items__item--picker">Left Slogan Logo <img src="'+generic.slogans.right.img_url+'"></li>';
        } 

        legend_html += "</ul></li>";
      }

      //background
      if(!$.isEmptyObject(generic.bg) || generic.colours.background !== "default"){
        legend_html += "<li><h5>Background</h5><ul>";

        if(!$.isEmptyObject(generic.bg)){
          legend_html += '<li class="plate-builder__legend__items__item--picker">Background Image<div class="picker picker--background" style="background-image: url('+generic.bg.display_img+');"></div></li>';        
        }

        if(generic.colours.background !== "default"){
          legend_html += '<li class="plate-builder__legend__items__item--picker">Background Colour:<div class="picker" style="background-color: '+generic.colours.background+';"></div></li>';
        }

        legend_html += "</ul></li>";
      }  

      legend_html += "</ul>";


      $(".plate-builder__legend__items").html(legend_html);

    },
    getFace: function(face){
      var _this = this;
      var face_params = _this.display_params[face];
      var generic_params = _this.display_params.generic; 

     return new Promise(resolve => {
      _this.createFace(face,true,function(){
        _this.showLoading();

        var query_params = {
          "filename": Date.now() + "_" + face, 
          "pdf": _this.pdf_data[face]
        }

        query_params = JSON.stringify(query_params); 


          $.ajax({
            type: 'POST',
            url: _this.settings.generator_url,
            data: query_params
          }).done(function (response) {
            return resolve(response);
          }).fail(function (response) {
            console.log('generate fail');
            return resolve(response);
          });           
        });
      }); 
    },
    addPlates: async function(){ 
      var _this = this;
      var plates = {};

      _this.selectVariant();

      try{
        plates.front = await _this.getFace("front");
      }catch(e){
        console.log(e);
        plates.front = "nodata";
      }

      try{
        plates.back = await _this.getFace("back");
      }catch(e){
        console.log(e);
        plates.back = "nodata";
      } 

      var properties = _this.generateProductProperties(plates.front.img_url, plates.back.img_url);

      var cart_data = {
        id: _this.variant_id, 
        quantity: 1, 
        properties: properties 
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: cart_data,
        dataType: 'json'
      }).done(function (response) {   
        var front_key = response.key+"[front]";
        var back_key = response.key+"[back]";
        var front_b = localStorage.getItem("front");
        var back_b = localStorage.getItem("back");
        localStorage.setItem(front_key, front_b, 4);
        localStorage.setItem(back_key, back_b, 4);       
        location.href = '/cart';
      }).fail(function (response) {
        console.log('atc fail');
        var parseRes = JSON.parse(response.responseText);
        alert("Add to cart failed "+parseRes.description);
      });       
    },
    createFace: function(face, for_print, callback){
      var _this = this;

      if(_this.loading[face] === true){
        return;
      }  

      _this.loading[face] = true;

      var face_params = _this.display_params[face];
      var generic_params = _this.display_params.generic; 

      //adjust sizes with dpi
      var face_height = _this.toPoints(face_params.size.height);
      var face_width = _this.toPoints(face_params.size.width);
      var bleed_x = _this.toPoints(face_params.size.bleed_x);
      var bleed_y = _this.toPoints(face_params.size.bleed_y);
      var badge_width = _this.toPoints(face_params.size.badge_width);
      var badge_image_width = _this.toPoints(face_params.size.badge_image_width);
      var bsau_size = _this.toPoints(face_params.size.bsau_size);
      var font_size = _this.toPoints(face_params.size.font_size);
      var max_font_size = _this.toPoints(face_params.size.font_size);
      var multi_line_font_size = _this.toPoints(face_params.size.multi_line_font_size);
      var slogan_font_size = _this.toPoints(face_params.size.slogan_font_size);
      var slogan_image_size = _this.toPoints(face_params.size.slogan_image_size);
      var border_radius = _this.toPoints(face_params.size.border_radius);
      var border_width = _this.toPoints(face_params.size.border_width);
      var border_bleed = _this.toPoints(7);

      var inner_width = face_width - (border_bleed * 2);
      var inner_height = face_height - (border_bleed * 2);

      var border = {};
      border.width = (face_width - (2 * border_bleed));
      border.height = (face_height - (2 * border_bleed));
      border.thickness = border_width;
      border.radius = border_radius;
      border.x = border_bleed;
      border.y = border_bleed;

      var doc = new PDFDocument({
        layout: 'landscape',
        size: [face_height, face_width],
        compress: false
      });

      var b_stream = new blobStream();

      var stream = doc.pipe(b_stream);    

      $(".loading-stage").text("Setting Background");

      //set background
      var fill_colour = _this.settings.default_display[face].bg_colour;

      if(_this.settings.bg_chosen === true){
        fill_colour = generic_params.colours.background;
      }else{
        if(for_print === true){
          fill_colour = "#ffffff";
        } 
      }

      doc.rect(0, 0, face_width, face_height).fill(fill_colour);

      if(!$.isEmptyObject(generic_params.bg)){

        let bg_width = inner_width;
        let bg_x = border_bleed;

        if(!$.isEmptyObject(generic_params.badges.left)){
          if(!$.isEmptyObject(generic_params.border)){
            if(generic_params.border.type === 'inside'){
              bg_width -= (badge_width + (bleed_x / 2));
              bg_x = badge_width + bleed_x;
            }
          }
        }

        if(!$.isEmptyObject(generic_params.badges.right)){
          if(!$.isEmptyObject(generic_params.border)){
            if(generic_params.border.type === 'inside'){
              bg_width -= (badge_width + (bleed_x / 2));
            }
          } 
        }      

        var bg_opts = {
          width: 752.3161099999999,
          preserveAspectRatio: 'xMinYMid slice'
        } 

        let domparser = new DOMParser();
        var svg_dom = domparser.parseFromString(generic_params.bg.image.img_data, 'image/svg+xml');
        var transformed_svg = svg_dom.documentElement.outerHTML;
        console.log('Width:',inner_width)
        try {
          SVGtoPDF(doc,transformed_svg, 0, 0, bg_opts);
          
          if(inner_width > 442.2054) {
            var bg_opts = {
              width: 752.3161099999999,
              preserveAspectRatio: 'xMinYMid slice'
            } 
            SVGtoPDF(doc,transformed_svg, 752.3161099999999, 0, bg_opts);
            if(inner_width >= 1544.88425) {
              SVGtoPDF(doc,transformed_svg, 1504.6322199999999, 0, bg_opts);
            }
          }
        } catch (error) {
          console.error(error);
          // Expected output: ReferenceError: nonExistentFunction is not defined
          // (Note: the exact output may be browser-dependent)
        }

      } 

      $(".loading-stage").text("Setting Border");

      //set border
      if(!$.isEmptyObject(generic_params.badges.left)){
        if(!$.isEmptyObject(generic_params.border)){
          if(generic_params.border.type === 'inside'){
            border.x = badge_width + border_bleed;
            border.width -= (badge_width);
          }
        }
      }

      if(!$.isEmptyObject(generic_params.badges.right)){
        if(!$.isEmptyObject(generic_params.border)){
          if(generic_params.border.type === 'inside'){
            border.width -= (badge_width);
          }
        } 
      }

      if(!$.isEmptyObject(generic_params.border)){
        doc.lineWidth(border.thickness);
        doc.roundedRect(border.x,border.y,border.width,border.height,border.radius).stroke(generic_params.border.colour);               
      }

      doc.lineWidth(0);  

      $(".loading-stage").text("Setting Badges");

      // Working here to get the badges to the edge
      //set left badge
      var badge_opts = {};
      var badge_x = 0;
      var badge_y = 0;
      var badge_height = face_height;
      var badge_bg_col = '';   

      if(!$.isEmptyObject(generic_params.badges.left)){      
        _this.stored_options.badges.left = generic_params.badges.left;      
      }

      if(!$.isEmptyObject(_this.stored_options.badges.left)){

        generic_params.badges.left = _this.stored_options.badges.left;

        badge_opts = {
          width: badge_image_width,
          height: (face_height),
          preserveAspectRatio: 'xMidyMid meet'
        }        

        if(generic_params.colours.badge_left !== 'default'){

          badge_bg_col = generic_params.colours.badge_left;

          doc.fillColor(badge_bg_col);
          doc.roundedRect(badge_x, badge_y, badge_width, badge_height, border_radius).fill(badge_bg_col);
          doc.rect(badge_x + badge_width - border_radius,badge_y,border_radius,badge_height).fill(badge_bg_col);
        }           

        badge_x = badge_x + (badge_width - badge_image_width) / 2;

        SVGtoPDF(doc, generic_params.badges.left.img, badge_x, badge_y, badge_opts);
      } 

      //set right badge
      badge_opts = {};
      badge_x = face_width - badge_width;
      badge_y = 0;

      if(!$.isEmptyObject(generic_params.badges.right)){
        _this.stored_options.badges.right = generic_params.badges.right;
      }

      if(!$.isEmptyObject(_this.stored_options.badges.right)){

        generic_params.badges.right = _this.stored_options.badges.right;

        badge_opts = {
          width: badge_image_width,
          height: face_height,
          preserveAspectRatio: 'xMidyMid meet'
        }    

        if(generic_params.colours.badge_right !== 'default'){

          badge_bg_col = generic_params.colours.badge_right;

          doc.fillColor(badge_bg_col);
          doc.roundedRect(badge_x, badge_y, badge_width, badge_height, border_radius).fill(badge_bg_col);
          doc.rect(badge_x,badge_y,border_radius,badge_height).fill(badge_bg_col);
        }              

        badge_x = badge_x + (badge_width - badge_image_width) / 2;

        SVGtoPDF(doc, generic_params.badges.right.img, badge_x, badge_y, badge_opts);

      }  

      $(".loading-stage").text("Setting Registration");

      //set reg              
      var text_x = bleed_x;    
      var text_y = bleed_y;
      var text_svg = "";
      var primary_colour = "";
      var secondary_colour = "";    
      var text_line_1 = generic_params.registration.toUpperCase();
      var text_line_2 = "";
      var text_split = parseInt(generic_params.text_options[face].linebreak);
      var line_break_gap = 1;
      var line_height = _this.toPoints(8);
      var text_opts = {
        width: (face_width - (bleed_x * 2)),
        height: (face_height - (bleed_y * 2)),
        lineGap: line_height,
        align: 'center',
        baseline: 'middle',
        fill: true,
        stroke: false
      }; 
      var svg2pdf_opts = {
        width: (face_width - (bleed_x * 2)),
        height: (face_height - (bleed_y * 2)),
        preserveAspectRatio: "SVG to fit",
        assumePt: true
      }
      var string_height = 0;
      var font = generic_params.fonts.registration;
      var stroke_colour = "";
      var font_scale = font.font_scale;
      var badge_text_buffer = (bleed_x / 4);
      var arb_text_width_adj = 0.94;
      var font_size_adj = 1;
      var slogan_size_adj = 1;

      switch(font.name) {
        case 'Helvetica':
          font_size *= 0.9;
          slogan_size_adj = 0.75;
          break;           
      } 

      font_size = font_size * font_scale;
      multi_line_font_size = multi_line_font_size * font_scale;

      if(font.data !== 'nodata' ){
        doc.registerFont(font.name,font.data);
      }
      doc.registerFont(generic_params.fonts.base.name,generic_params.fonts.base.data);

      if(generic_params.colours.main !== 'default'){
        fill_colour = generic_params.colours.main;      
        stroke_colour = generic_params.colours.main;
      }else{
        fill_colour = _this.settings.default_colour;
        stroke_colour = _this.settings.default_colour;
      }  

      doc.fillColor(fill_colour);  

      if(!$.isEmptyObject(generic_params.badges.left)){
        text_opts.width -= (badge_width + badge_text_buffer);
        svg2pdf_opts.width -= (badge_width + badge_text_buffer);
        text_x += (badge_width + badge_text_buffer);
      }

      if(!$.isEmptyObject(generic_params.badges.right)){
        text_opts.width -= (badge_width + badge_text_buffer);
        svg2pdf_opts.width -= (badge_width + badge_text_buffer);
      }

      primary_colour = fill_colour;

      if(font.name.indexOf('3D') > -1){  
        if(fill_colour === _this.settings.default_colour){
          primary_colour = _this.settings.default_offset_colour;  
        }else{
          primary_colour = fill_colour;                   
        } 

        secondary_colour = _this.settings.default_colour;
      }

      if(font.name.indexOf('Inline') > -1){
        if(fill_colour === _this.settings.default_colour){
          primary_colour = _this.settings.default_offset_colour;
          secondary_colour = _this.settings.default_colour;       
        }else{
          primary_colour = _this.settings.default_colour;
          secondary_colour = fill_colour;        
        } 
      }           

      doc.font(font.name);
      doc.fontSize(font_size);   

      var text_style =  "<style>.core{"+
                        ";dominant-baseline: "+font.dominant_baseline+
                        ";baseline-shift: "+_this.toPoints(font.baseline_shift)+
                        ";alignment-baseline: "+font.alignment_baseline+
                        ";text-anchor:middle"+
                        ";font-family:"+font.name+
                        ";font-size:"+font_size+
                        "pt;}</style>";

      var underlay_style = "<style>.core{"+
                        ";dominant-baseline: "+font.dominant_baseline+
                        ";baseline-shift: "+_this.toPoints(font.baseline_shift)+
                        ";alignment-baseline: "+font.alignment_baseline+
                        ";text-anchor:middle"+
                        ";font-family:"+generic_params.fonts.base.name+
                        ";font-size:"+font_size+
                        "pt;}</style> ";

      var text_svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:x="http://www.w3.org/1999/xlink" x="0" y="0" width="'+text_opts.width+'pt" height="'+text_opts.height+'pt">'+
                      '#style#'+
                      '<defs>'+
                        carbon_pattern+
                      '</defs>'+
                      '<rect x="0" y="0" width="'+text_opts.width+'pt" height="'+text_opts.height+'pt" fill-opacity="0" />'+
                      '<text class="core" x="50%" y="50%" fill="#fill#" stroke="#stroke#" text-anchor="middle">'+text_line_1+'</text>'+
                     '</svg>';

      var reg_string_width = doc.widthOfString(text_line_1);

      if(reg_string_width > text_opts.width){
        var width_scale = text_opts.width / reg_string_width;
        font_size = font_size * width_scale;

        text_style =  "<style>.core{"+
                      ";dominant-baseline: "+font.dominant_baseline+
                      ";baseline-shift: "+_this.toPoints(font.baseline_shift)+
                      ";alignment-baseline: "+font.alignment_baseline+
                      ";text-anchor:middle"+
                      ";font-family:"+font.name+
                      ";font-size:"+font_size+
                      "pt;}</style>";

        underlay_style = "<style>.core{"+
                        ";dominant-baseline: "+font.dominant_baseline+
                        ";baseline-shift: "+_this.toPoints(font.baseline_shift)+
                        ";alignment-baseline: "+font.alignment_baseline+
                        ";text-anchor:middle"+
                        ";font-family:"+generic_params.fonts.base.name+
                        ";font-size:"+font_size+
                        "pt;}</style> ";      
      }      

      var underlay_svg = "";

      var carbon_pattern_replace = "url(#p1)";

      if(generic_params.colours.main_outline !== 'default'){
        text_svg = text_svg.replace('#stroke#', generic_params.colours.main_outline);
      }    

      if(generic_params.text_options[face].multiline !== true){ // single line text    

        if(font.name.indexOf('Inline') > -1 || font.name.indexOf('3D') > -1){  

          if(generic_params.colours.carbon === true && font.name.indexOf('Inline') > -1){
            underlay_svg = text_svg.replace('#style#', underlay_style).replace('#fill#',carbon_pattern_replace);
          }else{
            underlay_svg = text_svg.replace('#style#', underlay_style).replace('#fill#',secondary_colour);
          }

          SVGtoPDF(doc, underlay_svg, text_x, text_y, svg2pdf_opts);

        } 

        if(generic_params.colours.carbon === true && font.name.indexOf('Inline') === -1){
          text_svg = text_svg.replace('#style#', text_style).replace('#fill#',carbon_pattern_replace);
        }else{
          text_svg = text_svg.replace('#style#', text_style).replace('#fill#',primary_colour);
        } 

        SVGtoPDF(doc, text_svg, text_x, text_y, svg2pdf_opts);  

      }else{

        font_size = multi_line_font_size;
        text_line_2 = text_line_1.substring(text_split);
        text_line_1 = text_line_1.substring(0, text_split);  

        //remove spaces from the start and end of strings to adjust spacing
        if(text_line_1[0] === " "){
          text_line_1 = text_line_1.removeCharAt(1);
        }
        if(text_line_1[text_line_1.length] === " "){
          text_line_1 = text_line_1.removeCharAt(text_line_1.length);
        }  

        if(text_line_2[0] === " "){
          text_line_2 = text_line_2.removeCharAt(1);
        }
        if(text_line_2[text_line_2.length] === " "){
          text_line_2 = text_line_2.removeCharAt(text_line_2.length);
        }       

        text_style =  "<style>.core{"+
                          ";dominant-baseline: "+font.dominant_baseline+
                          ";baseline-shift: "+(_this.toPoints(font.baseline_shift) / 2)+
                          ";alignment-baseline: "+font.alignment_baseline+
                          ";text-anchor:middle"+
                          ";font-family:"+font.name+
                          ";font-size:"+font_size+
                          "pt;}</style>";

        underlay_style = "<style>.core{"+
                          ";dominant-baseline: "+font.dominant_baseline+
                          ";baseline-shift: "+(_this.toPoints(font.baseline_shift) / 2)+
                          ";alignment-baseline: "+font.alignment_baseline+
                          ";text-anchor:middle"+
                          ";font-family:"+generic_params.fonts.base.name+
                          ";font-size:"+font_size+
                          "pt;}</style> "; 

        text_svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:x="http://www.w3.org/1999/xlink" x="0" y="0" width="'+text_opts.width+'pt" height="'+text_opts.height+'pt">'+
                        '#style#'+
                        '<defs>'+
                          carbon_pattern+
                        '</defs>'+
                        '<rect x="0" y="0" width="'+text_opts.width+'pt" height="'+text_opts.height+'pt" fill-opacity="0" />'+
                        '<text class="core" x="50%" y="24%" fill="#fill#" text-anchor="middle">'+text_line_1+'</text>'+
                        '<text class="core" x="50%" y="76%" fill="#fill#" text-anchor="middle">'+text_line_2+'</text>'+
                       '</svg>';

        doc.fontSize(font_size);

        if(text_line_1.length > text_line_2.length){
          reg_string_width = doc.widthOfString(text_line_1) * arb_text_width_adj;
        }else{
          reg_string_width = doc.widthOfString(text_line_2) * arb_text_width_adj;
        }     

        if(reg_string_width > text_opts.width){
          var width_scale = text_opts.width / reg_string_width;
          font_size = font_size * width_scale;

          text_style =  "<style>.core{"+
                        ";dominant-baseline: "+font.dominant_baseline+
                        ";baseline-shift: "+_this.toPoints(font.baseline_shift)+
                        ";alignment-baseline: "+font.alignment_baseline+
                        ";text-anchor:middle"+
                        ";font-family:"+font.name+
                        ";font-size:"+font_size+
                        "pt;}</style>";

          underlay_style = "<style>.core{"+
                            ";dominant-baseline: "+font.dominant_baseline+
                            ";baseline-shift: "+(_this.toPoints(font.baseline_shift) / 2)+
                            ";alignment-baseline: "+font.alignment_baseline+
                            ";text-anchor:middle"+
                            ";font-family:"+generic_params.fonts.base.name+
                            ";font-size:"+font_size+
                            "pt;}</style> ";         
        }        

        if(font.name.indexOf('Inline') > -1 || font.name.indexOf('3D') > -1){  

          if(generic_params.colours.carbon === true && font.name.indexOf('Inline') > -1){
            underlay_svg = text_svg.replace('#style#', underlay_style).replace(/#fill#/g,carbon_pattern_replace);
          }else{
            underlay_svg = text_svg.replace('#style#', underlay_style).replace(/#fill#/g,secondary_colour);
          }

          SVGtoPDF(doc, underlay_svg, text_x, text_y, svg2pdf_opts);

        } 

        if(generic_params.colours.carbon === true && font.name.indexOf('Inline') === -1){
          text_svg = text_svg.replace('#style#', text_style).replace(/#fill#/g,carbon_pattern_replace);
        }else{
          text_svg = text_svg.replace('#style#', text_style).replace(/#fill#/g,primary_colour);
        }     

        SVGtoPDF(doc, text_svg, text_x, text_y, svg2pdf_opts);       

      }

      $(".loading-stage").text("Setting Slogan");

      //set slogan
      if(generic_params.slogans.text !== "" || !$.isEmptyObject(generic_params.slogans.left) || !$.isEmptyObject(generic_params.slogans.right)){

        var slogan_font = generic_params.fonts.slogan;
        var font_scale = slogan_font.font_scale;

        switch(slogan_font.name) {
          case 'Helvetica':          
            slogan_size_adj = 0.75;
            break;           
        }       

        console.log(slogan_size_adj);     

        slogan_font_size = slogan_font_size * font_scale * slogan_size_adj;
        var slogan_bg_height = slogan_image_size + slogan_image_size / 4;

        if(slogan_font.data !== 'nodata' ){
          doc.registerFont(slogan_font.name,slogan_font.data);
        }       

        var slogan_image_width = slogan_image_size * 3;
        var slogan_image_buffer = slogan_image_size / 2;

        doc.font(slogan_font.name);
        doc.fontSize(slogan_font_size);
        doc.fillColor(generic_params.colours.slogan);   

        var slogan_string_width = doc.widthOfString(generic_params.slogans.text) + slogan_image_size;  

        fill_colour = _this.settings.default_display[face].bg_colour;

        if(_this.settings.bg_chosen === true){
          fill_colour = generic_params.colours.background;  
        }else{
          if(for_print === true){
            fill_colour = "#ffffff";
          }    
        }           

        var slogan_opts = {
          width: 0,
          height: bleed_y,
          x: 0,
          y: face_height - (bleed_y / 2) - (slogan_image_size / 2),
          text: generic_params.slogans.text
        };

        var slogan_svg_opts = {};

        //set slogan container

        var slogan_type = "default";

        //text only
        if(generic_params.slogans.text !== "" && $.isEmptyObject(generic_params.slogans.left) && $.isEmptyObject(generic_params.slogans.right)){
          slogan_type = "text-only";
          slogan_opts.x = (face_width / 2) - (slogan_string_width / 2);  
          slogan_opts.width = slogan_string_width;
        }

        //single image only
        if(!$.isEmptyObject(generic_params.slogans.left) && $.isEmptyObject(generic_params.slogans.right)){
          slogan_opts.x = (face_width / 2) - (slogan_image_width / 2) - slogan_image_buffer;
          slogan_opts.width = slogan_image_width + (slogan_image_buffer * 2);
          slogan_type = "single-image";

          //single image with text
          if(generic_params.slogans.text !== ""){
            slogan_opts.x = (face_width / 2) - (((slogan_image_buffer * 3) + slogan_string_width + slogan_image_width) / 2);
            slogan_opts.width = slogan_string_width + slogan_image_width + (slogan_image_buffer * 3);          
            slogan_type = "single-image-text-right";
          }
        } 

        if($.isEmptyObject(generic_params.slogans.left) && !$.isEmptyObject(generic_params.slogans.right)){
          slogan_opts.x = (face_width / 2) - (slogan_image_width / 2) - slogan_image_buffer;
          slogan_opts.width = slogan_image_width + (slogan_image_buffer * 2);
          slogan_type = "single-image";  

          //single image with text
          if(generic_params.slogans.text !== ""){
            slogan_opts.x = (face_width / 2) - (((slogan_image_buffer * 3) + slogan_string_width + slogan_image_width) / 2);
            slogan_opts.width = slogan_string_width + slogan_image_width + (slogan_image_buffer * 3);           
            slogan_type = "single-image-text-left";
          }        
        }

        //double image no text
        if((!$.isEmptyObject(generic_params.slogans.left) && !$.isEmptyObject(generic_params.slogans.right)) && generic_params.slogans.text === ""){
          slogan_opts.x = (face_width / 2) - slogan_image_width - slogan_image_buffer - ( slogan_image_buffer / 2); 
          slogan_opts.width = (slogan_image_width * 2) + (slogan_image_buffer * 3);
          slogan_type = "double-image";
        }       

        //all
        if(!$.isEmptyObject(generic_params.slogans.left) && !$.isEmptyObject(generic_params.slogans.right) && generic_params.slogans.text !== ""){
          slogan_opts.x = (face_width / 2) - (slogan_string_width / 2) - slogan_image_width - (slogan_image_buffer * 2);
          slogan_opts.width = (slogan_image_width * 2) + (slogan_image_buffer * 4) + slogan_string_width;
          slogan_type = "all";
        }

        doc.fillColor(fill_colour);
        doc.strokeColor("#000");
        doc.rect(slogan_opts.x,(face_height - bleed_y + (slogan_image_size / 3)),slogan_opts.width,slogan_opts.height).fill(fill_colour);

        //set slogan text
        if(generic_params.slogans.text !== ""){

          fill_colour = generic_params.colours.slogan; 
          primary_colour = fill_colour; 

          if(slogan_font.name.indexOf('3D') > -1){  
            if(fill_colour === _this.settings.default_colour){
              primary_colour = _this.settings.default_offset_colour;  
            }else{
              primary_colour = fill_colour;                   
            } 

            secondary_colour = _this.settings.default_colour;
          }

          if(slogan_font.name.indexOf('Inline') > -1){
            if(fill_colour === _this.settings.default_colour){
              primary_colour = _this.settings.default_colour;
              secondary_colour = _this.settings.default_offset_colour;       
            }else{
              primary_colour = fill_colour;
              secondary_colour = _this.settings.default_colour;        
            } 
          }

          doc.fillColor(fill_colour);

          var alignment = "";
          var anchor = "";
          var text_x = "";

          //text only
          if(slogan_type === "text-only"){
            alignment = 'center';
            anchor = "middle";
            text_x = "50%";
          }

          //single image with text
          if(slogan_type === "single-image-text-left"){
            alignment = 'left';
            anchor = "start";
            text_x = "0";
          }
          if(slogan_type === "single-image-text-right"){
            alignment = 'right';
            anchor = "end";
            text_x = "100%";
          }   

          //all
          if(slogan_type === "all"){
            alignment = 'center';
            anchor = "middle";
            text_x = "50%";
          }          

          text_style =  "<style>.core{"+
                        ";dominant-baseline: "+slogan_font.dominant_baseline+
                        ";alignment-baseline: "+slogan_font.alignment_baseline+
                        ";text-align:"+alignment+
                        ";font-family:"+slogan_font.name+
                        ";font-size:"+slogan_font_size+
                        "pt;}</style>";

          underlay_style = "<style>.core{"+
                        ";dominant-baseline: "+slogan_font.dominant_baseline+
                        ";alignment-baseline: "+slogan_font.alignment_baseline+
                        ";text-align:"+alignment+
                        ";font-family:"+generic_params.fonts.base.name+
                        ";font-size:"+slogan_font_size+
                        "pt;}</style> ";

          text_svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:x="http://www.w3.org/1999/xlink" x="0" y="0" width="'+slogan_string_width+'pt" height="'+slogan_opts.height+'pt">'+
                          '#style#'+
                          '<rect x="0" y="0" width="'+slogan_string_width+'pt" height="'+slogan_opts.height+'pt" fill-opacity="0" />'+
                          '<text class="core" x="'+text_x+'" y="50%" fill="#fill#" text-anchor="'+anchor+'">'+generic_params.slogans.text+'</text>'+
                         '</svg>';  

          var underlay_svg = "";
          var aspect_ratio = "";

          slogan_opts.y = face_height - bleed_y;

          //text only
          if(slogan_type === "text-only"){
            slogan_opts.x = (face_width / 2) - (slogan_string_width / 2);
            aspect_ratio = 'xMidYMid meet';
          }

          //single image with text
          if(slogan_type === "single-image-text-left"){
            slogan_opts.x = (face_width / 2) - (((slogan_image_buffer * 3) + slogan_string_width + slogan_image_width) / 2) + slogan_image_buffer;
            aspect_ratio = 'xMinYMid meet';
          }
          if(slogan_type === "single-image-text-right"){
            slogan_opts.x = (face_width / 2) - (((slogan_image_buffer * 3) + slogan_string_width + slogan_image_width) / 2) + slogan_image_width + (slogan_image_buffer * 2);
            aspect_ratio = 'xMaxYMid meet';
          }        

          //all
          if(slogan_type === "all"){
            slogan_opts.x = (face_width / 2) - (slogan_string_width / 2);
            aspect_ratio = 'xMidYMid meet';
          }

          slogan_svg_opts = {
            width: slogan_string_width,
            height: slogan_opts.height,
            preserveAspectRatio: aspect_ratio
          } 


          if(slogan_font.name.indexOf('Inline') > -1 || slogan_font.name.indexOf('3D') > -1){  

            underlay_svg = text_svg.replace('#style#', underlay_style).replace('#fill#',secondary_colour);

            SVGtoPDF(doc, underlay_svg, slogan_opts.x, slogan_opts.y, slogan_svg_opts);

          }       

          text_svg = text_svg.replace("#style#",text_style).replace('#fill#',primary_colour);

          SVGtoPDF(doc, text_svg, slogan_opts.x, slogan_opts.y, slogan_svg_opts);
        }

        slogan_opts.y = face_height - (bleed_y / 2) - (slogan_image_size / 2);      

        //single image only
        if(slogan_type === "single-image"){
          slogan_opts.x = (face_width / 2) - (slogan_image_width / 2);
        } 

        //single image with text
        if(slogan_type === "single-image-text-right"){
          slogan_opts.x = (face_width / 2) - ((slogan_image_width + slogan_string_width + ( slogan_image_buffer / 2)) / 2);
        }      

        //double image no text
        if(slogan_type === "double-image"){
          slogan_opts.x = (face_width / 2) - slogan_image_width - (slogan_image_buffer / 2);
        }       

        //all
        if(slogan_type === "all"){
          slogan_opts.x = (face_width / 2) - (slogan_string_width / 2) - slogan_image_width - slogan_image_buffer;
        }  

        //set left slogan
        if(!$.isEmptyObject(generic_params.slogans.left)){

          slogan_svg_opts = {
            width: slogan_image_width,
            height: slogan_image_size,
            preserveAspectRatio: 'xMidYMid meet'
          }

          SVGtoPDF(doc, generic_params.slogans.left.img, slogan_opts.x, slogan_opts.y, slogan_svg_opts);                
        } 

        //single image with text
        if(slogan_type === "single-image-text-left"){
          slogan_opts.x = (face_width / 2) - ((slogan_string_width + slogan_image_width + slogan_image_buffer) / 2) + slogan_string_width + slogan_image_buffer;
        }   

        //double image no text
        if(slogan_type === "double-image"){
          slogan_opts.x = (face_width / 2) + (slogan_image_buffer / 2);
        }       

        //all
        if(slogan_type === "all"){
          slogan_opts.x = (face_width / 2) + (slogan_string_width / 2) + slogan_image_buffer;
        }  

        //set right slogan     
        if(!$.isEmptyObject(generic_params.slogans.right)){     

          slogan_svg_opts = {
            width: slogan_image_width,
            height: slogan_image_size,
            preserveAspectRatio: 'xMidYMid meet'
          }       

          SVGtoPDF(doc, generic_params.slogans.right.img, slogan_opts.x, slogan_opts.y, slogan_svg_opts);
        }      


      }

      $(".loading-stage").text("Setting BSAU");

      //set BSAU
      if(!$.isEmptyObject(generic_params.bsau)){

        doc.registerFont(generic_params.fonts.bsau.name,generic_params.fonts.bsau.data);

        var is_light = false;

        if(!$.isEmptyObject(generic_params.border)){
          is_light = hex_is_light(generic_params.border.colour);  
        }else{
          var test_colour = _this.settings.default_display[face].bg_colour;

          if(generic_params.colours.background !== 'default'){
            test_colour = generic_params.colours.background;            
          }        
          is_light = hex_is_light(test_colour);
        }

        if(is_light){
          doc.fillColor("#000000");
        }else{
          doc.fillColor("#ffffff");
        }

        doc.font(generic_params.fonts.bsau.name);
        doc.fontSize(border.thickness);

        let bsau_length = doc.widthOfString(generic_params.bsau.text) + (doc.widthOfString(generic_params.bsau.text) / 2); 
        let bsau_x = face_width - border_bleed - border.thickness - border.radius - bsau_length;
        let bsau_y = face_height - border_bleed;

        let bsau_text_opts = {
          width: bsau_length,
          height: border.thickness,
          lineGap: 0,
          align: 'right',
          baseline: 'middle',
          fill: true,
          stroke: false
        };            

        doc.text(generic_params.bsau.text, bsau_x, bsau_y, bsau_text_opts).fill(generic_params.colours.main);

      }

      $(".loading-stage").text("Setting Tint");

      //set tint
      if(_this.settings.tint === true){    
        doc.fillOpacity(0.25);
        doc.rect(0, 0, face_width, face_height).fill("#000000");    
      }       

      // end and display the document in the iframe to the right
      doc.end();      

      stream.on('finish', function() {

        /*
        // get a blob you can do whatever you like with
        const blob = stream.toBlob('application/pdf');

        // or get a blob URL for display in the browser
        const url = stream.toBlobURL('application/pdf');
        $(_this.selectors.display[face]).attr("src", stream.toBlobURL('application/pdf')); 
        */

        var blob = stream.toBlob('application/pdf');

        readBlobFile(blob, function(pdfData){

          $(".loading-stage").text("Generating Preview");

          if(for_print === true || _this.pdf_data[face] === ""){
            console.log("setting data");
            _this.pdf_data[face] = pdfData;
          }         

          // Loaded via <script> tag, create shortcut to access PDF.js exports.
          var pdfjsLib = window['pdfjs-dist/build/pdf'];

          // The workerSrc property shall be specified.
          pdfjsLib.GlobalWorkerOptions.workerSrc = "//proplates.co.uk/cdn/shop/t/41/assets/pdf.worker.js?v=20800980732360356531785049629";

          var converted_data = atob(pdfData.replace('data:application/pdf;base64,',''));                

          // Using DocumentInitParameters object to load binary data.
          var loadingTask = pdfjsLib.getDocument({data: converted_data});

          loadingTask.promise.then(function(pdf) {

            // Fetch the first page
            var pageNumber = 1;
            pdf.getPage(pageNumber).then(function(page) {

              var viewport = page.getViewport({scale: 1});

              var max_v_width = $("#plate_builder .plate-builder__content").width();

              if(window.innerWidth > 1268){
                max_v_width = 650;
              }else{
                max_v_width = 300;
              }

              var init_scale = 300 / viewport.height;
              var second_scale = 1;

              viewport = page.getViewport({scale: init_scale});

              if(viewport.width > max_v_width){
                second_scale = (max_v_width / viewport.width) * (init_scale / 1);

                viewport = page.getViewport({scale: second_scale});            
              }

              // Prepare canvas using PDF page dimensions
              var selector = _this.selectors.display[face].replace("#",'');
              var canvas = document.getElementById(selector);
              var context = canvas.getContext('2d');

              canvas.height = viewport.height;
              canvas.width = viewport.width;            

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };

              _this.render_tasks[face] = page.render(renderContext);

              $(".loading-stage").text("Rendering Preview");
              _this.render_tasks[face].promise.then(function () {

                if(for_print !== true || _this.pdf_data[face] === ""){
                  var imgData = canvas.toDataURL();
                  localStorage.setItem(face, imgData);
                }

                _this.loading[face] = false;

                if(callback){
                  callback();
                }

                _this.hideLoading();

              });
            });
          }, function (reason) {
            // PDF loading error
            console.error(reason);


            if(callback){
              callback(reason);
            }          
          });        
        });
      }); 

      //resize frame
      _this.setDisplaySize();           

    }   
  };

  function hex_is_light(color) {
      const hex = color.replace('#', '');
      const c_r = parseInt(hex.substr(0, 2), 16);
      const c_g = parseInt(hex.substr(2, 2), 16);
      const c_b = parseInt(hex.substr(4, 2), 16);
      const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
      return brightness > 155;
  }

  function readBlobFile(blob, callback) {

    let reader = new FileReader();

    reader.readAsDataURL(blob);

    reader.onload = function() {
      callback(reader.result);
    };

    reader.onerror = function() {
      callback(reader.error);
    };

  }

  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  String.prototype.removeCharAt = function (i) {
      var tmp = this.split(''); // convert to an array
      tmp.splice(i - 1 , 1); // remove 1 element from the array (adjusting for non-zero-indexed counts)
      return tmp.join(''); // reconstruct the string
  }

  plate_builder.init();
  },{"svg-to-pdfkit":2}],2:[function(require,module,exports){
  var SVGtoPDF = function(doc, svg, x, y, options) {
      "use strict";

      const NamedColors = {aliceblue: [240,248,255], antiquewhite: [250,235,215], aqua: [0,255,255], aquamarine: [127,255,212], azure: [240,255,255], beige: [245,245,220], bisque: [255,228,196], black: [0,0,0], blanchedalmond: [255,235,205], blue: [0,0,255], blueviolet: [138,43,226], brown: [165,42,42], burlywood: [222,184,135], cadetblue: [95,158,160], chartreuse: [127,255,0],
        chocolate: [210,105,30], coral: [255,127,80], cornflowerblue: [100,149,237], cornsilk: [255,248,220], crimson: [220,20,60], cyan: [0,255,255], darkblue: [0,0,139], darkcyan: [0,139,139], darkgoldenrod: [184,134,11], darkgray: [169,169,169], darkgrey: [169,169,169], darkgreen: [0,100,0], darkkhaki: [189,183,107], darkmagenta: [139,0,139], darkolivegreen: [85,107,47],
        darkorange: [255,140,0], darkorchid: [153,50,204], darkred: [139,0,0], darksalmon: [233,150,122], darkseagreen: [143,188,143], darkslateblue: [72,61,139], darkslategray: [47,79,79], darkslategrey: [47,79,79], darkturquoise: [0,206,209], darkviolet: [148,0,211], deeppink: [255,20,147], deepskyblue: [0,191,255], dimgray: [105,105,105], dimgrey: [105,105,105],
        dodgerblue: [30,144,255], firebrick: [178,34,34], floralwhite: [255,250,240], forestgreen: [34,139,34], fuchsia: [255,0,255], gainsboro: [220,220,220], ghostwhite: [248,248,255], gold: [255,215,0], goldenrod: [218,165,32], gray: [128,128,128], grey: [128,128,128], green: [0,128,0], greenyellow: [173,255,47], honeydew: [240,255,240], hotpink: [255,105,180],
        indianred: [205,92,92], indigo: [75,0,130], ivory: [255,255,240], khaki: [240,230,140], lavender: [230,230,250], lavenderblush: [255,240,245], lawngreen: [124,252,0], lemonchiffon: [255,250,205], lightblue: [173,216,230], lightcoral: [240,128,128], lightcyan: [224,255,255], lightgoldenrodyellow: [250,250,210], lightgray: [211,211,211], lightgrey: [211,211,211],
        lightgreen: [144,238,144], lightpink: [255,182,193], lightsalmon: [255,160,122], lightseagreen: [32,178,170], lightskyblue: [135,206,250], lightslategray: [119,136,153], lightslategrey: [119,136,153], lightsteelblue: [176,196,222], lightyellow: [255,255,224], lime: [0,255,0], limegreen: [50,205,50], linen: [250,240,230], magenta: [255,0,255], maroon: [128,0,0],
        mediumaquamarine: [102,205,170], mediumblue: [0,0,205], mediumorchid: [186,85,211], mediumpurple: [147,112,219], mediumseagreen: [60,179,113], mediumslateblue: [123,104,238], mediumspringgreen: [0,250,154], mediumturquoise: [72,209,204], mediumvioletred: [199,21,133], midnightblue: [25,25,112], mintcream: [245,255,250], mistyrose: [255,228,225], moccasin: [255,228,181],
        navajowhite: [255,222,173], navy: [0,0,128], oldlace: [253,245,230], olive: [128,128,0], olivedrab: [107,142,35], orange: [255,165,0], orangered: [255,69,0], orchid: [218,112,214], palegoldenrod: [238,232,170], palegreen: [152,251,152], paleturquoise: [175,238,238], palevioletred: [219,112,147], papayawhip: [255,239,213], peachpuff: [255,218,185], peru: [205,133,63],
        pink: [255,192,203], plum: [221,160,221], powderblue: [176,224,230], purple: [128,0,128], rebeccapurple: [102,51,153], red: [255,0,0], rosybrown: [188,143,143], royalblue: [65,105,225], saddlebrown: [139,69,19], salmon: [250,128,114], sandybrown: [244,164,96], seagreen: [46,139,87], seashell: [255,245,238], sienna: [160,82,45], silver: [192,192,192], skyblue: [135,206,235],
        slateblue: [106,90,205], slategray: [112,128,144], slategrey: [112,128,144], snow: [255,250,250], springgreen: [0,255,127], steelblue: [70,130,180], tan: [210,180,140], teal: [0,128,128], thistle: [216,191,216], tomato: [255,99,71], turquoise: [64,224,208], violet: [238,130,238], wheat: [245,222,179], white: [255,255,255], whitesmoke: [245,245,245], yellow: [255,255,0]};
      const DefaultColors = {black: [NamedColors.black, 1], white: [NamedColors.white, 1], transparent: [NamedColors.black, 0]};
      const Entities = {quot: 34, amp: 38, lt: 60, gt: 62, apos: 39, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, circ: 710, tilde: 732, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249,
        rsaquo: 8250, euro: 8364, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, copy: 169, ordf: 170, laquo: 171, not: 172, shy: 173, reg: 174, macr: 175, deg: 176, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190,
        iquest: 191, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221,
        THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252,
        yacute: 253, thorn: 254, yuml: 255, fnof: 402, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949,
        zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, bull: 8226, hellip: 8230, prime: 8242, Prime: 8243, oline: 8254, frasl: 8260, weierp: 8472, image: 8465, real: 8476,
        trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744,
        cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830};
      const PathArguments = {A: 7, a: 7, C: 6, c: 6, H: 1, h: 1, L: 2, l: 2, M: 2, m: 2, Q: 4, q: 4, S: 4, s: 4, T: 2, t: 2, V: 1, v: 1, Z: 0, z: 0};
      const PathFlags = {A3: true, A4: true, a3: true, a4: true};
      const Properties = {
        'color':              {inherit: true, initial: undefined},
        'visibility':         {inherit: true, initial: 'visible', values: {'hidden': 'hidden', 'collapse': 'hidden', 'visible':'visible'}},
        'fill':               {inherit: true, initial: DefaultColors.black},
        'stroke':             {inherit: true, initial: 'none'},
        'stop-color':         {inherit: false, initial: DefaultColors.black},
        'fill-opacity':       {inherit: true, initial: 1},
        'stroke-opacity':     {inherit: true, initial: 1},
        'stop-opacity':       {inherit: false, initial: 1},
        'fill-rule':          {inherit: true, initial: 'nonzero', values: {'nonzero':'nonzero', 'evenodd':'evenodd'}},
        'clip-rule':          {inherit: true, initial: 'nonzero', values: {'nonzero':'nonzero', 'evenodd':'evenodd'}},
        'stroke-width':       {inherit: true, initial: 1},
        'stroke-dasharray':   {inherit: true, initial: []},
        'stroke-dashoffset':  {inherit: true, initial: 0},
        'stroke-miterlimit':  {inherit: true, initial: 4},
        'stroke-linejoin':    {inherit: true, initial: 'miter', values: {'miter':'miter', 'round':'round', 'bevel':'bevel'}},
        'stroke-linecap':     {inherit: true, initial: 'butt', values: {'butt':'butt', 'round':'round', 'square':'square'}},
        'font-size':          {inherit: true, initial: 16, values: {'xx-small':9, 'x-small':10, 'small':13, 'medium':16, 'large':18, 'x-large':24, 'xx-large':32}},
        'font-family':        {inherit: true, initial: 'sans-serif'},
        'font-weight':        {inherit: true, initial: 'normal', values: {'600':'bold', '700':'bold', '800':'bold', '900':'bold', 'bold':'bold', 'bolder':'bold', '500':'normal', '400':'normal', '300':'normal', '200':'normal', '100':'normal', 'normal':'normal', 'lighter':'normal'}},
        'font-style':         {inherit: true, initial: 'normal', values: {'italic':'italic', 'oblique':'italic', 'normal':'normal'}},
        'text-anchor':        {inherit: true, initial: 'start', values: {'start':'start', 'middle':'middle', 'end':'end'}},
        'direction':          {inherit: true, initial: 'ltr', values: {'ltr':'ltr', 'rtl':'rtl'}},
        'dominant-baseline':  {inherit: true, initial: 'baseline', values: {'auto':'baseline', 'baseline':'baseline', 'before-edge':'before-edge', 'text-before-edge':'before-edge', 'middle':'middle', 'central':'central', 'after-edge':'after-edge', 'text-after-edge':'after-edge', 'ideographic':'ideographic', 'alphabetic':'alphabetic', 'hanging':'hanging', 'mathematical':'mathematical'}},
        'alignment-baseline': {inherit: false, initial: undefined, values: {'auto':'baseline', 'baseline':'baseline', 'before-edge':'before-edge', 'text-before-edge':'before-edge', 'middle':'middle', 'central':'central', 'after-edge':'after-edge', 'text-after-edge':'after-edge', 'ideographic':'ideographic', 'alphabetic':'alphabetic', 'hanging':'hanging', 'mathematical':'mathematical'}},
        'baseline-shift':     {inherit: true, initial: 'baseline', values: {'baseline':'baseline', 'sub':'sub', 'super':'super'}},
        'word-spacing':       {inherit: true, initial: 0, values: {normal:0}},
        'letter-spacing':     {inherit: true, initial: 0, values: {normal:0}},
        'text-decoration':    {inherit: false, initial: 'none', values: {'none':'none', 'underline':'underline', 'overline':'overline', 'line-through':'line-through'}},
        'xml:space':          {inherit: true, initial: 'default', css: 'white-space', values: {'preserve':'preserve', 'default':'default', 'pre':'preserve', 'pre-line':'preserve', 'pre-wrap':'preserve', 'nowrap': 'default'}},
        'marker-start':       {inherit: true, initial: 'none'},
        'marker-mid':         {inherit: true, initial: 'none'},
        'marker-end':         {inherit: true, initial: 'none'},
        'opacity':            {inherit: false, initial: 1},
        'transform':          {inherit: false, initial: [1, 0, 0, 1, 0, 0]},
        'display':            {inherit: false, initial: 'inline', values: {'none':'none', 'inline':'inline', 'block':'inline'}},
        'clip-path':          {inherit: false, initial: 'none'},
        'mask':               {inherit: false, initial: 'none'},
        'overflow':           {inherit: false, initial: 'hidden', values: {'hidden':'hidden', 'scroll':'hidden', 'visible':'visible'}}
      };

      function docBeginGroup(bbox) {
        let group = new (function PDFGroup() {})();
        group.name = 'G' + (doc._groupCount = (doc._groupCount || 0) + 1);
        group.resources = doc.ref();
        group.xobj = doc.ref({
          Type: 'XObject',
          Subtype: 'Form',
          FormType: 1,
          BBox: bbox,
          Group: {S: 'Transparency', CS: 'DeviceRGB', I: true, K: false},
          Resources: group.resources
        });
        group.xobj.write('');
        group.savedMatrix = doc._ctm;
        group.savedPage = doc.page;
        groupStack.push(group);
        doc._ctm = [1, 0, 0, 1, 0, 0];
        doc.page = {
          width: doc.page.width, height: doc.page.height,
          write: function(data) {group.xobj.write(data);},
          fonts: {}, xobjects: {}, ext_gstates: {}, patterns: {}
        };
        return group;
      }
      function docEndGroup(group) {
        if (group !== groupStack.pop()) {throw('Group not matching');}
        if (Object.keys(doc.page.fonts).length) {group.resources.data.Font = doc.page.fonts;}
        if (Object.keys(doc.page.xobjects).length) {group.resources.data.XObject = doc.page.xobjects;}
        if (Object.keys(doc.page.ext_gstates).length) {group.resources.data.ExtGState = doc.page.ext_gstates;}
        if (Object.keys(doc.page.patterns).length) {group.resources.data.Pattern = doc.page.patterns;}
        group.resources.end();
        group.xobj.end();
        doc._ctm = group.savedMatrix;
        doc.page = group.savedPage;
      }
      function docInsertGroup(group) {
        doc.page.xobjects[group.name] = group.xobj;
        doc.addContent('/' + group.name + ' Do');
      }
      function docApplyMask(group, clip) {
        let name = 'M' + (doc._maskCount = (doc._maskCount || 0) + 1);
        let gstate = doc.ref({
          Type: 'ExtGState', CA: 1, ca: 1, BM: 'Normal',
          SMask: {S: 'Luminosity', G: group.xobj, BC: (clip ? [0, 0, 0] : [1, 1, 1])}
        });
        gstate.end();
        doc.page.ext_gstates[name] = gstate;
        doc.addContent('/' + name + ' gs');
      }
      function docCreatePattern(group, dx, dy, matrix) {
        let pattern = new (function PDFPattern() {})();
        pattern.group = group;
        pattern.dx = dx;
        pattern.dy = dy;
        pattern.matrix = matrix || [1, 0, 0, 1, 0, 0];
        return pattern;
      }
      function docUsePattern(pattern, stroke) {
        let name = 'P' + (doc._patternCount = (doc._patternCount || 0) + 1);
        let ref = doc.ref({
          Type: 'Pattern', PatternType: 1, PaintType: 1, TilingType: 2,
          BBox: [0, 0, pattern.dx, pattern.dy], XStep: pattern.dx, YStep: pattern.dy,
          Matrix: multiplyMatrix(doc._ctm, pattern.matrix),
          Resources: {
            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
            XObject: (function() {let temp = {}; temp[pattern.group.name] = pattern.group.xobj; return temp;})()
          }
        });
        ref.write('/' + pattern.group.name + ' Do');
        ref.end();
        doc.page.patterns[name] = ref;
        if (stroke) {
          doc.addContent('/Pattern CS');
          doc.addContent('/' + name + ' SCN');
        } else {
          doc.addContent('/Pattern cs');
          doc.addContent('/' + name + ' scn');
        }
      }
      function docBeginText(font, size) {
        if (!doc.page.fonts[font.id]) {doc.page.fonts[font.id] = font.ref();}
        doc.addContent('BT').addContent('/' + font.id + ' ' + size + ' Tf');
      }
      function docSetTextMatrix(a, b, c, d, e, f) {
        doc.addContent(validateNumber(a) + ' ' + validateNumber(b) + ' ' + validateNumber(-c) + ' '  + validateNumber(-d) + ' ' + validateNumber(e) + ' ' + validateNumber(f) + ' Tm');
      }
      function docSetTextMode(fill, stroke) {
        let mode = fill && stroke ? 2 : stroke ? 1 : fill ? 0 : 3;
        doc.addContent(mode + ' Tr');
      }
      function docWriteGlyph(glyph) {
        doc.addContent('<' + glyph + '> Tj');
      }
      function docEndText() {
        doc.addContent('ET');
      }
      function docFillColor(color) {
        if (color[0].constructor.name === 'PDFPattern') {
          doc.fillOpacity(color[1]);
          docUsePattern(color[0], false);
        } else {
          doc.fillColor(color[0], color[1]);
        }
      }
      function docStrokeColor(color) {
        if (color[0].constructor.name === 'PDFPattern') {
          doc.strokeOpacity(color[1]);
          docUsePattern(color[0], true);
        } else {
          doc.strokeColor(color[0], color[1]);
        }
      }
      function docInsertLink(x, y, w, h, url) {
        let ref = doc.ref({
          Type: 'Annot',
          Subtype: 'Link',
          Rect: [x, y, w, h],
          Border: [0, 0, 0],
          A: {
            S: 'URI',
            URI: new String(url)
          }
        });
        ref.end();
        links.push(ref);
      }
      function parseXml(xml) {
        let SvgNode = function(tag, type, value, error) {
          this.error = error;
          this.nodeName = tag;
          this.nodeValue = value;
          this.nodeType = type;
          this.attributes = Object.create(null);
          this.childNodes = [];
          this.parentNode = null;
          this.id = '';
          this.textContent = '';
          this.classList = [];
        };
        SvgNode.prototype.getAttribute = function(attr) {
          return this.attributes[attr] != null ? this.attributes[attr] : null;
        };
        SvgNode.prototype.getElementById = function(id) {
          let result = null;
          (function recursive(node) {
            if (result) {return;}
            if (node.nodeType === 1) {
              if (node.id === id) {result = node;}
              for (let i = 0; i < node.childNodes.length; i++) {
                recursive(node.childNodes[i]);
              }
            }
          })(this);
          return result;
        };
        SvgNode.prototype.getElementsByTagName = function(tag) {
          let result = [];
          (function recursive(node) {
            if (node.nodeType === 1) {
              if (node.nodeName === tag) {result.push(node);}
              for (let i = 0; i < node.childNodes.length; i++) {
                recursive(node.childNodes[i]);
              }
            }
          })(this);
          return result;
        };
        let parser = new StringParser(xml.trim()), result, child, error = false; 
        let recursive = function() {
          let temp, child;
          if (temp = parser.match(/^<([\w:.-]+)\s*/, true)) { // Opening tag
            let node = new SvgNode(temp[1], 1, null, error);
            while (temp = parser.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, true)) { // Attribute
              let attr = temp[1], value = decodeEntities(temp[2] || temp[3] || '');
              if (!node.attributes[attr]) {
                node.attributes[attr] = value;
                if (attr === 'id') {node.id = value;}
                if (attr === 'class') {node.classList = value.split(' ');}
              } else {
                warningCallback('parseXml: duplicate attribute "' + attr + '"');
                error = true;
              }
            }
            if (parser.match(/^>/)) { // End of opening tag
              while (child = recursive()) {
                node.childNodes.push(child);
                child.parentNode = node;
                node.textContent += (child.nodeType === 3 || child.nodeType === 4 ? child.nodeValue : child.textContent);
              }
              if (temp = parser.match(/^<\/([\w:.-]+)\s*>/, true)) { // Closing tag
                if (temp[1] === node.nodeName) {
                  return node;
                } else {
                  warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & closing "' + temp[1] + '"');
                  error = true;
                  return node;
                }
              } else {
                warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & not closing');
                error = true;
                return node;
              }
            } else if (parser.match(/^\/>/)) { // Self-closing tag
              return node;
            } else {
              warningCallback('parseXml: tag could not be parsed "' + node.nodeName + '"');
              error = true;
            }
          } else if (temp = parser.match(/^<!--[\s\S]*?-->/)) { // Comment
            return new SvgNode(null, 8, temp, error);
          } else if (temp = parser.match(/^<\?[\s\S]*?\?>/)) { // Processing instructions
            return new SvgNode(null, 7, temp, error);
          } else if (temp = parser.match(/^<!DOCTYPE\s*([\s\S]*?)>/)) { // Doctype
            return new SvgNode(null, 10, temp, error);
          } else if (temp = parser.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, true)) { // Cdata node
            return new SvgNode('#cdata-section', 4, temp[1], error);
          } else if (temp = parser.match(/^([^<]+)/, true)) { // Text node
            return new SvgNode('#text', 3, decodeEntities(temp[1]), error);
          }
        };
        while (child = recursive()) {
          if (child.nodeType === 1 && !result) {
            result = child;
          } else if (child.nodeType === 1 || (child.nodeType === 3 && child.nodeValue.trim() !== '')) {
            warningCallback('parseXml: data after document end has been discarded');
          }
        }
        if (parser.matchAll()) {
          warningCallback('parseXml: parsing error');
        }
        return result;
      };
      function decodeEntities(str) {
        return(str.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, function(mt, m0, m1, m2) {
          if (m0) {return String.fromCharCode(parseInt(m0, 10));}
          else if (m1) {return String.fromCharCode(parseInt(m1, 16));}
          else if (m2 && Entities[m2]) {return String.fromCharCode(Entities[m2]);}
          else {return mt;}
        }));
      }
      function parseColor(raw) {
        let temp, result;
        raw = (raw || '').trim();
        if (temp = NamedColors[raw]) {
          result = [temp.slice(), 1];
        } else if (temp = raw.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) {
          temp[1] = parseInt(temp[1]); temp[2] = parseInt(temp[2]); temp[3] = parseInt(temp[3]); temp[4] = parseFloat(temp[4]);
          if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256 && temp[4] <= 1) {
            result = [temp.slice(1, 4), temp[4]];
          }
        } else if (temp = raw.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) {
          temp[1] = parseInt(temp[1]); temp[2] = parseInt(temp[2]); temp[3] = parseInt(temp[3]);
          if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) {
            result = [temp.slice(1, 4), 1];
          }
        } else if (temp = raw.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) {
          temp[1] = 2.55 * parseFloat(temp[1]); temp[2] = 2.55 * parseFloat(temp[2]); temp[3] = 2.55 * parseFloat(temp[3]);
          if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) {
            result = [temp.slice(1, 4), 1];
          }
        } else if (temp = raw.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) {
          result = [[parseInt(temp[1], 16), parseInt(temp[2], 16), parseInt(temp[3], 16)], 1];
        } else if (temp = raw.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) {
          result = [[0x11 * parseInt(temp[1], 16), 0x11 * parseInt(temp[2], 16), 0x11 * parseInt(temp[3], 16)], 1];
        }
        return colorCallback ? colorCallback(result, raw) : result;
      }
      function opacityToColor(color, opacity, isMask) {
        let newColor = color[0].slice(),
            newOpacity = color[1] * opacity;
        if (isMask) {
          for (let i = 0; i < color.length; i++) {
            newColor[i] *= newOpacity;
          }
          return [newColor, 1];
        } else {
          return [newColor, newOpacity];
        }
      }
      function multiplyMatrix() {
        function multiply(a, b) {
          return [ a[0]*b[0]+a[2]*b[1], a[1]*b[0]+a[3]*b[1], a[0]*b[2]+a[2]*b[3],
                   a[1]*b[2]+a[3]*b[3], a[0]*b[4]+a[2]*b[5]+a[4], a[1]*b[4]+a[3]*b[5]+a[5] ];
        }
        let result = arguments[0];
        for (let i = 1; i < arguments.length; i++) {
          result = multiply(result, arguments[i]);
        }
        return result;
      }
      function transformPoint(p, m) {
        return [m[0] * p[0] + m[2] * p[1] + m[4], m[1] * p[0] + m[3] * p[1] + m[5]];
      }
      function getGlobalMatrix() {
        let ctm = doc._ctm;
        for (let i = groupStack.length - 1; i >= 0; i--) {
          ctm = multiplyMatrix(groupStack[i].savedMatrix, ctm);
        }
        return ctm;
      }
      function getPageBBox() {
        return new SvgShape().M(0, 0).L(doc.page.width, 0).L(doc.page.width, doc.page.height).L(0, doc.page.height)
                             .transform(inverseMatrix(getGlobalMatrix())).getBoundingBox();
      }
      function inverseMatrix(m) {
        let dt = m[0] * m[3] - m[1] * m[2];
        return [m[3] / dt, -m[1] / dt, -m[2] / dt, m[0] / dt, (m[2]*m[5] - m[3]*m[4]) / dt, (m[1]*m[4] - m[0]*m[5]) / dt];
      }
      function validateMatrix(m) {
        let m0 = validateNumber(m[0]), m1 = validateNumber(m[1]), m2 = validateNumber(m[2]),
            m3 = validateNumber(m[3]), m4 = validateNumber(m[4]), m5 = validateNumber(m[5]);
        if (isNotEqual(m0 * m3 - m1 * m2, 0)) {
          return [m0, m1, m2, m3, m4, m5];
        }
      }
      function solveEquation(curve) {
        let a = curve[2] || 0, b = curve[1] || 0, c = curve[0] || 0;
        if (isEqual(a, 0) && isEqual(b, 0)) {
          return [];
        } else if (isEqual(a, 0)) {
          return [(-c) / b];
        } else {
          let d = b * b - 4 * a * c;
          if (isNotEqual(d, 0) && d > 0) {
            return [(-b + Math.sqrt(d)) / (2 * a), (-b - Math.sqrt(d)) / (2 * a)];
          } else if (isEqual(d, 0)) {
            return [(-b) / (2 * a)];
          } else {
            return [];
          }
        }
      }
      function getCurveValue(t, curve) {
        return (curve[0] || 0) + (curve[1] || 0) * t + (curve[2] || 0) * t * t + (curve[3] || 0) * t * t * t;
      }
      function isEqual(number, ref) {
        return Math.abs(number - ref) < 1e-10;
      }
      function isNotEqual(number, ref) {
        return Math.abs(number - ref) >= 1e-10;
      }
      function validateNumber(n) {
        return n > -1e21 && n < 1e21 ? Math.round(n * 1e6) / 1e6 : 0;
      }
      function isArrayLike(v) {
        return typeof v === 'object' && v !== null && typeof v.length === 'number';
      }
      function parseTranform(v) {
        let parser = new StringParser((v || '').trim()), result = [1, 0, 0, 1, 0, 0], temp;
        while (temp = parser.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, true)) {
          let func = temp[1], nums = [], parser2 = new StringParser(temp[2].trim()), temp2;
          while (temp2 = parser2.matchNumber()) {
            nums.push(Number(temp2));
            parser2.matchSeparator();
          }
          if (func === 'matrix' && nums.length === 6) {
            result = multiplyMatrix(result, [nums[0], nums[1], nums[2], nums[3], nums[4], nums[5]]);
          } else if (func === 'translate' && nums.length === 2) {
            result = multiplyMatrix(result, [1, 0, 0, 1, nums[0], nums[1]]);
          } else if (func === 'translate' && nums.length === 1) {
            result = multiplyMatrix(result, [1, 0, 0, 1, nums[0], 0]);
          } else if (func === 'scale' && nums.length === 2) {
            result = multiplyMatrix(result, [nums[0], 0, 0, nums[1], 0, 0]);
          } else if (func === 'scale' && nums.length === 1) {
            result = multiplyMatrix(result, [nums[0], 0, 0, nums[0], 0, 0]);
          } else if (func === 'rotate' && nums.length === 3) {
            let a = nums[0] * Math.PI / 180;
            result = multiplyMatrix(result, [1, 0, 0, 1, nums[1], nums[2]], [Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0], [1, 0, 0, 1, -nums[1], -nums[2]]);
          } else if (func === 'rotate' && nums.length === 1) {
            let a = nums[0] * Math.PI / 180;
            result = multiplyMatrix(result, [Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0]);
          } else if (func === 'skewX' && nums.length === 1) {
            let a = nums[0] * Math.PI / 180;
            result = multiplyMatrix(result, [1, 0, Math.tan(a), 1, 0, 0]);
          } else if (func === 'skewY' && nums.length === 1) {
            let a = nums[0] * Math.PI / 180;
            result = multiplyMatrix(result, [1, Math.tan(a), 0, 1, 0, 0]);
          } else {return;}
          parser.matchSeparator();
        }
        if (parser.matchAll()) {return;}
        return result;
      }
      function parseAspectRatio(aspectRatio, availWidth, availHeight, elemWidth, elemHeight, initAlign) {
        let temp = (aspectRatio || '').trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [],
            ratioType = temp[1] || temp[4] || 'meet',
            xAlign = temp[2] || 'Mid',
            yAlign = temp[3] || 'Mid',
            scaleX = availWidth / elemWidth,
            scaleY = availHeight / elemHeight,
            dx = {'Min':0, 'Mid':0.5, 'Max':1}[xAlign] - (initAlign || 0),
            dy = {'Min':0, 'Mid':0.5, 'Max':1}[yAlign] - (initAlign || 0);
        if (ratioType === 'slice') {
          scaleY = scaleX = Math.max(scaleX, scaleY);
        } else if (ratioType === 'meet') {
          scaleY = scaleX = Math.min(scaleX, scaleY);
        }
        return [scaleX, 0, 0, scaleY, dx * (availWidth - elemWidth * scaleX), dy * (availHeight - elemHeight * scaleY)];
      }
      function parseStyleAttr(v) {
        let result = Object.create(null);
        v = (v || '').trim().split(/;/);
        for (let i = 0; i < v.length; i++) {
          let key = (v[i].split(':')[0] || '').trim(),
              value = (v[i].split(':')[1] || '').trim();
          if (key) {
            result[key] = value;
          }
        }
        if (result['marker']) {
          if (!result['marker-start']) {result['marker-start'] = result['marker'];}
          if (!result['marker-mid']) {result['marker-mid'] = result['marker'];}
          if (!result['marker-end']) {result['marker-end'] = result['marker'];}
        }
        if (result['font']) {
          let fontFamily = null, fontSize = null, fontStyle = "normal", fontWeight = "normal", fontVariant = "normal";
          let parts = result['font'].split(/\s+/);
          for (let i = 0; i < parts.length; i++) {
            switch (parts[i]) {
              case "normal":
                break;
              case "italic": case "oblique":
                fontStyle = parts[i];
                break;
              case "small-caps":
                fontVariant = parts[i];
                break;
              case "bold": case "bolder": case "lighter": case "100": case "200": case "300":
              case "400": case "500": case "600": case "700": case "800": case "900":
                fontWeight = parts[i];
                break;
              default:
                if (!fontSize) {
                  fontSize = parts[i].split('/')[0];
                } else {
                  if (!fontFamily) {
                    fontFamily = parts[i];
                  } else {
                    fontFamily += ' ' + parts[i];
                  }
                }
                break;
            }
          }
          if (!result['font-style']) {result['font-style'] = fontStyle;}
          if (!result['font-variant']) {result['font-variant'] = fontVariant;}
          if (!result['font-weight']) {result['font-weight'] = fontWeight;}
          if (!result['font-size']) {result['font-size'] = fontSize;}
          if (!result['font-family']) {result['font-family'] = fontFamily;}
        }
        return result;
      }
      function parseSelector(v) {
        let parts = v.split(/(?=[.#])/g), ids = [], classes = [], tags = [], temp;
        for (let i = 0; i < parts.length; i++) {
          if (temp = parts[i].match(/^[#]([_A-Za-z0-9-]+)$/)) {
            ids.push(temp[1]);
          } else if (temp = parts[i].match(/^[.]([_A-Za-z0-9-]+)$/)) {
            classes.push(temp[1]);
          } else if (temp = parts[i].match(/^([_A-Za-z0-9-]+)$/)) {
            tags.push(temp[1]);
          } else if (parts[i] !== '*') {
            return;
          }
        }
        return {
          tags: tags, ids: ids, classes: classes,
          specificity: ids.length * 10000 + classes.length * 100 + tags.length
        };
      }
      function parseStyleSheet(v) {
        let parser = new StringParser(v.trim()), rules = [], rule;
        while (rule = parser.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, true)) {
          let selectors = rule[1].split(/\s*,\s*/g),
              css = parseStyleAttr(rule[2]);
          for (let i = 0; i < selectors.length; i++) {
            let selector = parseSelector(selectors[i]);
            if (selector) {
              rules.push({selector: selector, css:css});
            }
          }
        }
        return rules;
      }
      function matchesSelector(elem, selector) {
        if (elem.nodeType !== 1) {return false;}
        for (let i = 0; i < selector.tags.length; i++) {
          if (selector.tags[i] !== elem.nodeName) {return false;}
        }
        for (let i = 0; i < selector.ids.length; i++) {
          if (selector.ids[i] !== elem.id) {return false;}
        }
        for (let i = 0; i < selector.classes.length; i++) {
          if (elem.classList.indexOf(selector.classes[i]) === -1) {return false;}
        }
        return true;
      }
      function getStyle(elem) {
        let result = Object.create(null);
        let specificities = Object.create(null);
        for (let i = 0; i < styleRules.length; i++) {
          let rule = styleRules[i];
          if (matchesSelector(elem, rule.selector)) {
            for (let key in rule.css) {
              if (!(specificities[key] > rule.selector.specificity)) {
                result[key] = rule.css[key];
                specificities[key] = rule.selector.specificity;
              }
            }
          }
        }
        return result;
      }
      function combineArrays(array1, array2) {
        return array1.concat(array2.slice(array1.length));
      }
      function getAscent(font, size) {
        return Math.max(font.ascender, (font.bbox[3] || font.bbox.maxY) * (font.scale || 1)) * size / 1000;
      }
      function getDescent(font, size) {
        return Math.min(font.descender, (font.bbox[1] || font.bbox.minY) * (font.scale || 1)) * size / 1000;
      }
      function getXHeight(font, size) {
        return (font.xHeight || 0.5 * (font.ascender - font.descender)) * size / 1000;
      }
      function getBaseline(font, size, baseline, shift) {
        let dy1, dy2;
        switch (baseline) {
          case 'middle': dy1 = 0.5 * getXHeight(font, size); break;
          case 'central': dy1 = 0.5 * (getDescent(font, size) + getAscent(font, size)); break;
          case 'after-edge': case 'text-after-edge': dy1 = getDescent(font, size); break;
          case 'alphabetic': case 'auto': case 'baseline': dy1 = 0; break;
          case 'mathematical': dy1 = 0.5 * getAscent(font, size); break;
          case 'hanging': dy1 = 0.8 * getAscent(font, size); break;
          case 'before-edge': case 'text-before-edge': dy1 = getAscent(font, size); break;
          default: dy1 = 0; break;
        }
        switch (shift) {
          case 'baseline': dy2 = 0; break;
          case 'super': dy2 = 0.6 * size; break;
          case 'sub': dy2 = -0.6 * size; break;
          default: dy2 = shift; break;
        }
        return dy1 - dy2;
      }
      function getTextPos(font, size, text) {
        let encoded = font.encode('' + text), hex = encoded[0], pos = encoded[1], data = [];
        for (let i = 0; i < hex.length; i++) {
          let unicode = font.unicode ? font.unicode[parseInt(hex[i], 16)] : [text.charCodeAt(i)];
          data.push({
            glyph: hex[i],
            unicode: unicode,
            width: pos[i].advanceWidth * size / 1000,
            xOffset: pos[i].xOffset * size / 1000,
            yOffset: pos[i].yOffset * size / 1000,
            xAdvance: pos[i].xAdvance * size / 1000,
            yAdvance: pos[i].yAdvance * size / 1000
          });
        }
        return data;
      }
      function createSVGElement(obj, inherits) {
        switch (obj.nodeName) {
          case 'use': return new SvgElemUse(obj, inherits);
          case 'symbol': return new SvgElemSymbol(obj, inherits);
          case 'g': return new SvgElemGroup(obj, inherits);
          case 'a': return new SvgElemLink(obj, inherits);
          case 'svg': return new SvgElemSvg(obj, inherits);
          case 'image': return new SVGElemImage(obj, inherits);
          case 'rect': return new SvgElemRect(obj, inherits);
          case 'circle': return new SvgElemCircle(obj, inherits);
          case 'ellipse': return new SvgElemEllipse(obj, inherits);
          case 'line': return new SvgElemLine(obj, inherits);
          case 'polyline': return new SvgElemPolyline(obj, inherits);
          case 'polygon': return new SvgElemPolygon(obj, inherits);
          case 'path': return new SvgElemPath(obj, inherits);
          case 'text': return new SvgElemText(obj, inherits);
          case 'tspan': return new SvgElemTspan(obj, inherits);
          case 'textPath': return new SvgElemTextPath(obj, inherits);
          case '#text': case '#cdata-section': return new SvgElemTextNode(obj, inherits);
          default: return new SvgElem(obj, inherits);
        }
      }

      var StringParser = function(str) {
        this.match = function(exp, all) {
          let temp = str.match(exp);
          if (!temp || temp.index !== 0) {return;}
          str = str.substring(temp[0].length);
          return (all ? temp : temp[0]);
        };
        this.matchSeparator = function() {
          return this.match(/^(?:\s*,\s*|\s*|)/);
        };
        this.matchSpace = function() {
          return this.match(/^(?:\s*)/);
        };
        this.matchLengthUnit = function() {
          return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
        };
        this.matchNumber = function() {
          return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
        };
        this.matchAll = function() {
          return this.match(/^[\s\S]+/);
        };
      };

      var BezierSegment = function(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        let divisions = 6 * precision;
        let equationX = [p1x, -3 * p1x + 3 * c1x, 3 * p1x - 6 * c1x + 3 * c2x, -p1x + 3 * c1x - 3 * c2x + p2x];
        let equationY = [p1y, -3 * p1y + 3 * c1y, 3 * p1y - 6 * c1y + 3 * c2y, -p1y + 3 * c1y - 3 * c2y + p2y];
        let derivativeX = [-3 * p1x + 3 * c1x, 6 * p1x - 12 * c1x + 6 * c2x, -3 * p1x + 9 * c1x - 9 * c2x + 3 * p2x];
        let derivativeY = [-3 * p1y + 3 * c1y, 6 * p1y - 12 * c1y + 6 * c2y, -3 * p1y + 9 * c1y - 9 * c2y + 3 * p2y];
        let lengthMap = [0];
        for (let i = 1; i <= divisions; i++) {
          let t = (i - 0.5) / divisions;
          let dx = getCurveValue(t, derivativeX) / divisions,
              dy = getCurveValue(t, derivativeY) / divisions,
              l = Math.sqrt(dx * dx + dy * dy);
          lengthMap[i] = lengthMap[i - 1] + l;
        }
        this.totalLength = lengthMap[divisions];
        this.startPoint = [p1x, p1y, isEqual(p1x, c1x) && isEqual(p1y, c1y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(c1y - p1y, c1x - p1x)];
        this.endPoint = [p2x, p2y, isEqual(c2x, p2x) && isEqual(c2y, p2y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(p2y - c2y, p2x - c2x)];
        this.getBoundingBox = function() {
          let temp;
          let minX = getCurveValue(0, equationX), minY = getCurveValue(0, equationY),
              maxX = getCurveValue(1, equationX), maxY = getCurveValue(1, equationY);
          if (minX > maxX) {temp = maxX; maxX = minX; minX = temp;}
          if (minY > maxY) {temp = maxY; maxY = minY; minY = temp;}
          let rootsX = solveEquation(derivativeX);
          for (let i = 0; i < rootsX.length; i++) {
            if (rootsX[i] >= 0 && rootsX[i] <= 1) {
              let x = getCurveValue(rootsX[i], equationX);
              if (x < minX) {minX = x;}
              if (x > maxX) {maxX = x;}
            }
          }
          let rootsY = solveEquation(derivativeY);
          for (let i = 0; i < rootsY.length; i++) {
            if (rootsY[i] >= 0 && rootsY[i] <= 1) {
              let y = getCurveValue(rootsY[i], equationY);
              if (y < minY) {minY = y;}
              if (y > maxY) {maxY = y;}
            }
          }
          return [minX, minY, maxX, maxY];
        };
        this.getPointAtLength = function(l) {
          if (isEqual(l, 0)) {return this.startPoint;}
          if (isEqual(l, this.totalLength)) {return this.endPoint;}
          if (l < 0 || l > this.totalLength) {return;}
          for (let i = 1; i <= divisions; i++) {
            let l1 = lengthMap[i-1], l2 = lengthMap[i];
            if (l1 <= l && l <= l2) {
              let t = (i - (l2 - l) / (l2 - l1)) / divisions,
                  x = getCurveValue(t, equationX), y = getCurveValue(t, equationY),
                  dx = getCurveValue(t, derivativeX), dy = getCurveValue(t, derivativeY);
              return [x, y, Math.atan2(dy, dx)];
            }
          }
        };
      };

      var LineSegment = function(p1x, p1y, p2x, p2y) {
        this.totalLength = Math.sqrt((p2x - p1x) * (p2x - p1x) + (p2y - p1y) * (p2y - p1y));
        this.startPoint = [p1x, p1y, Math.atan2(p2y - p1y, p2x - p1x)];
        this.endPoint = [p2x, p2y, Math.atan2(p2y - p1y, p2x - p1x)];
        this.getBoundingBox = function() {
          return [Math.min(this.startPoint[0], this.endPoint[0]), Math.min(this.startPoint[1], this.endPoint[1]),
                  Math.max(this.startPoint[0], this.endPoint[0]), Math.max(this.startPoint[1], this.endPoint[1])];
        };
        this.getPointAtLength = function(l) {
          if (l >= 0 && l <= this.totalLength) {
            let r = l / this.totalLength || 0,
                x = this.startPoint[0] + r * (this.endPoint[0] - this.startPoint[0]),
                y = this.startPoint[1] + r * (this.endPoint[1] - this.startPoint[1]);
            return [x, y, this.startPoint[2]];
          }
        };
      };

      var SvgShape = function() {
        this.pathCommands = [];
        this.pathSegments = [];
        this.startPoint = null;
        this.endPoint = null;
        this.totalLength = 0;
        let startX = 0, startY = 0, currX = 0, currY = 0, lastCom, lastCtrlX, lastCtrlY;
        this.move = function(x, y) {
          startX = currX = x; startY = currY = y;
          return null;
        };
        this.line = function(x, y) {
          let segment = new LineSegment(currX, currY, x, y);
          currX = x; currY = y;
          return segment;
        };
        this.curve = function(c1x, c1y, c2x, c2y, x, y) {
          let segment = new BezierSegment(currX, currY, c1x, c1y, c2x, c2y, x, y);
          currX = x; currY = y;
          return segment;
        };
        this.close = function() {
          let segment = new LineSegment(currX, currY, startX, startY);
          currX = startX; currY = startY;
          return segment;
        };
        this.addCommand = function(data) {
          this.pathCommands.push(data);
          let segment = this[data[0]].apply(this, data.slice(3));
          if (segment) {
            segment.hasStart = data[1];
            segment.hasEnd = data[2];
            this.startPoint = this.startPoint || segment.startPoint;
            this.endPoint = segment.endPoint;
            this.pathSegments.push(segment);
            this.totalLength += segment.totalLength;
          }
        };
        this.M = function(x, y) {
          this.addCommand(['move', true, true, x, y]);
          lastCom = 'M';
          return this;
        };
        this.m = function(x, y) {
          return this.M(currX + x, currY + y);
        };
        this.Z = this.z = function() {
          this.addCommand(['close', true, true]);
          lastCom = 'Z';
          return this;
        };
        this.L = function(x, y) {
          this.addCommand(['line', true, true, x, y]);
          lastCom = 'L';
          return this;
        };
        this.l = function(x, y) {
          return this.L(currX + x, currY + y);
        };
        this.H = function(x) {
          return this.L(x, currY);
        };
        this.h = function(x) {
          return this.L(currX + x, currY);
        };
        this.V = function(y) {
          return this.L(currX, y);
        };
        this.v = function(y) {
          return this.L(currX, currY + y);
        };
        this.C = function(c1x, c1y, c2x, c2y, x, y) {
          this.addCommand(['curve', true, true, c1x, c1y, c2x, c2y, x, y]);
          lastCom = 'C'; lastCtrlX = c2x; lastCtrlY = c2y;
          return this;
        };
        this.c = function(c1x, c1y, c2x, c2y, x, y) {
          return this.C(currX + c1x, currY + c1y, currX + c2x, currY + c2y, currX + x, currY + y);
        };
        this.S = function(c1x, c1y, x, y) {
          return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), c1x, c1y, x, y);
        };
        this.s = function(c1x, c1y, x, y) {
          return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), currX + c1x, currY + c1y, currX + x, currY + y);
        };
        this.Q = function(cx, cy, x, y) {
          let c1x = currX + 2 / 3 * (cx - currX), c1y = currY + 2 / 3 * (cy - currY),
              c2x = x + 2 / 3 * (cx - x), c2y = y + 2 / 3 * (cy - y);
          this.addCommand(['curve', true, true, c1x, c1y, c2x, c2y, x, y]);
          lastCom = 'Q'; lastCtrlX = cx; lastCtrlY = cy;
          return this;
        };
        this.q = function(c1x, c1y, x, y) {
          return this.Q(currX + c1x, currY + c1y, currX + x, currY + y);
        };
        this.T = function(x, y) {
          return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), x, y);
        };
        this.t = function(x, y) {
          return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), currX + x, currY + y);
        };
        this.A = function(rx, ry, fi, fa, fs, x, y) {
          if (isEqual(rx, 0) || isEqual(ry, 0)) {
            this.addCommand(['line', true, true, x, y]);
          } else {
            fi = fi * (Math.PI / 180);
            rx = Math.abs(rx);
            ry = Math.abs(ry);
            fa = 1 * !!fa;
            fs = 1 * !!fs;
            let x1 = Math.cos(fi) * (currX - x) / 2 + Math.sin(fi) * (currY - y) / 2,
                y1 = Math.cos(fi) * (currY - y) / 2 - Math.sin(fi) * (currX - x) / 2,
                lambda = (x1 * x1) / (rx * rx) + (y1 * y1) / (ry * ry);
            if (lambda > 1) {
              rx *= Math.sqrt(lambda);
              ry *= Math.sqrt(lambda);
            }
            let r = Math.sqrt(Math.max(0, rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1)),
                x2 = (fa === fs ? -1 : 1) * r * rx * y1 / ry,
                y2 = (fa === fs ? 1 : -1) * r * ry * x1 / rx;
            let cx = Math.cos(fi) * x2 - Math.sin(fi) * y2 + (currX + x) / 2,
                cy = Math.sin(fi) * x2 + Math.cos(fi) * y2 + (currY + y) / 2,
                th1 = Math.atan2((y1 - y2) / ry, (x1 - x2) / rx),
                th2 = Math.atan2((-y1 - y2) / ry, (-x1 - x2) / rx);
            if (fs === 0 && th2 - th1 > 0) {
              th2 -= 2 * Math.PI;
            } else if (fs === 1 && th2 - th1 < 0) {
              th2 += 2 * Math.PI;
            }
            let segms = Math.ceil(Math.abs(th2 - th1) / (Math.PI / precision));
            for (let i = 0; i < segms; i++) {
              let th3 = th1 + i * (th2 - th1) / segms,
                  th4 = th1 + (i + 1) * (th2 - th1) / segms,
                  t = 4/3 * Math.tan((th4 - th3) / 4);
              let c1x = cx + Math.cos(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) - Math.sin(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)),
                  c1y = cy + Math.sin(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) + Math.cos(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)),
                  c2x = cx + Math.cos(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) - Math.sin(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)),
                  c2y = cy + Math.sin(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) + Math.cos(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)),
                  endX = cx + Math.cos(fi) * rx * Math.cos(th4) - Math.sin(fi) * ry * Math.sin(th4),
                  endY = cy + Math.sin(fi) * rx * Math.cos(th4) + Math.cos(fi) * ry * Math.sin(th4);
              this.addCommand(['curve', (i === 0), (i === segms - 1), c1x, c1y, c2x, c2y, endX, endY]);
            }
          }
          lastCom = 'A';
          return this;
        };
        this.a = function(rx, ry, fi, fa, fs, x, y) {
          return this.A(rx, ry, fi, fa, fs, currX + x, currY + y);
        };
        this.path = function(d) {
          let command, value, temp,
              parser = new StringParser((d || '').trim());
          while (command = parser.match(/^[astvzqmhlcASTVZQMHLC]/)) {
            parser.matchSeparator();
            let values = [];
            while (value = (PathFlags[command + values.length] ? parser.match(/^[01]/) : parser.matchNumber())) {
              parser.matchSeparator();
              if (values.length === PathArguments[command]) {
                this[command].apply(this, values);
                values = [];
                if (command === 'M') {command = 'L';}
                else if (command === 'm') {command = 'l';}
              }
              values.push(Number(value));
            }
            if (values.length === PathArguments[command]) {
              this[command].apply(this, values);
            } else {
              warningCallback('SvgPath: command ' + command + ' with ' + values.length + ' numbers'); return;
            }
          }
          if (temp = parser.matchAll()) {
            warningCallback('SvgPath: unexpected string ' + temp);
          }
          return this;
        };
        this.getBoundingBox = function() {
          let bbox = [Infinity, Infinity, -Infinity, -Infinity];
          function addBounds(bbox1) {
            if (bbox1[0] < bbox[0]) {bbox[0] = bbox1[0];}
            if (bbox1[2] > bbox[2]) {bbox[2] = bbox1[2];}
            if (bbox1[1] < bbox[1]) {bbox[1] = bbox1[1];}
            if (bbox1[3] > bbox[3]) {bbox[3] = bbox1[3];}
          }
          for (let i = 0; i < this.pathSegments.length; i++) {
            addBounds(this.pathSegments[i].getBoundingBox());
          }
          if (bbox[0] === Infinity) {bbox[0] = 0;}
          if (bbox[1] === Infinity) {bbox[1] = 0;}
          if (bbox[2] === -Infinity) {bbox[2] = 0;}
          if (bbox[3] === -Infinity) {bbox[3] = 0;}
          return bbox;
        };
        this.getPointAtLength = function(l) {
          if (l >= 0 && l <= this.totalLength) {
            let temp;
            for (let i = 0; i < this.pathSegments.length; i++) {
              if (temp = this.pathSegments[i].getPointAtLength(l)) {
                return temp;
              }
              l -= this.pathSegments[i].totalLength;
            }
            return this.endPoint;
          }
        };
        this.transform = function(m) {
          this.pathSegments = [];
          this.startPoint = null;
          this.endPoint = null;
          this.totalLength = 0;
          for (let i = 0; i < this.pathCommands.length; i++) {
            let data = this.pathCommands.shift();
            for (let j = 3; j < data.length; j+=2) {
              let p = transformPoint([data[j], data[j + 1]], m)
              data[j] = p[0];
              data[j + 1] = p[1];
            }
            this.addCommand(data);
          }
          return this;        
        };
        this.mergeShape = function(shape) {
          for (let i = 0; i < shape.pathCommands.length; i++) {
            this.addCommand(shape.pathCommands[i].slice());
          }
          return this;
        };
        this.clone = function() {
          return new SvgShape().mergeShape(this);
        };
        this.insertInDocument = function() {
          for (let i = 0; i < this.pathCommands.length; i++) {
            let command = this.pathCommands[i][0], values = this.pathCommands[i].slice(3);
            switch(command) {
              case 'move':  doc.moveTo(values[0], values[1]);  break;
              case 'line':  doc.lineTo(values[0], values[1]);  break;
              case 'curve':  doc.bezierCurveTo(values[0], values[1], values[2], values[3], values[4], values[5]);  break;
              case 'close':  doc.closePath();  break;
            }
          }
        };
        this.getSubPaths = function() {
          let subPaths = [], shape = new SvgShape();
          for (let i = 0; i < this.pathCommands.length; i++) {
            let data = this.pathCommands[i], command = this.pathCommands[i][0];
            if (command === 'move' && i !== 0) {
              subPaths.push(shape);
              shape = new SvgShape();
            }
            shape.addCommand(data);
          }
          subPaths.push(shape);
          return subPaths;
        };
        this.getMarkers = function() {
          let markers = [], subPaths = this.getSubPaths();
          for (let i = 0; i < subPaths.length; i++) {
            let subPath = subPaths[i], subPathMarkers = [];
            for (let j = 0; j < subPath.pathSegments.length; j++) {
              let segment = subPath.pathSegments[j];
              if (isNotEqual(segment.totalLength, 0) || j === 0 || j === subPath.pathSegments.length - 1) {
                if (segment.hasStart) {
                  let startMarker = segment.getPointAtLength(0), prevEndMarker = subPathMarkers.pop();
                  if (prevEndMarker) {startMarker[2] = 0.5 * (prevEndMarker[2] + startMarker[2]);}
                  subPathMarkers.push(startMarker);
                }
                if (segment.hasEnd) {
                  let endMarker = segment.getPointAtLength(segment.totalLength);
                  subPathMarkers.push(endMarker);
                }
              }
            }
            markers = markers.concat(subPathMarkers);
          }
          return markers;
        };
      };

      var SvgElem = function(obj, inherits) {
        let styleCache = Object.create(null);
        let childrenCache = null;
        this.name = obj.nodeName;
        this.isOuterElement = obj === svg || !obj.parentNode;
        this.inherits = inherits || (!this.isOuterElement ? createSVGElement(obj.parentNode, null) : null);
        this.stack = (this.inherits ? this.inherits.stack.concat(obj) : [obj]);
        this.style = parseStyleAttr(typeof obj.getAttribute === 'function' && obj.getAttribute('style'));
        this.css = useCSS ? getComputedStyle(obj) : getStyle(obj);
        this.allowedChildren = [];
        this.attr = function(key) {
          if (typeof obj.getAttribute === 'function') {
            return obj.getAttribute(key);
          }
        };
        this.resolveUrl = function(value) {
          let temp = (value || '').match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [];
          let file = temp[1] || temp[3] || temp[5] || temp[7],
              id = temp[2] || temp[4] || temp[6] || temp[8];
          if (id) {
            if (!file) {
              let svgObj = svg.getElementById(id);
              if (svgObj) {
                if (this.stack.indexOf(svgObj) === -1) {
                  return svgObj;
                } else {
                  warningCallback('SVGtoPDF: loop of circular references for id "' + id + '"');
                  return;
                }
              }
            }
            if (documentCallback) {
              let svgs = documentCache[file];
              if (!svgs) {
                svgs = documentCallback(file);
                if (!isArrayLike(svgs)) {svgs = [svgs];}
                for (let i = 0; i < svgs.length; i++) {
                  if (typeof svgs[i] === 'string') {svgs[i] = parseXml(svgs[i]);}
                }
                documentCache[file] = svgs;
              }
              for (let i = 0; i < svgs.length; i++) {
                let svgObj = svgs[i].getElementById(id);
                if (svgObj) {
                  if (this.stack.indexOf(svgObj) === -1) {
                    return svgObj;
                  } else {
                    warningCallback('SVGtoPDF: loop of circular references for id "' + file + '#' + id + '"');
                    return;
                  }
                }
              }
            }
          }
        };
        this.computeUnits = function(value, unit, percent, isFontSize) {
          if (unit === '%') {
            return parseFloat(value) / 100 * (isFontSize || percent != null ? percent : this.getViewport());
          } else if (unit === 'ex' || unit === 'em') {
            return value * {'em':1, 'ex':0.5}[unit] * (isFontSize ? percent : this.get('font-size'));
          } else {
            return value * {'':1, 'px':1, 'pt':96/72, 'cm':96/2.54, 'mm':96/25.4, 'in':96, 'pc':96/6}[unit];
          }
        };
        this.computeLength = function(value, percent, initial, isFontSize) {
          let parser = new StringParser((value || '').trim()), temp1, temp2;
          if (typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string' && !parser.matchAll()) {
            return this.computeUnits(temp1, temp2, percent, isFontSize);
          }
          return initial;
        };
        this.computeLengthList = function(value, percent, strict) {
          let parser = new StringParser((value || '').trim()), result = [], temp1, temp2;
          while (typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string') {
            result.push(this.computeUnits(temp1, temp2, percent));
            parser.matchSeparator();
          }
          if (strict && parser.matchAll()) {return;}
          return result;
        };
        this.getLength = function(key, percent, initial) {
          return this.computeLength(this.attr(key), percent, initial);
        };
        this.getLengthList = function(key, percent) {
          return this.computeLengthList(this.attr(key), percent);
        };
        this.getUrl = function(key) {
          return this.resolveUrl(this.attr(key))
        };
        this.getNumberList = function(key) {
          let parser = new StringParser((this.attr(key) || '').trim()), result = [], temp;
          while (temp = parser.matchNumber()) {
            result.push(Number(temp));
            parser.matchSeparator();
          }
          result.error = parser.matchAll();
          return result;
        }
        this.getViewbox = function(key, initial) {
          let viewBox = this.getNumberList(key);
          if (viewBox.length === 4 && viewBox[2] >= 0 && viewBox[3] >= 0) {return viewBox;}
          return initial;
        };
        this.getPercent = function(key, initial) {
          let value = this.attr(key);
          let parser = new StringParser((value || '').trim()), temp1, temp2;
          let number = parser.matchNumber();
          if (!number) {return initial;}
          if (parser.match('%')) {number *= 0.01;}
          if (parser.matchAll()) {return initial;}
          return Math.max(0, Math.min(1, number));
        };
        this.chooseValue = function(args) {
          for (let i = 0; i < arguments.length; i++) {
            if (arguments[i] != null && arguments[i] === arguments[i]) {return arguments[i];}
          }
          return arguments[arguments.length - 1];
        };
        this.get = function(key) {
          if (styleCache[key] !== undefined) {return styleCache[key];}
          let keyInfo = Properties[key] || {}, value, result;
          for (let i = 0; i < 3; i++) {
            switch (i) {
              case 0:
                if (key !== 'transform') { // the CSS transform behaves strangely
                  value = this.css[keyInfo.css || key];
                }
                break;
              case 1:
                value = this.style[key];
                break;
              case 2:
                value = this.attr(key);
                break;
            }
            if (value === 'inherit') {
              result = (this.inherits ? this.inherits.get(key) : keyInfo.initial);
              if (result != null) {return styleCache[key] = result;}
            }
            if (keyInfo.values != null) {
              result = keyInfo.values[value];
              if (result != null) {return styleCache[key] = result;}
            }
            if (value != null) {
              let parsed;
              switch (key) {
                case 'font-size':
                  result = this.computeLength(value, this.inherits ? this.inherits.get(key) : keyInfo.initial, undefined, true);
                  break;
                case 'baseline-shift':
                  result = this.computeLength(value, this.get('font-size'));
                  break;
                case 'font-family':
                  result = value || undefined;
                  break;
                case 'opacity': case 'stroke-opacity': case 'fill-opacity': case 'stop-opacity':
                  parsed = parseFloat(value);
                  if (!isNaN(parsed)) {
                    result = Math.max(0, Math.min(1, parsed));
                  }
                  break;
                case 'transform':
                  result = parseTranform(value);
                  break;
                case 'stroke-dasharray':
                  if (value === 'none') {
                    result = [];
                  } else if (parsed = this.computeLengthList(value, this.getViewport(), true)) {
                    let sum = 0, error = false;
                    for (let j = 0; j < parsed.length; j++) {
                      if (parsed[j] < 0) {error = true;}
                      sum += parsed[j];
                    }
                    if (!error) {
                      if (parsed.length % 2 === 1) {
                        parsed = parsed.concat(parsed);
                      }
                      result = (sum === 0 ? [] : parsed);
                    }
                  }
                  break;
                case 'color':
                  if (value === 'none' || value === 'transparent') {
                    result = 'none';
                  } else {
                    result = parseColor(value);
                  }
                  break;
                case 'fill': case 'stroke':
                  if (value === 'none' || value === 'transparent') {
                    result = 'none';
                  } else if (value === 'currentColor') {
                    result = this.get('color');
                  } else if (parsed = parseColor(value)) {
                    return parsed;
                  } else if (parsed = (value || '').split(' ')) {
                    let object = this.resolveUrl(parsed[0]),
                        fallbackColor = parseColor(parsed[1]);
                    if (object == null) {
                      result = fallbackColor;
                    } else if (object.nodeName === 'linearGradient' || object.nodeName === 'radialGradient') {
                      result = new SvgElemGradient(object, null, fallbackColor);
                    } else if (object.nodeName === 'pattern') {
                      result = new SvgElemPattern(object, null, fallbackColor);
                    } else {
                      result = fallbackColor;
                    }
                  }
                  break;
                case 'stop-color':
                  if (value === 'none' || value === 'transparent') {
                    result = 'none';
                  } else if (value === 'currentColor') {
                    result = this.get('color');
                  } else {
                    result = parseColor(value);
                  }
                  break;
                case 'marker-start': case 'marker-mid': case 'marker-end': case 'clip-path': case 'mask':
                  if (value === 'none') {
                    result = 'none';
                  } else {
                    result = this.resolveUrl(value);
                  }
                  break;
                case 'stroke-width':
                  parsed = this.computeLength(value, this.getViewport());
                  if (parsed != null && parsed >= 0) {
                    result = parsed;
                  }
                  break;
                case 'stroke-miterlimit':
                  parsed = parseFloat(value);
                  if (parsed != null && parsed >= 1) {
                    result = parsed;
                  }
                  break;
                case 'word-spacing': case 'letter-spacing':
                  result = this.computeLength(value, this.getViewport());
                  break;
                case 'stroke-dashoffset':
                  result = this.computeLength(value, this.getViewport());
                  if (result != null) {
                    if (result < 0) { // fix for crbug.com/660850
                      let dasharray = this.get('stroke-dasharray');
                      for (let j = 0; j < dasharray.length; j++) {result += dasharray[j];}
                    }
                  }
                  break;
              }
              if (result != null) {return styleCache[key] = result;}
            }
          }
          return styleCache[key] = (keyInfo.inherit && this.inherits ? this.inherits.get(key) : keyInfo.initial);
        };
        this.getChildren = function() {
          if (childrenCache != null) {return childrenCache;}
          let children = [];
          for (let i = 0; i < obj.childNodes.length; i++) {
            let child = obj.childNodes[i];
            if (!child.error && this.allowedChildren.indexOf(child.nodeName) !== -1) {
              children.push(createSVGElement(child, this));
            }
          }
          return childrenCache = children;
        };
        this.getParentVWidth = function() {
          return (this.inherits ? this.inherits.getVWidth(): viewportWidth);
        };
        this.getParentVHeight = function() {
          return (this.inherits ? this.inherits.getVHeight() : viewportHeight);
        };
        this.getParentViewport = function() {
          return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
        };
        this.getVWidth = function() {
          return this.getParentVWidth();
        };
        this.getVHeight = function() {
          return this.getParentVHeight();
        };
        this.getViewport = function() {
          return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
        };
        this.getBoundingBox = function() {
          let shape = this.getBoundingShape();
          return shape.getBoundingBox();
        };
      };

      var SvgElemStylable = function(obj, inherits) {
        SvgElem.call(this, obj, inherits);
        this.transform = function() {
          doc.transform.apply(doc, this.getTransformation());
        };
        this.clip = function() {
          if (this.get('clip-path') !== 'none') {
            let clipPath = new SvgElemClipPath(this.get('clip-path'), null);
            clipPath.useMask(this.getBoundingBox());
            return true;
          }
        };
        this.mask = function() {
          if (this.get('mask') !== 'none') {
            let mask = new SvgElemMask(this.get('mask'), null);
            mask.useMask(this.getBoundingBox());
            return true;
          }
        };
        this.getFill = function(isClip, isMask) {
          let opacity = this.get('opacity'),
              fill = this.get('fill'),
              fillOpacity = this.get('fill-opacity');
          if (isClip) {return DefaultColors.white;}
          if (fill !== 'none' && opacity && fillOpacity) {
            if (fill instanceof SvgElemGradient || fill instanceof SvgElemPattern) {
              return fill.getPaint(this.getBoundingBox(), fillOpacity * opacity, isClip, isMask);
            }
            return opacityToColor(fill, fillOpacity * opacity, isMask);
          }
        };
        this.getStroke = function(isClip, isMask) {
          let opacity = this.get('opacity'),
              stroke = this.get('stroke'),
              strokeOpacity = this.get('stroke-opacity');
          if (isClip || isEqual(this.get('stroke-width'), 0)) {return;}
          if (stroke !== 'none' && opacity && strokeOpacity) {
            if (stroke instanceof SvgElemGradient || stroke instanceof SvgElemPattern) {
              return stroke.getPaint(this.getBoundingBox(), strokeOpacity * opacity, isClip, isMask);
            }
            return opacityToColor(stroke, strokeOpacity * opacity, isMask);
          }
        };
      };

      var SvgElemHasChildren = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        this.allowedChildren = ['use', 'g', 'a', 'svg', 'image', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'path', 'text'];
        this.getBoundingShape = function() {
          let shape = new SvgShape(),
              children = this.getChildren();
          for (let i = 0; i < children.length; i++) {
            if (children[i].get('display') !== 'none') {
              if (typeof children[i].getBoundingShape === 'function') {
                let childShape = children[i].getBoundingShape().clone();
                if (typeof children[i].getTransformation === 'function') {
                  childShape.transform(children[i].getTransformation());
                }
                shape.mergeShape(childShape);
              }
            }
          }
          return shape;
        };
        this.drawChildren = function(isClip, isMask) {
          let children = this.getChildren();
          for (let i = 0; i < children.length; i++) {
            if (children[i].get('display') !== 'none') {
              if (typeof children[i].drawInDocument === 'function') {
                children[i].drawInDocument(isClip, isMask);
              }
            }
          }
        };
      };

      var SvgElemContainer = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.drawContent = function(isClip, isMask) {
          this.transform();
          let clipped = this.clip(),
              masked = this.mask(),
              group;
          if ((this.get('opacity') < 1 || clipped || masked) && !isClip) {
            group = docBeginGroup(getPageBBox());
          }
          this.drawChildren(isClip, isMask);
          if (group) {
            docEndGroup(group);
            doc.fillOpacity(this.get('opacity'));
            docInsertGroup(group);
          }
        };
      };

      var SvgElemUse = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        let x = this.getLength('x', this.getVWidth(), 0),
            y = this.getLength('y', this.getVHeight(), 0),
            child = this.getUrl('href') || this.getUrl('xlink:href');
        if (child) {child = createSVGElement(child, this);}
        this.getChildren  = function() {
          return child ? [child] : [];
        };
        this.drawInDocument = function(isClip, isMask) {
          doc.save();
          this.drawContent(isClip, isMask);
          doc.restore();
        };
        this.getTransformation = function() {
          return multiplyMatrix(this.get('transform'), [1, 0, 0, 1, x, y]);
        };
      };

      var SvgElemSymbol = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        let width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth()),
            height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight());
        if (inherits instanceof SvgElemUse) {
          width = inherits.getLength('width', inherits.getParentVWidth(), width);
          height = inherits.getLength('height', inherits.getParentVHeight(), height);
        }
        let aspectRatio = (this.attr('preserveAspectRatio') || '').trim(),
            viewBox = this.getViewbox('viewBox', [0, 0, width, height]);
        this.getVWidth = function() {
          return viewBox[2];
        };
        this.getVHeight = function() {
          return viewBox[3];
        };
        this.drawInDocument = function(isClip, isMask) {
          doc.save();
          this.drawContent(isClip, isMask);
          doc.restore();
        };
        this.getTransformation = function() {
          return multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [1, 0, 0, 1, -viewBox[0], -viewBox[1]]);
        };
      };

      var SvgElemGroup = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        this.drawInDocument = function(isClip, isMask) {
          doc.save();
          if (this.link && !isClip && !isMask) {this.addLink();}
          this.drawContent(isClip, isMask);
          doc.restore();
        };
        this.getTransformation = function() {
          return this.get('transform');
        };
      };

      var SvgElemLink = function(obj, inherits) {
        if (inherits && inherits.isText) {
          SvgElemTspan.call(this, obj, inherits);
          this.allowedChildren = ['textPath', 'tspan', '#text', '#cdata-section', 'a'];
        } else {
          SvgElemGroup.call(this, obj, inherits);
        }
        this.link = this.attr('href') || this.attr('xlink:href');
        this.addLink = function() {
          if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
            let bbox = this.getBoundingShape().transform(getGlobalMatrix()).getBoundingBox();
            docInsertLink(bbox[0], bbox[1], bbox[2], bbox[3], this.link);
          }
        }
      };

      var SvgElemSvg = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        let width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth()),
            height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight()),
            x = this.getLength('x', this.getParentVWidth(), 0),
            y = this.getLength('y', this.getParentVHeight(), 0);
        if (inherits instanceof SvgElemUse) {
          width = inherits.getLength('width', inherits.getParentVWidth(), width);
          height = inherits.getLength('height', inherits.getParentVHeight(), height);
        }
        let aspectRatio = this.attr('preserveAspectRatio'),
            viewBox = this.getViewbox('viewBox', [0, 0, width, height]);
        if (this.isOuterElement && preserveAspectRatio) {
          x = y = 0;
          width = viewportWidth;
          height = viewportHeight;
          aspectRatio = preserveAspectRatio;
        }
        this.getVWidth = function() {
          return viewBox[2];
        };
        this.getVHeight = function() {
          return viewBox[3];
        };
        this.drawInDocument = function(isClip, isMask) {
          doc.save();
          if (this.get('overflow') === 'hidden') {
            new SvgShape().M(x, y).L(x + width, y).L(x + width, y + height).L(x, y + height).Z()
                          .transform(this.get('transform'))
                          .insertInDocument();
            doc.clip();
          }
          this.drawContent(isClip, isMask);
          doc.restore();
        };
        this.getTransformation = function() {
          return multiplyMatrix(
            this.get('transform'),
            [1, 0, 0, 1, x, y],
            parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]),
            [1, 0, 0, 1, -viewBox[0], -viewBox[1]]
          );
        };
      };

      var SVGElemImage = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        let link = imageCallback(this.attr('href') || this.attr('xlink:href') || ''),
            x = this.getLength('x', this.getVWidth(), 0),
            y = this.getLength('y', this.getVHeight(), 0),
            width = this.getLength('width', this.getVWidth(), 'auto'),
            height = this.getLength('height', this.getVHeight(), 'auto'),
            image;
        try {
          image = doc.openImage(link);
        } catch(e) {
          warningCallback('SVGElemImage: failed to open image "' + link + '" in PDFKit');
        }
        if (image) {
          if (width === 'auto' && height !== 'auto') {
            width = height * image.width / image.height;
          } else if (height === 'auto' && width !== 'auto') {
            height = width * image.height / image.width;
          } else if (width === 'auto' && height === 'auto') {
            width = image.width;
            height = image.height;
          }
        }
        if (width === 'auto' || width < 0) {width = 0;}
        if (height === 'auto' || height < 0) {height = 0;}
        this.getTransformation = function() {
          return this.get('transform');
        };
        this.getBoundingShape = function() {
          return new SvgShape().M(x, y).L(x + width, y).M(x + width, y + height).L(x, y + height);
        };
        this.drawInDocument = function(isClip, isMask) {
          if (this.get('visibility') === 'hidden' || !image) {return;}
          doc.save();
          this.transform();
          if (this.get('overflow') === 'hidden') {
            doc.rect(x, y, width, height).clip();
          }
          this.clip();
          this.mask();
          doc.translate(x, y);
          doc.transform.apply(doc, parseAspectRatio(this.attr('preserveAspectRatio'), width, height, image ? image.width : width, image ? image.height : height));
          if (!isClip) {
            doc.fillOpacity(this.get('opacity'));
            doc.image(image, 0, 0);
          } else {
            doc.rect(0, 0, image.width, image.height);
            docFillColor(DefaultColors.white).fill();
          }
          doc.restore();
        };
      };

      var SvgElemPattern = function(obj, inherits, fallback) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.ref = (function() {
          let ref = this.getUrl('href') || this.getUrl('xlink:href');
          if (ref && ref.nodeName === obj.nodeName) {
            return new SvgElemPattern(ref, inherits, fallback);
          }
        }).call(this);
        let _attr = this.attr;
        this.attr = function(key) {
          let attr = _attr.call(this, key);
          if (attr != null || key === 'href' || key === 'xlink:href') {return attr;}
          return this.ref ? this.ref.attr(key) : null;
        };
        let _getChildren = this.getChildren;
        this.getChildren = function() {
          let children = _getChildren.call(this);
          if (children.length > 0) {return children;}
          return this.ref ? this.ref.getChildren() : [];
        };
        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
          let bBoxUnitsPattern = (this.attr('patternUnits') !== 'userSpaceOnUse'),
              bBoxUnitsContent = (this.attr('patternContentUnits') === 'objectBoundingBox'),
              x = this.getLength('x', (bBoxUnitsPattern ? 1 : this.getParentVWidth()), 0),
              y = this.getLength('y', (bBoxUnitsPattern ? 1 : this.getParentVHeight()), 0),
              width = this.getLength('width', (bBoxUnitsPattern ? 1 : this.getParentVWidth()), 0),
              height = this.getLength('height', (bBoxUnitsPattern ? 1 : this.getParentVHeight()), 0);
          if (bBoxUnitsContent && !bBoxUnitsPattern) { // Use the same units for pattern & pattern content
            x = (x - bBox[0]) / (bBox[2] - bBox[0]) || 0;
            y = (y - bBox[1]) / (bBox[3] - bBox[1]) || 0;
            width = width / (bBox[2] - bBox[0]) || 0;
            height = height / (bBox[3] - bBox[1]) || 0;
          } else if (!bBoxUnitsContent && bBoxUnitsPattern) {
            x = bBox[0] + x * (bBox[2] - bBox[0]);
            y = bBox[1] + y * (bBox[3] - bBox[1]);
            width = width * (bBox[2] - bBox[0]);
            height = height * (bBox[3] - bBox[1]);
          }
          let viewBox = this.getViewbox('viewBox', [0, 0, width, height]),
              aspectRatio = (this.attr('preserveAspectRatio') || '').trim(),
              aspectRatioMatrix = multiplyMatrix(
                parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3], 0),
                [1, 0, 0, 1, -viewBox[0], -viewBox[1]]
              ),
              matrix = parseTranform(this.attr('patternTransform'));
          if (bBoxUnitsContent) {
            matrix = multiplyMatrix([bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]], matrix);
          }
          matrix = multiplyMatrix(matrix, [1, 0, 0, 1, x, y]);
          if ((matrix = validateMatrix(matrix)) && (aspectRatioMatrix = validateMatrix(aspectRatioMatrix)) && (width = validateNumber(width)) && (height = validateNumber(height))) {
            let group = docBeginGroup([0, 0, width, height]);
            doc.transform.apply(doc, aspectRatioMatrix);
            this.drawChildren(isClip, isMask);
            docEndGroup(group);
            return [docCreatePattern(group, width, height, matrix), gOpacity];
          } else {
            return fallback ? [fallback[0], fallback[1] * gOpacity] : undefined;
          }
        };
        this.getVWidth = function() {
          let bBoxUnitsPattern = (this.attr('patternUnits') !== 'userSpaceOnUse'),
              width = this.getLength('width', (bBoxUnitsPattern ? 1 : this.getParentVWidth()), 0);
          return this.getViewbox('viewBox', [0, 0, width, 0])[2];
        };
        this.getVHeight = function() {
          let bBoxUnitsPattern = (this.attr('patternUnits') !== 'userSpaceOnUse'),
              height = this.getLength('height', (bBoxUnitsPattern ? 1 : this.getParentVHeight()), 0);
          return this.getViewbox('viewBox', [0, 0, 0, height])[3];
        };
      };

      var SvgElemGradient = function(obj, inherits, fallback) {
        SvgElem.call(this, obj, inherits);
        this.allowedChildren = ['stop'];
        this.ref = (function() {
          let ref = this.getUrl('href') || this.getUrl('xlink:href');
          if (ref && ref.nodeName === obj.nodeName) {
            return new SvgElemGradient(ref, inherits, fallback);
          }
        }).call(this);
        let _attr = this.attr;
        this.attr = function(key) {
          let attr = _attr.call(this, key);
          if (attr != null || key === 'href' || key === 'xlink:href') {return attr;}
          return this.ref ? this.ref.attr(key) : null;
        };
        let _getChildren = this.getChildren;
        this.getChildren = function() {
          let children = _getChildren.call(this);
          if (children.length > 0) {return children;}
          return this.ref ? this.ref.getChildren() : [];
        };
        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
          let children = this.getChildren();
          if (children.length === 0) {return;}
          if (children.length === 1) {
            let child = children[0],
                stopColor = child.get('stop-color');
            if (stopColor === 'none') {return;}
            return opacityToColor(stopColor, child.get('stop-opacity') * gOpacity, isMask);
          }
          let bBoxUnits = (this.attr('gradientUnits') !== 'userSpaceOnUse'),
              matrix = parseTranform(this.attr('gradientTransform')),
              spread = this.attr('spreadMethod'),
              grad,
              x1, x2, y1, y2, r2,
              nAfter = 0,
              nBefore = 0,
              nTotal = 1;
          if (bBoxUnits) {
            matrix = multiplyMatrix([bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]], matrix);
          }
          if (matrix = validateMatrix(matrix)) {
            if (this.name === 'linearGradient') {
              x1 = this.getLength('x1', (bBoxUnits ? 1 : this.getVWidth()), 0);
              x2 = this.getLength('x2', (bBoxUnits ? 1 : this.getVWidth()), (bBoxUnits ? 1 : this.getVWidth()));
              y1 = this.getLength('y1', (bBoxUnits ? 1 : this.getVHeight()), 0);
              y2 = this.getLength('y2', (bBoxUnits ? 1 : this.getVHeight()), 0);
            } else {
              x2 = this.getLength('cx', (bBoxUnits ? 1 : this.getVWidth()), (bBoxUnits ? 0.5 : 0.5 * this.getVWidth()));
              y2 = this.getLength('cy', (bBoxUnits ? 1 : this.getVHeight()), (bBoxUnits ? 0.5 : 0.5 * this.getVHeight()));
              r2 = this.getLength('r', (bBoxUnits ? 1 : this.getViewport()), (bBoxUnits ? 0.5 : 0.5 * this.getViewport()));
              x1 = this.getLength('fx', (bBoxUnits ? 1 : this.getVWidth()), x2);
              y1 = this.getLength('fy', (bBoxUnits ? 1 : this.getVHeight()), y2);
              if (r2 < 0) {
                warningCallback('SvgElemGradient: negative r value');
              }
              let d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)),
                  multiplier = 1;
              if (d > r2) { // according to specification
                multiplier = r2 / d;
                x1 = x2 + (x1 - x2) * multiplier;
                y1 = y2 + (y1 - y2) * multiplier;
              }
              r2 = Math.max(r2, d * multiplier * (1 + 1e-6)); // fix for edge-case gradients see issue #84
            }
            if (spread === 'reflect' || spread === 'repeat') {
              let inv = inverseMatrix(matrix),
                  corner1 = transformPoint([bBox[0], bBox[1]], inv),
                  corner2 = transformPoint([bBox[2], bBox[1]], inv),
                  corner3 = transformPoint([bBox[2], bBox[3]], inv),
                  corner4 = transformPoint([bBox[0], bBox[3]], inv);
              if (this.name === 'linearGradient') { // See file 'gradient-repeat-maths.png'
                nAfter  = Math.max((corner1[0] - x2) * (x2 - x1) + (corner1[1] - y2) * (y2 - y1),
                                   (corner2[0] - x2) * (x2 - x1) + (corner2[1] - y2) * (y2 - y1),
                                   (corner3[0] - x2) * (x2 - x1) + (corner3[1] - y2) * (y2 - y1),
                                   (corner4[0] - x2) * (x2 - x1) + (corner4[1] - y2) * (y2 - y1))
                                  / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                nBefore = Math.max((corner1[0] - x1) * (x1 - x2) + (corner1[1] - y1) * (y1 - y2),
                                   (corner2[0] - x1) * (x1 - x2) + (corner2[1] - y1) * (y1 - y2),
                                   (corner3[0] - x1) * (x1 - x2) + (corner3[1] - y1) * (y1 - y2),
                                   (corner4[0] - x1) * (x1 - x2) + (corner4[1] - y1) * (y1 - y2))
                                  / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
              } else {
                nAfter  = Math.sqrt(Math.max(Math.pow(corner1[0] - x2, 2) + Math.pow(corner1[1] - y2, 2),
                                             Math.pow(corner2[0] - x2, 2) + Math.pow(corner2[1] - y2, 2),
                                             Math.pow(corner3[0] - x2, 2) + Math.pow(corner3[1] - y2, 2),
                                             Math.pow(corner4[0] - x2, 2) + Math.pow(corner4[1] - y2, 2))) / r2 - 1;
              }
              nAfter = Math.ceil(nAfter + 0.5); // Add a little more because the stroke can extend outside of the bounding box
              nBefore = Math.ceil(nBefore + 0.5);
              nTotal = nBefore + 1 + nAfter; // How many times the gradient needs to be repeated to fill the object bounding box
            }
            if (this.name === 'linearGradient') {
              grad = doc.linearGradient(x1 - nBefore * (x2 - x1), y1 - nBefore * (y2 - y1), x2 + nAfter * (x2 - x1), y2 + nAfter * (y2 - y1));
            } else {
              grad = doc.radialGradient(x1, y1, 0, x2, y2, r2 + nAfter * r2);
            }
            for (let n = 0; n < nTotal; n++) {
              let offset = 0,
                  inOrder = (spread !== 'reflect' || (n - nBefore) % 2 === 0);
              for (let i = 0; i < children.length; i++) {
                let child = children[inOrder ? i : children.length - 1 - i],
                    stopColor = child.get('stop-color');
                if (stopColor === 'none') {stopColor = DefaultColors.transparent;}
                stopColor = opacityToColor(stopColor, child.get('stop-opacity') * gOpacity, isMask);
                offset = Math.max(offset, inOrder ? child.getPercent('offset', 0) : 1 - child.getPercent('offset', 0));
                if (i === 0 && stopColor[0].length === 4) {grad._colorSpace = 'DeviceCMYK';} // Fix until PR #763 is merged into PDFKit
                if (i === 0 && offset > 0) {
                  grad.stop((n + 0) / nTotal, stopColor[0], stopColor[1]);
                }
                grad.stop((n + offset) / (nAfter + nBefore + 1), stopColor[0], stopColor[1]);
                if (i === children.length - 1 && offset < 1) {
                  grad.stop((n + 1) / nTotal, stopColor[0], stopColor[1]);
                }
              }
            }
            grad.setTransform.apply(grad, matrix);
            return [grad, 1];
          } else {
            return fallback ? [fallback[0], fallback[1] * gOpacity] : undefined;
          }
        }
      };

      var SvgElemBasicShape = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        this.dashScale = 1;
        this.getBoundingShape = function() {
          return this.shape;
        };
        this.getTransformation = function() {
          return this.get('transform');
        };
        this.drawInDocument = function(isClip, isMask) {
          if (this.get('visibility') === 'hidden' || !this.shape) {return;}
          doc.save();
          this.transform();
          this.clip();
          if (!isClip) {
            let masked = this.mask(),
                group;
            if (masked) {
              group = docBeginGroup(getPageBBox());
            }
            let subPaths = this.shape.getSubPaths(),
                fill = this.getFill(isClip, isMask),
                stroke = this.getStroke(isClip, isMask),
                lineWidth = this.get('stroke-width'),
                lineCap = this.get('stroke-linecap');
            if (fill || stroke) {
              if (fill) {
                docFillColor(fill);
              }
              if (stroke) {
                for (let j = 0; j < subPaths.length; j++) {
                  if (isEqual(subPaths[j].totalLength, 0)) {
                    if ((lineCap === 'square' || lineCap === 'round') && lineWidth > 0) {
                      if (subPaths[j].startPoint && subPaths[j].startPoint.length > 1) {
                        let x = subPaths[j].startPoint[0],
                            y = subPaths[j].startPoint[1];
                        docFillColor(stroke);
                        if (lineCap === 'square') {
                          doc.rect(x - 0.5 * lineWidth, y - 0.5 * lineWidth, lineWidth, lineWidth);
                        } else if (lineCap === 'round') {
                          doc.circle(x, y, 0.5 * lineWidth);
                        }
                        doc.fill();
                      }
                    }
                  }
                }
                let dashArray = this.get('stroke-dasharray'),
                    dashOffset = this.get('stroke-dashoffset');
                if (isNotEqual(this.dashScale, 1)) {
                  for (let j = 0; j < dashArray.length; j++) {
                    dashArray[j] *= this.dashScale;
                  }
                  dashOffset *= this.dashScale;
                }
                docStrokeColor(stroke);
                doc.lineWidth(lineWidth)
                   .miterLimit(this.get('stroke-miterlimit'))
                   .lineJoin(this.get('stroke-linejoin'))
                   .lineCap(lineCap)
                   .dash(dashArray, {phase: dashOffset});
              }
              for (let j = 0; j < subPaths.length; j++) {
                if (subPaths[j].totalLength > 0) {
                  subPaths[j].insertInDocument();
                }
              }
              if (fill && stroke) {
                doc.fillAndStroke(this.get('fill-rule'));
              } else if (fill) {
                doc.fill(this.get('fill-rule'));
              } else if (stroke) {
                doc.stroke();
              }
            }
            let markerStart = this.get('marker-start'),
                markerMid = this.get('marker-mid'),
                markerEnd = this.get('marker-end');
            if (markerStart !== 'none' || markerMid !== 'none' || markerEnd !== 'none') {
              let markersPos = this.shape.getMarkers();
              if (markerStart !== 'none') {
                let marker = new SvgElemMarker(markerStart, null);
                marker.drawMarker(false, isMask, markersPos[0], lineWidth);
              }
              if (markerMid !== 'none') {
                for (let i = 1; i < markersPos.length - 1; i++) {
                  let marker = new SvgElemMarker(markerMid, null);
                  marker.drawMarker(false, isMask, markersPos[i], lineWidth);
                }
              }
              if (markerEnd !== 'none') {
                let marker = new SvgElemMarker(markerEnd, null);
                marker.drawMarker(false, isMask, markersPos[markersPos.length - 1], lineWidth);
              }
            }
            if (group) {
              docEndGroup(group);
              docInsertGroup(group);
            }
          } else {
            this.shape.insertInDocument();
            docFillColor(DefaultColors.white);
            doc.fill(this.get('clip-rule'));
          }
          doc.restore();
        };
      };

      var SvgElemRect = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let x = this.getLength('x', this.getVWidth(), 0),
            y = this.getLength('y', this.getVHeight(), 0),
            w = this.getLength('width', this.getVWidth(), 0),
            h = this.getLength('height', this.getVHeight(), 0),
            rx = this.getLength('rx', this.getVWidth()),
            ry = this.getLength('ry', this.getVHeight());
        if (rx === undefined && ry === undefined) {rx = ry = 0;}
        else if (rx === undefined && ry !== undefined) {rx = ry;}
        else if (rx !== undefined && ry === undefined) {ry = rx;}
        if (w > 0 && h > 0) {
          if (rx && ry) {
            rx = Math.min(rx, 0.5 * w);
            ry = Math.min(ry, 0.5 * h);
            this.shape = new SvgShape().M(x + rx, y).L(x + w - rx, y).A(rx, ry, 0, 0, 1, x + w, y + ry)
                              .L(x + w, y + h - ry).A(rx, ry, 0, 0, 1, x + w - rx, y + h).L(x + rx, y + h)
                              .A(rx, ry, 0, 0, 1, x, y + h - ry).L(x, y + ry).A(rx, ry, 0, 0, 1, x + rx, y).Z();
          } else {
            this.shape = new SvgShape().M(x, y).L(x + w, y).L(x + w, y + h).L(x, y + h).Z();
          }
        } else {
          this.shape = new SvgShape();
        }
      };

      var SvgElemCircle = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let cx = this.getLength('cx', this.getVWidth(), 0),
            cy = this.getLength('cy', this.getVHeight(), 0),
            r = this.getLength('r', this.getViewport(), 0);
        if (r > 0) {
          this.shape = new SvgShape().M(cx + r, cy).A(r, r, 0, 0, 1, cx - r, cy).A(r, r, 0, 0, 1, cx + r, cy).Z();
        } else {
          this.shape = new SvgShape();
        }
      };

      var SvgElemEllipse = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let cx = this.getLength('cx', this.getVWidth(), 0),
            cy = this.getLength('cy', this.getVHeight(), 0),
            rx = this.getLength('rx', this.getVWidth(), 0),
            ry = this.getLength('ry', this.getVHeight(), 0);
        if (rx > 0 && ry > 0) {
          this.shape = new SvgShape().M(cx + rx, cy).A(rx, ry, 0, 0, 1, cx - rx, cy).A(rx, ry, 0, 0, 1, cx + rx, cy).Z();
        } else {
          this.shape = new SvgShape();
        }
      };

      var SvgElemLine = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let x1 = this.getLength('x1', this.getVWidth(), 0),
            y1 = this.getLength('y1', this.getVHeight(), 0),
            x2 = this.getLength('x2', this.getVWidth(), 0),
            y2 = this.getLength('y2', this.getVHeight(), 0);
        this.shape = new SvgShape().M(x1, y1).L(x2, y2);
      };

      var SvgElemPolyline = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let points = this.getNumberList('points');
        this.shape = new SvgShape();
        for (let i = 0; i < points.length - 1; i += 2) {
          if (i === 0) {
            this.shape.M(points[i], points[i+1]);
          } else {
            this.shape.L(points[i], points[i+1]);
          }
        }
        if (points.error) {warningCallback('SvgElemPolygon: unexpected string ' + points.error);}
        if (points.length % 2 === 1) {warningCallback('SvgElemPolyline: uneven number of coordinates');}
      };

      var SvgElemPolygon = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let points = this.getNumberList('points');
        this.shape = new SvgShape();
        for (let i = 0; i < points.length - 1; i += 2) {
          if (i === 0) {
            this.shape.M(points[i], points[i+1]);
          } else {
            this.shape.L(points[i], points[i+1]);
          }
        }
        this.shape.Z();
        if (points.error) {warningCallback('SvgElemPolygon: unexpected string ' + points.error);}
        if (points.length % 2 === 1) {warningCallback('SvgElemPolygon: uneven number of coordinates');}
      };

      var SvgElemPath = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        this.shape = new SvgShape().path(this.attr('d'));
        let pathLength = this.getLength('pathLength', this.getViewport());
        this.pathLength = pathLength > 0 ? pathLength : undefined;
        this.dashScale = (this.pathLength !== undefined ? this.shape.totalLength / this.pathLength : 1);
      };

      var SvgElemMarker = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        let width = this.getLength('markerWidth', this.getParentVWidth(), 3),
            height = this.getLength('markerHeight', this.getParentVHeight(), 3),
            viewBox = this.getViewbox('viewBox', [0, 0, width, height]);
        this.getVWidth = function() {
          return viewBox[2];
        };
        this.getVHeight = function() {
          return viewBox[3];
        };
        this.drawMarker = function(isClip, isMask, posArray, strokeWidth) {
          doc.save();
          let orient = this.attr('orient'),
              units = this.attr('markerUnits'),
              rotate = (orient === 'auto' ? posArray[2] : (parseFloat(orient) || 0) * Math.PI / 180),
              scale = (units === 'userSpaceOnUse' ? 1 : strokeWidth);
          doc.transform(Math.cos(rotate) * scale, Math.sin(rotate) * scale, -Math.sin(rotate) * scale, Math.cos(rotate) * scale, posArray[0], posArray[1]);
          let refX = this.getLength('refX', this.getVWidth(), 0),
              refY = this.getLength('refY', this.getVHeight(), 0),
              aspectRatioMatrix = parseAspectRatio(this.attr('preserveAspectRatio'), width, height, viewBox[2], viewBox[3], 0.5);
          if (this.get('overflow') === 'hidden') {
            doc.rect(aspectRatioMatrix[0] * (viewBox[0] + viewBox[2] / 2 - refX) - width / 2, aspectRatioMatrix[3] * (viewBox[1] + viewBox[3] / 2 - refY) - height / 2, width, height).clip();
          }
          doc.transform.apply(doc, aspectRatioMatrix);
          doc.translate(-refX, -refY);
          let group;
          if (this.get('opacity') < 1 && !isClip) {
            group = docBeginGroup(getPageBBox());
          }
          this.drawChildren(isClip, isMask);
          if (group) {
            docEndGroup(group);
            doc.fillOpacity(this.get('opacity'));
            docInsertGroup(group);
          }
          doc.restore();
        };
      };

      var SvgElemClipPath = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.useMask = function(bBox) {
          let group = docBeginGroup(getPageBBox());
          doc.save();
          if (this.attr('clipPathUnits') === 'objectBoundingBox') {
            doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
          }
          this.clip();
          this.drawChildren(true, false);
          doc.restore();
          docEndGroup(group);
          docApplyMask(group, true);
        };
      };

      var SvgElemMask = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.useMask = function(bBox) {
          let group = docBeginGroup(getPageBBox());
          doc.save();
          let x, y, w, h;
          if (this.attr('maskUnits') === 'userSpaceOnUse') {
            x = this.getLength('x', this.getVWidth(), -0.1 * (bBox[2] - bBox[0]) + bBox[0]);
            y = this.getLength('y', this.getVHeight(), -0.1 * (bBox[3] - bBox[1]) + bBox[1]);
            w = this.getLength('width', this.getVWidth(), 1.2 * (bBox[2] - bBox[0]));
            h = this.getLength('height', this.getVHeight(), 1.2 * (bBox[3] - bBox[1]));
          } else {
            x = this.getLength('x', this.getVWidth(), -0.1) * (bBox[2] - bBox[0]) + bBox[0];
            y = this.getLength('y', this.getVHeight(), -0.1) * (bBox[3] - bBox[1]) + bBox[1];
            w = this.getLength('width', this.getVWidth(), 1.2) * (bBox[2] - bBox[0]);
            h = this.getLength('height', this.getVHeight(), 1.2) * (bBox[3] - bBox[1]);
          }
          doc.rect(x, y, w, h).clip();
          if (this.attr('maskContentUnits') === 'objectBoundingBox') {
            doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
          }
          this.clip();
          this.drawChildren(false, true);
          doc.restore();
          docEndGroup(group);
          docApplyMask(group, true);
        };
      };

      var SvgElemTextContainer = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        this.allowedChildren = ['tspan', '#text', '#cdata-section', 'a'];
        this.isText = true;
        this.getBoundingShape = function() {
          let shape = new SvgShape();
          for (let i = 0; i < this._pos.length; i++) {
            let pos = this._pos[i];
            if (!pos.hidden) {
              let dx0 = pos.ascent * Math.sin(pos.rotate), dy0 = -pos.ascent * Math.cos(pos.rotate),
                  dx1 = pos.descent * Math.sin(pos.rotate), dy1 = -pos.descent * Math.cos(pos.rotate),
                  dx2 = pos.width * Math.cos(pos.rotate), dy2 = pos.width * Math.sin(pos.rotate);
              shape.M(pos.x + dx0, pos.y + dy0).L(pos.x + dx0 + dx2, pos.y + dy0 + dy2)
                   .M(pos.x + dx1 + dx2, pos.y + dy1 + dy2).L(pos.x + dx1, pos.y + dy1);
            }
          }
          return shape;
        };
        this.drawTextInDocument = function(isClip, isMask) {
          if (this.link && !isClip && !isMask) {this.addLink();}
          if (this.get('text-decoration') === 'underline') {
            this.decorate(0.05 * this._font.size, -0.075 * this._font.size, isClip, isMask);
          }
          if (this.get('text-decoration') === 'overline') {
            this.decorate(0.05 * this._font.size, getAscent(this._font.font, this._font.size) + 0.075 * this._font.size, isClip, isMask);
          }
          let fill = this.getFill(isClip, isMask),
              stroke = this.getStroke(isClip, isMask),
              strokeWidth = this.get('stroke-width');
          if (this._font.fauxBold) {
            if (!stroke) {
              stroke = fill;
              strokeWidth = this._font.size * 0.03;
            } else {
              strokeWidth += this._font.size * 0.03;
            }
          }
          let children = this.getChildren();
          for (let i = 0; i < children.length; i++) {
            let childElem = children[i];
            switch(childElem.name) {
              case 'tspan': case 'textPath': case 'a':
                if (childElem.get('display') !== 'none') {
                  childElem.drawTextInDocument(isClip, isMask);
                }
                break;
              case '#text': case '#cdata-section':
                if (this.get('visibility') === 'hidden') {continue;}
                if (fill || stroke || isClip) {
                  if (fill) {
                    docFillColor(fill);
                  }
                  if (stroke && strokeWidth) {
                    docStrokeColor(stroke);
                    doc.lineWidth(strokeWidth)
                       .miterLimit(this.get('stroke-miterlimit'))
                       .lineJoin(this.get('stroke-linejoin'))
                       .lineCap(this.get('stroke-linecap'))
                       .dash(this.get('stroke-dasharray'), {phase:this.get('stroke-dashoffset')});
                  }
                  docBeginText(this._font.font, this._font.size);
                  docSetTextMode(!!fill, !!stroke);
                  for (let j = 0, pos = childElem._pos; j < pos.length; j++) {
                    if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                      let cos = Math.cos(pos[j].rotate), sin = Math.sin(pos[j].rotate), skew = (this._font.fauxItalic ? -0.25 : 0);
                      docSetTextMatrix(cos * pos[j].scale, sin * pos[j].scale, cos * skew - sin, sin * skew + cos, pos[j].x, pos[j].y);
                      docWriteGlyph(pos[j].glyph);
                    }
                  }
                  docEndText();
                }
                break;
            }
          }
          if (this.get('text-decoration') === 'line-through') {
            this.decorate(0.05 * this._font.size, 0.5 * (getAscent(this._font.font, this._font.size) + getDescent(this._font.font, this._font.size)), isClip, isMask);
          }
        };
        this.decorate = function(lineWidth, linePosition, isClip, isMask) {
          let fill = this.getFill(isClip, isMask),
              stroke = this.getStroke(isClip, isMask);
          if (fill) {
            docFillColor(fill);
          }
          if (stroke) {
            docStrokeColor(stroke);
            doc.lineWidth(this.get('stroke-width'))
               .miterLimit(this.get('stroke-miterlimit'))
               .lineJoin(this.get('stroke-linejoin'))
               .lineCap(this.get('stroke-linecap'))
               .dash(this.get('stroke-dasharray'), {phase:this.get('stroke-dashoffset')});
          }
          for (let j = 0, pos = this._pos; j < pos.length; j++) {
            if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
              let dx0 = (linePosition + lineWidth / 2) * Math.sin(pos[j].rotate),
                  dy0 = -(linePosition + lineWidth / 2) * Math.cos(pos[j].rotate),
                  dx1 = (linePosition - lineWidth / 2) * Math.sin(pos[j].rotate),
                  dy1 = -(linePosition - lineWidth / 2) * Math.cos(pos[j].rotate),
                  dx2 = pos[j].width * Math.cos(pos[j].rotate),
                  dy2 = pos[j].width * Math.sin(pos[j].rotate);
              new SvgShape().M(pos[j].x + dx0, pos[j].y + dy0)
                            .L(pos[j].x + dx0 + dx2, pos[j].y + dy0 + dy2)
                            .L(pos[j].x + dx1 + dx2, pos[j].y + dy1 + dy2)
                            .L(pos[j].x + dx1, pos[j].y + dy1).Z()
                            .insertInDocument();
              if (fill && stroke) {
                doc.fillAndStroke();
              } else if (fill) {
                doc.fill();
              } else if (stroke) {
                doc.stroke();
              }
            }
          }
        };
      };

      var SvgElemTextNode = function(obj, inherits) {
        this.name = obj.nodeName;
        this.textContent = obj.nodeValue;
      };

      var SvgElemTspan = function(obj, inherits) {
        SvgElemTextContainer.call(this, obj, inherits);
      };

      var SvgElemTextPath = function(obj, inherits) {
        SvgElemTextContainer.call(this, obj, inherits);
        let pathObject, pathLength, temp;
        if ((temp = this.attr('path')) && temp.trim() !== '') {
          let pathLength = this.getLength('pathLength', this.getViewport());
          this.pathObject = new SvgShape().path(temp);
          this.pathLength = pathLength > 0 ? pathLength : this.pathObject.totalLength;
          this.pathScale = this.pathObject.totalLength / this.pathLength;
        } else if ((temp = this.getUrl('href') || this.getUrl('xlink:href')) && temp.nodeName === 'path') {
          let pathElem = new SvgElemPath(temp, this);
          this.pathObject = pathElem.shape.clone().transform(pathElem.get('transform'));
          this.pathLength = this.chooseValue(pathElem.pathLength, this.pathObject.totalLength);
          this.pathScale = this.pathObject.totalLength / this.pathLength;
        }
      };

      var SvgElemText = function(obj, inherits) {
        SvgElemTextContainer.call(this, obj, inherits);
        this.allowedChildren = ['textPath', 'tspan', '#text', '#cdata-section', 'a'];
        (function (textParentElem) {
          let processedText = '', remainingText = obj.textContent, textPaths = [], currentChunk = [], currentAnchor, currentDirection, currentX = 0, currentY = 0;
          function doAnchoring() {
            if (currentChunk.length) {
              let last = currentChunk[currentChunk.length - 1];
              let first = currentChunk[0]
              let width = last.x + last.width - first.x;
              let anchordx = {'startltr': 0, 'middleltr': 0.5, 'endltr': 1, 'startrtl': 1, 'middlertl': 0.5, 'endrtl': 0}[currentAnchor + currentDirection] * width || 0;
              for (let i = 0; i < currentChunk.length; i++) {
                currentChunk[i].x -= anchordx;
              }
            }
            currentChunk = [];
          }
          function adjustLength(pos, length, spacingAndGlyphs) {
            let firstChar = pos[0], lastChar = pos[pos.length - 1],
                startX = firstChar.x, endX = lastChar.x + lastChar.width;
            if (spacingAndGlyphs) {
              let textScale = length / (endX - startX);
              if (textScale > 0 && textScale < Infinity) {
                for (let j = 0; j < pos.length; j++) {
                  pos[j].x = startX + textScale * (pos[j].x - startX);
                  pos[j].scale *= textScale;
                  pos[j].width *= textScale;
                }
              }
            } else {
              if (pos.length >= 2) {
                let spaceDiff = (length - (endX - startX)) / (pos.length - 1);
                for (let j = 0; j < pos.length; j++) {
                  pos[j].x += j * spaceDiff;
                }
              }
            }
            currentX += length - (endX - startX);
          }
          function recursive(currentElem, parentElem) {
            currentElem._x = combineArrays(currentElem.getLengthList('x', currentElem.getVWidth()), (parentElem ? parentElem._x.slice(parentElem._pos.length) : []));
            currentElem._y = combineArrays(currentElem.getLengthList('y', currentElem.getVHeight()), (parentElem ? parentElem._y.slice(parentElem._pos.length) : []));
            currentElem._dx = combineArrays(currentElem.getLengthList('dx', currentElem.getVWidth()), (parentElem ? parentElem._dx.slice(parentElem._pos.length) : []));
            currentElem._dy = combineArrays(currentElem.getLengthList('dy', currentElem.getVHeight()), (parentElem ? parentElem._dy.slice(parentElem._pos.length) : []));
            currentElem._rot = combineArrays(currentElem.getNumberList('rotate'), (parentElem ? parentElem._rot.slice(parentElem._pos.length) : []));
            currentElem._defRot = currentElem.chooseValue(currentElem._rot[currentElem._rot.length - 1], parentElem && parentElem._defRot, 0);
            if (currentElem.name === 'textPath') {currentElem._y = [];}
            let fontOptions = {fauxItalic: false, fauxBold: false},
                fontNameorLink = fontCallback(currentElem.get('font-family'), currentElem.get('font-weight') === 'bold', currentElem.get('font-style') === 'italic', fontOptions);
            try {
              doc.font(fontNameorLink);
            } catch(e) {
              warningCallback('SVGElemText: failed to open font "' + fontNameorLink + '" in PDFKit');
            }
            currentElem._pos = [];
            currentElem._index = 0;
            currentElem._font = {font: doc._font, size: currentElem.get('font-size'), fauxItalic: fontOptions.fauxItalic, fauxBold: fontOptions.fauxBold};
            let textLength = currentElem.getLength('textLength', currentElem.getVWidth(), undefined),
                spacingAndGlyphs = currentElem.attr('lengthAdjust') === 'spacingAndGlyphs',
                wordSpacing = currentElem.get('word-spacing'),
                letterSpacing = currentElem.get('letter-spacing'),
                textAnchor = currentElem.get('text-anchor'),
                textDirection = currentElem.get('direction'),
                baseline = getBaseline(currentElem._font.font, currentElem._font.size, currentElem.get('alignment-baseline') || currentElem.get('dominant-baseline'), currentElem.get('baseline-shift'));
            if (currentElem.name === 'textPath') {
              doAnchoring();
              currentX = currentY = 0;
            }
            let children = currentElem.getChildren();
            for (let i = 0; i < children.length; i++) {
              let childElem = children[i];
              switch(childElem.name) {
                case 'tspan': case 'textPath': case 'a':
                  recursive(childElem, currentElem);
                  break;
                case '#text': case '#cdata-section':
                  let rawText = childElem.textContent, renderedText = rawText, words;
                  childElem._font = currentElem._font;
                  childElem._pos = [];
                  remainingText = remainingText.substring(rawText.length);
                  if (currentElem.get('xml:space') === 'preserve') {
                    renderedText = renderedText.replace(/[\s]/g, ' ');
                  } else {
                    renderedText = renderedText.replace(/[\s]+/g, ' ');
                    if (processedText.match(/[\s]$|^$/)) {renderedText = renderedText.replace(/^[\s]/, '');}
                    if (remainingText.match(/^[\s]*$/)) {renderedText = renderedText.replace(/[\s]$/, '');}
                  }
                  processedText += rawText;
                  if (wordSpacing === 0) {
                    words = [renderedText];
                  } else {
                    words = renderedText.split(/(\s)/);
                  }
                  for (let w = 0; w < words.length; w++) {
                    let pos = getTextPos(currentElem._font.font, currentElem._font.size, words[w]);
                    for (let j = 0; j < pos.length; j++) {
                      let index = currentElem._index,
                          xAttr = currentElem._x[index],
                          yAttr = currentElem._y[index],
                          dxAttr = currentElem._dx[index],
                          dyAttr = currentElem._dy[index],
                          rotAttr = currentElem._rot[index],
                          continuous = !(w === 0 && j === 0);
                      if (xAttr !== undefined) {continuous = false; doAnchoring(); currentX = xAttr;}
                      if (yAttr !== undefined) {continuous = false; doAnchoring(); currentY = yAttr;}
                      if (dxAttr !== undefined) {continuous = false; currentX += dxAttr;}
                      if (dyAttr !== undefined) {continuous = false; currentY += dyAttr;}
                      if (rotAttr !== undefined || currentElem._defRot !== 0) {continuous = false;}
                      let position = {
                        glyph: pos[j].glyph,
                        rotate: (Math.PI / 180) * currentElem.chooseValue(rotAttr, currentElem._defRot),
                        x: currentX + pos[j].xOffset,
                        y: currentY + baseline + pos[j].yOffset,
                        width: pos[j].width,
                        ascent: getAscent(currentElem._font.font, currentElem._font.size),
                        descent: getDescent(currentElem._font.font, currentElem._font.size),
                        scale: 1,
                        hidden: false,
                        continuous: continuous
                      };
                      currentChunk.push(position);
                      childElem._pos.push(position);
                      currentElem._pos.push(position);
                      currentElem._index += pos[j].unicode.length;
                      if (currentChunk.length === 1) {
                        currentAnchor = textAnchor;
                        currentDirection = textDirection;
                      }
                      currentX += pos[j].xAdvance + letterSpacing;
                      currentY += pos[j].yAdvance;
                    }
                    if (words[w] === ' ') {
                      currentX += wordSpacing;
                    }
                  }
                  break;
                default:
                  remainingText = remainingText.substring(childElem.textContent.length);
              }
            }
            if (textLength && currentElem._pos.length) {
              adjustLength(currentElem._pos, textLength, spacingAndGlyphs);
            }
            if (currentElem.name === 'textPath' || currentElem.name === 'text') {
              doAnchoring();
            }
            if (currentElem.name === 'textPath') {
              textPaths.push(currentElem);
              let pathObject = currentElem.pathObject;
              if (pathObject) {
                currentX = pathObject.endPoint[0]; currentY = pathObject.endPoint[1];
              }
            }
            if (parentElem) {
              parentElem._pos = parentElem._pos.concat(currentElem._pos);
              parentElem._index += currentElem._index;
            }
          }
          function textOnPath(currentElem) {
            let pathObject = currentElem.pathObject,
                pathLength = currentElem.pathLength,
                pathScale = currentElem.pathScale;
            if (pathObject) {
              let textOffset = currentElem.getLength('startOffset', pathLength, 0);
              for (let j = 0; j < currentElem._pos.length; j++) {
                let charMidX = textOffset + currentElem._pos[j].x + 0.5 * currentElem._pos[j].width;
                if (charMidX > pathLength || charMidX < 0) {
                  currentElem._pos[j].hidden = true;
                } else {
                  let pointOnPath = pathObject.getPointAtLength(charMidX * pathScale);
                  if (isNotEqual(pathScale, 1)) {
                    currentElem._pos[j].scale *= pathScale;
                    currentElem._pos[j].width *= pathScale;
                  }
                  currentElem._pos[j].x = pointOnPath[0] - 0.5 * currentElem._pos[j].width * Math.cos(pointOnPath[2]) - currentElem._pos[j].y * Math.sin(pointOnPath[2]);
                  currentElem._pos[j].y = pointOnPath[1] - 0.5 * currentElem._pos[j].width * Math.sin(pointOnPath[2]) + currentElem._pos[j].y * Math.cos(pointOnPath[2]);
                  currentElem._pos[j].rotate = pointOnPath[2] + currentElem._pos[j].rotate;
                  currentElem._pos[j].continuous = false;
                }
              }
            } else {
              for (let j = 0; j < currentElem._pos.length; j++) {
                currentElem._pos[j].hidden = true;
              }
            }
          }
          recursive(textParentElem, null);
          for (let i = 0; i < textPaths.length; i++) {
            textOnPath(textPaths[i]);
          }
        })(this);
        this.getTransformation = function() {
          return this.get('transform');
        };
        this.drawInDocument = function(isClip, isMask) {
          doc.save();
          this.transform();
          this.clip();
          let masked = this.mask(), group;
          if (masked) {
            group = docBeginGroup(getPageBBox());
          }
          this.drawTextInDocument(isClip, isMask);
          if (group) {
            docEndGroup(group);
            docInsertGroup(group);
          }
          doc.restore();
        };
      };

      options = options || {};
      var pxToPt = options.assumePt ? 1 : (72/96), // 1px = 72/96pt, but only if assumePt is false
          viewportWidth = (options.width || doc.page.width) / pxToPt,
          viewportHeight = (options.height || doc.page.height) / pxToPt,
          preserveAspectRatio = options.preserveAspectRatio || null, // default to null so that the attr can override if not passed
          useCSS = options.useCSS && typeof SVGElement !== 'undefined' && svg instanceof SVGElement && typeof getComputedStyle === 'function',
          warningCallback = options.warningCallback,
          fontCallback = options.fontCallback,
          imageCallback = options.imageCallback,
          colorCallback = options.colorCallback,
          documentCallback = options.documentCallback,
          precision = Math.ceil(Math.max(1, options.precision)) || 3,
          groupStack = [],
          documentCache = {},
          links = [],
          styleRules = [];

      if (typeof warningCallback !== 'function') {
        warningCallback = function(str) {
          if (typeof console !== undefined && typeof console.warn === 'function') {console.warn(str);}
        };
      }
      if (typeof fontCallback !== 'function') {
        fontCallback = function(family, bold, italic, fontOptions) {
          // Check if the font is already registered in the document
          if (bold && italic) {
            if (doc._registeredFonts.hasOwnProperty(family + '-BoldItalic')) {
              return family + '-BoldItalic';
            } else if (doc._registeredFonts.hasOwnProperty(family + '-Italic')) {
              fontOptions.fauxBold = true;
              return family + '-Italic';
            } else if (doc._registeredFonts.hasOwnProperty(family + '-Bold')) {
              fontOptions.fauxItalic = true;
              return family + '-Bold';
            } else if (doc._registeredFonts.hasOwnProperty(family)) {
              fontOptions.fauxBold = true;
              fontOptions.fauxItalic = true;
              return family;
            }
          }
          if (bold && !italic) {
            if (doc._registeredFonts.hasOwnProperty(family + '-Bold')) {
              return family + '-Bold';
            } else if (doc._registeredFonts.hasOwnProperty(family)) {
              fontOptions.fauxBold = true;
              return family;
            }
          }
          if (!bold && italic) {
            if (doc._registeredFonts.hasOwnProperty(family + '-Italic')) {
              return family + '-Italic';
            } else if (doc._registeredFonts.hasOwnProperty(family)) {
              fontOptions.fauxItalic = true;
              return family;
            }
          }
          if (!bold && !italic) {
            if (doc._registeredFonts.hasOwnProperty(family)) {
              return family;
            }
          }
          // Use standard fonts as fallback
          if (family.match(/(?:^|,)\s*serif\s*$/)) {
            if (bold && italic) {return 'Times-BoldItalic';}
            if (bold && !italic) {return 'Times-Bold';}
            if (!bold && italic) {return 'Times-Italic';}
            if (!bold && !italic) {return 'Times-Roman';}
          } else if (family.match(/(?:^|,)\s*monospace\s*$/)) {
            if (bold && italic) {return 'Courier-BoldOblique';}
            if (bold && !italic) {return 'Courier-Bold';}
            if (!bold && italic) {return 'Courier-Oblique';}
            if (!bold && !italic) {return 'Courier';}
          } else if (family.match(/(?:^|,)\s*sans-serif\s*$/) || true) {
            if (bold && italic) {return 'Helvetica-BoldOblique';}
            if (bold && !italic) {return 'Helvetica-Bold';}
            if (!bold && italic) {return 'Helvetica-Oblique';}
            if (!bold && !italic) {return 'Helvetica';}
          }
        };
      }
      if (typeof imageCallback !== 'function') {
        imageCallback = function(link) {
          return link.replace(/\s+/g, '');
        };
      }
      if (typeof colorCallback !== 'function') {
        colorCallback = null;
      } else {
        for (let color in DefaultColors) {
          let newColor = colorCallback(DefaultColors[color]);
          DefaultColors[color][0] = newColor[0];
          DefaultColors[color][1] = newColor[1];
        }
      }
      if (typeof documentCallback !== 'function') {
        documentCallback = null;
      }

      if (typeof svg === 'string') {svg = parseXml(svg);}
      if (svg) {
        let styles = svg.getElementsByTagName('style');
        for (let i = 0; i < styles.length; i++) {
          styleRules = styleRules.concat(parseStyleSheet(styles[i].textContent));
        }
        let elem = createSVGElement(svg, null);
        if (typeof elem.drawInDocument === 'function') {
          if (options.useCSS && !useCSS) {
            warningCallback('SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers');
          }
          let savedFillColor = doc._fillColor;
          doc.save().translate(x || 0, y || 0).scale(pxToPt);
          elem.drawInDocument();
          for (let i = 0; i < links.length; i++) {
            doc.page.annotations.push(links[i]);
          }
          doc.restore();
          doc._fillColor = savedFillColor;
        } else {
          warningCallback('SVGtoPDF: this element can\'t be rendered directly: ' + svg.nodeName);
        }
      } else {
        warningCallback('SVGtoPDF: the input does not look like a valid SVG');
      }

  };

  if (typeof module !== 'undefined' && module && typeof module.exports !== 'undefined') {
    module.exports = SVGtoPDF;
  }

  },{}]},{},[1]);
});